webpackJsonp([2],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(32);



var NavBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = (NavBus);

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(551)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(687),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(542)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(402),
  /* template */
  __webpack_require__(678),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(501)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(403),
  /* template */
  __webpack_require__(637),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cuelistBLACK.1ac73ee.png";

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(511)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(407),
  /* template */
  __webpack_require__(647),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuexfire__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuexfire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuexfire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(388);














__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* default */]);

var QListStore = new __WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* default */].Store({
    namespaced: true,
    state: {
        projects: [],
        activeProject: {
            cues: [],
            layers: [],
            collaborators: [],
            notes: []
        },
        activeVersion: null,
        users: [],
        activeUser: {
            uid: null,
            profile_picture: '',
            username: '',
            active_pay: false,
            subscription_level: 0,
            signInMethod: '',
            currentProject: null,
            projects: {}
        },
        showMode: false
    },
    getters: {
        projects: function projects(state) {
            return state.projects;
        },
        mostRecentProject: function mostRecentProject(state, getters) {
            return getters.userProjects.length > 0 ? getters.userProjects[0] : null;
        },
        userProjects: function userProjects(state, getters) {
            var uid = getters.user['.key'];
            return state.projects.filter(function (proj) {
                if (proj.ownerUID === uid) return true;

                var isCollab = false;
                if (proj.collaborators) {
                    var collabs = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(proj.collaborators);
                    isCollab = collabs.includes(uid);
                }

                return isCollab;
            }).sort(function (a, b) {
                var timeA = new Date(a.lastChangedDate);
                var timeB = new Date(b.lastChangedDate);
                return timeB - timeA;
            });
        },
        userPendingInvites: function userPendingInvites(state, getters) {
            return state.projects.filter(function (proj) {
                if (proj.pendingCollaborators) {
                    var index = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(proj.pendingCollaborators).findIndex(function (pc) {
                        return pc.email === getters.user.email;
                    });

                    return index > -1;
                }

                return false;
            });
        },
        projectFromID: function projectFromID(state, getters) {
            return function (id) {
                var projIndex = getters.projects.findIndex(function (proj) {
                    return proj.id === id;
                });

                if (projIndex > -1) {
                    return getters.projects[projIndex];
                }

                return null;
            };
        },

        users: function users(state) {
            return state.users;
        },
        user: function user(state) {
            return state.activeUser;
        },
        userByUID: function userByUID(state, getters) {
            return function (uid) {
                var userIndex = getters.users.findIndex(function (user) {
                    return user['.key'] === uid;
                });
                if (userIndex > -1) {
                    return getters.users[userIndex];
                }
                return null;
            };
        },
        userProjectData: function userProjectData(state, getters) {
            try {
                var currentUser = getters.user;
                var currentProject = getters.project;

                if (currentUser && currentProject) {
                    if (currentUser.projects) {
                        return currentUser.projects[currentProject.id];
                    }
                }
            } catch (e) {
                console.error(e);
            }
            return {};
        },

        project: function project(state) {
            return state.activeProject;
        },
        projectPath: function projectPath(state, getters) {
            if (getters.currentVersion) {
                return '/projects/' + getters.project.id + '/versions/' + getters.currentVersion.id;
            }

            return '/projects/' + getters.project.id;
        },
        documentUrl: function documentUrl(state) {
            return state.activeProject.documentUrl;
        },
        ownerUID: function ownerUID(state) {
            return state.activeProject.ownerUID || null;
        },

        versions: function versions(state, getters) {
            var versions = getters.project.versions || [];
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(versions);
        },
        versionByID: function versionByID(state, getters) {
            return function (id) {
                var vFilter = getters.versions.filter(function (v) {
                    return v.id === id;
                });
                if (vFilter.length > 0) {
                    return vFilter[0];
                }

                return null;
            };
        },
        currentVersion: function currentVersion(state, getters) {
            if (state.activeVersion) {
                return getters.versionByID(state.activeVersion);
            }

            return null;
        },
        isLocked: function isLocked(state, getters) {
            if (getters.currentVersion) {
                return getters.currentVersion.locked || false;
            }
            return getters.project.locked || false;
        },

        cues: function cues(state, getters) {
            var cues = getters.project.cues || [];
            var version = getters.currentVersion;
            if (version) {
                cues = version.cues || [];
            }
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(cues);
        },
        cuesByPage: function cuesByPage(state, getters) {
            return function (pageNumber) {
                return getters.cues.filter(function (cue) {
                    return cue.pageNumber === pageNumber;
                });
            };
        },
        visibleCues: function visibleCues(state, getters) {
            return function (pageNumber) {
                var layerIDs = getters.visibleLayerIDs;
                return getters.cuesByPage(pageNumber).filter(function (cue) {
                    return layerIDs.includes(cue.layer);
                });
            };
        },
        cuesPerLayer: function cuesPerLayer(state, getters) {
            return function (layerID) {
                return getters.cues.filter(function (cue) {
                    return cue.layer === layerID;
                });
            };
        },

        layers: function layers(state, getters) {
            var layers = getters.project.layers || [];
            var version = getters.currentVersion;
            if (version) {
                layers = version.layers || [];
            }
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(layers);
        },
        layerByID: function layerByID(state, getters) {
            return function (id) {
                try {
                    var filter = getters.layers.filter(function (layer) {
                        return layer.id === id;
                    });
                    if (filter.length > 0) return filter[0];
                } catch (e) {
                    console.error(e);
                }

                return null;
            };
        },
        layerByCue: function layerByCue(state, getters) {
            return function (cue) {
                return getters.layerByID(cue.layer);
            };
        },
        visibleLayers: function visibleLayers(state, getters) {
            try {
                var userProjectData = getters.userProjectData;
                if (userProjectData && userProjectData.layers && userProjectData.layers.viewing) {
                    return userProjectData.layers.viewing.reduce(function (result, id) {
                        var layer = getters.layerByID(id);
                        if (layer) result.push(layer);

                        return result;
                    }, []);
                }
            } catch (e) {
                console.error(e);
            }
            return [];
        },
        visibleLayerIDs: function visibleLayerIDs(state, getters) {
            var layers = getters.visibleLayers || [];
            return layers.map(function (layer) {
                return layer.id;
            });
        },
        showNotesLayers: function showNotesLayers(state, getters) {
            try {
                var userProjectData = getters.userProjectData;
                if (userProjectData && userProjectData.layers) {
                    return userProjectData.layers.showNotes || [];
                }
            } catch (e) {
                console.error(e);
            }
            return [];
        },
        editableLayers: function editableLayers(state, getters) {
            var uid = getters.user['.key'];
            if (uid) {
                if (!getters.user.active_pay) return [];
                if (getters.ownerUID === uid) return getters.layers;

                var collab = getters.collaboratorByUID(uid);
                if (collab) {
                    return getters.layers.filter(function (layer) {
                        return collab.layers[layer.id];
                    });
                }
            }
            return [];
        },
        validLayers: function validLayers(state, getters) {
            if (getters.editableLayers.length > 0 && getters.visibleLayers.length > 0) {
                var editSet = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(getters.editableLayers.map(function (x) {
                    return x.id;
                }));
                var visibleSet = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(getters.visibleLayers);
                var choices = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(visibleSet).filter(function (x) {
                    return editSet.has(x.id);
                });
                return choices;
            }
            return [];
        },
        currentLayer: function currentLayer(state, getters) {
            var userProjectData = getters.userProjectData;
            if (userProjectData && userProjectData.layers && userProjectData.layers.editing) {
                var editLayerID = userProjectData.layers.editing;
                if (getters.validLayers.findIndex(function (l) {
                    return l.id === editLayerID;
                }) > -1) {
                    return getters.layerByID(editLayerID);
                }
            }
            return null;
        },

        collaborators: function collaborators(state, getters) {
            var collaborators = getters.project.collaborators || [];
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(collaborators);
        },
        pendingCollaborators: function pendingCollaborators(state, getters) {
            var pendingCollaborators = getters.project.pendingCollaborators || [];
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(pendingCollaborators);
        },
        collaboratorByUID: function collaboratorByUID(state, getters) {
            return function (uid) {
                var filter = getters.collaborators.filter(function (collab) {
                    return collab.uid === uid;
                });
                if (filter.length > 0) {
                    return filter[0];
                }
                return null;
            };
        },

        notes: function notes(state, getters) {
            var notes = getters.project.notes || [];
            var version = getters.currentVersion;
            if (version) {
                notes = version.notes || [];
            }
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(notes);
        },
        visibleNotes: function visibleNotes(state, getters) {
            var layerIDs = getters.visibleLayerIDs;
            var showNotes = getters.showNotesLayers;
            try {
                return getters.notes.filter(function (note) {
                    var layerVisible = layerIDs.includes(note.layer);
                    var layerShowingNotes = showNotes.includes(note.layer);
                    return layerVisible && layerShowingNotes;
                });
            } catch (e) {
                console.error(e);
            }
            return [];
        },
        notesByPage: function notesByPage(state, getters) {
            return function (page) {
                try {
                    return getters.visibleNotes.filter(function (note) {
                        return note.page === page;
                    });
                } catch (e) {
                    console.error(e);
                }
                return [];
            };
        },

        showMode: function showMode(state) {
            return state.showMode || false;
        }
    },
    mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_7_vuexfire__["firebaseMutations"]),
    actions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        setProjectsRef: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuexfire__["firebaseAction"])(function (_ref, _ref2) {
            var bindFirebaseRef = _ref.bindFirebaseRef;
            var ref = _ref2.ref,
                options = _ref2.options;

            console.log('Binding projects ref');
            bindFirebaseRef('projects', ref, options);
        }),
        setActiveProject: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuexfire__["firebaseAction"])(function (_ref3, _ref4) {
            var bindFirebaseRef = _ref3.bindFirebaseRef;
            var ref = _ref4.ref,
                options = _ref4.options;

            console.log('Binding project ref');
            bindFirebaseRef('activeProject', ref, options);
        }),
        setUsersRef: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuexfire__["firebaseAction"])(function (_ref5, _ref6) {
            var bindFirebaseRef = _ref5.bindFirebaseRef;
            var ref = _ref6.ref,
                options = _ref6.options;

            console.log('Binding Users Ref');
            bindFirebaseRef('users', ref, options);
        }),
        setActiveUser: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuexfire__["firebaseAction"])(function (_ref7, _ref8) {
            var bindFirebaseRef = _ref7.bindFirebaseRef;
            var ref = _ref8.ref,
                options = _ref8.options;

            console.log('Binding User Ref');
            bindFirebaseRef('activeUser', ref, options);
        })
    }, __WEBPACK_IMPORTED_MODULE_8__actions__["a" /* default */])
});

/* harmony default export */ __webpack_exports__["a"] = (QListStore);

/***/ }),
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var SampleData = {
    users: {
        1: {
            id: 1,
            firstName: 'First',
            lastName: 'User',
            avatar: 'avatar-2.jpg'
        },
        2: {
            id: 2,
            firstName: 'Second',
            lastName: 'User',
            avatar: 'avatar-2.jpg'
        }
    },
    defaultProject: function defaultProject() {
        return {
            title: '',
            lastChangedDate: new Date(),
            lastChangedBy: '',
            version: '',
            mutations: [],
            pages: [],
            collaborators: [],
            layers: [],
            activeVersion: '',
            showVersion: '',
            versions: []
        };
    },
    projects: [{
        id: 1,
        title: 'Most Recent Project',
        lastChangedDate: new Date(),
        lastChangedBy: 'Bob',
        version: 'V1.2',
        mutations: [],
        activeVersion: 'V1.2',
        showVersion: 'V1.2',
        documentUrl: './static/pdfs/legend.pdf',
        versions: [{
            title: 'Most Recent Project',
            version: 'V1.2',
            lastChangedBy: 'Bob',
            mutations: [{
                date: new Date(),
                user: 'Bob'
            }, {
                date: new Date(),
                user: 'Jane'
            }]
        }, {
            title: 'Most Recent Project v1.1',
            version: 'V1.1',
            lastChangedBy: 'Charlie',
            mutations: [{
                date: new Date(),
                user: 'Billy Jean'
            }]
        }],
        pages: [{
            pageNumber: 1,
            cues: [{
                id: 1,
                title: 'My First Cue',
                description: 'This is a description. It is longer than the title. a lot longer. very much longer.This is a description. It is longer than the title. a lot longer. very much longer.This is a description. It is longer than the title. a lot longer. very much longer.This is a description. It is longer than the title. a lot longer. very much longer.',
                layer: 1,
                x: 175,
                y: 290,
                scalarX: 850,
                scalarY: 1100
            }, {
                id: 2,
                title: 'My Second Cue',
                description: 'This is a description. It is longer than the title. a lot longer. very much longer.This is a description. It is longer than the title. a lot longer. very much longer.This is a description. It is longer than the title. a lot longer. very much longer.This is a description. It is longer than the title. a lot longer. very much longer.',
                layer: 2,
                x: 186,
                y: 153,
                scalarX: 850,
                scalarY: 1100
            }]
        }, {
            pageNumber: 2,
            cues: []
        }],
        collaborators: [{
            id: 1,
            title: 'Grand Vizier',
            layerPerms: [{
                id: 1,
                edit: true,
                view: true
            }]
        }, {
            id: 2,
            title: 'Sub Person',
            layerPerms: [{
                id: 1,
                edit: true,
                view: true
            }, {
                id: 2,
                edit: false,
                view: true
            }]
        }],
        layers: [{
            id: 1,
            title: 'Layer 1',
            color: 'yellow'
        }, {
            id: 2,
            title: 'Layer 2',
            color: 'pink'
        }]
    }, {
        id: 2,
        title: 'Project 2',
        lastChangedDate: new Date(),
        lastChangedBy: 'Bob',
        version: 'V1.2',
        pages: [{
            pageNumber: 1,
            cues: [{
                id: 1,
                title: 'My First Cue',
                description: 'This is a description. It is longer than the title. a lot longer. very much longer.This is a description. It is longer than the title. a lot longer. very much longer.This is a description. It is longer than the title. a lot longer. very much longer.This is a description. It is longer than the title. a lot longer. very much longer.',
                layer: 1
            }, {
                id: 2,
                title: 'My Second Cue',
                description: 'This is a description. It is longer than the title. a lot longer. very much longer.This is a description. It is longer than the title. a lot longer. very much longer.This is a description. It is longer than the title. a lot longer. very much longer.This is a description. It is longer than the title. a lot longer. very much longer.',
                layer: 2
            }]
        }, {
            pageNumber: 2
        }]
    }, {
        id: 3,
        title: 'Project 3',
        lastChangedDate: new Date(),
        lastChangedBy: 'Bob'
    }, {
        id: 4,
        title: 'Project 4',
        lastChangedDate: new Date(),
        lastChangedBy: 'Bob'
    }, {
        id: 5,
        title: 'Project 5',
        lastChangedDate: new Date(),
        lastChangedBy: 'Bob'
    }, {
        id: 6,
        title: 'Project 6',
        lastChangedDate: new Date(),
        lastChangedBy: 'Bob'
    }, {
        id: 7,
        title: 'Project 7',
        lastChangedDate: new Date(),
        lastChangedBy: 'Bob'
    }, {
        id: 8,
        title: 'Project 7',
        lastChangedDate: new Date(),
        lastChangedBy: 'Bob'
    }, {
        id: 9,
        title: 'Project 7',
        lastChangedDate: new Date(),
        lastChangedBy: 'Bob'
    }, {
        id: 10,
        title: 'Project 7',
        lastChangedDate: new Date(),
        lastChangedBy: 'Bob'
    }, {
        id: 11,
        title: 'Project 7',
        lastChangedDate: new Date(),
        lastChangedBy: 'Bob'
    }, {
        id: 12,
        title: 'Project 7',
        lastChangedDate: new Date(),
        lastChangedBy: 'Bob'
    }, {
        id: 13,
        title: 'Project 7',
        lastChangedDate: new Date(),
        lastChangedBy: 'Bob'
    }, {
        id: 14,
        title: 'Project 7',
        lastChangedDate: new Date(),
        lastChangedBy: 'Bob'
    }]
};

/* harmony default export */ __webpack_exports__["a"] = (SampleData);

/***/ }),
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cuelist.8600fc3.png";

/***/ }),
/* 295 */,
/* 296 */,
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(534)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(396),
  /* template */
  __webpack_require__(670),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(500)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(397),
  /* template */
  __webpack_require__(636),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(505)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(409),
  /* template */
  __webpack_require__(641),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(550)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(415),
  /* template */
  __webpack_require__(686),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(528)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(424),
  /* template */
  __webpack_require__(664),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(548)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(428),
  /* template */
  __webpack_require__(684),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 303 */,
/* 304 */,
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_vuex_Store__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_dashboard__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_project__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_project___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_project__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_account__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_account___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_account__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_accept_invite__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_accept_invite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_accept_invite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_login__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_forgot__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_forgot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_forgot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_admin_dashboard__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_admin_dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_admin_dashboard__);














__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{
        path: '/login/:redirect?',
        name: 'login',
        props: true,
        component: __WEBPACK_IMPORTED_MODULE_8__views_login___default.a
    }, {
        path: '/forgot',
        name: 'forgot',
        props: true,
        component: __WEBPACK_IMPORTED_MODULE_9__views_forgot___default.a
    }, {
        path: '/',
        name: 'home',
        component: __WEBPACK_IMPORTED_MODULE_4__views_dashboard___default.a,
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/dashboard',
        name: 'dashboard',
        component: __WEBPACK_IMPORTED_MODULE_4__views_dashboard___default.a,
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/admin',
        name: 'admin',
        component: __WEBPACK_IMPORTED_MODULE_10__views_admin_dashboard___default.a,
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        }
    }, {
        path: '/account',
        name: 'account',
        component: __WEBPACK_IMPORTED_MODULE_6__views_account___default.a,
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/project/:id',
        name: 'project',
        component: __WEBPACK_IMPORTED_MODULE_5__views_project___default.a,
        props: true,
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/project/:id/version/:version',
        name: 'projectVersion',
        component: __WEBPACK_IMPORTED_MODULE_5__views_project___default.a,
        props: true,
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/invite/:id',
        name: 'acceptInvite',
        component: __WEBPACK_IMPORTED_MODULE_7__views_accept_invite___default.a,
        props: true,
        meta: {
            requiresAuth: true
        }
    }]
});

router.beforeEach(function (to, from, next) {
    var currentUser = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().currentUser;
    var requiresAuth = to.matched.some(function (record) {
        return record.meta.requiresAuth;
    });
    var requiresAdmin = to.matched.some(function (record) {
        return record.meta.requiresAdmin;
    });

    if (requiresAdmin) {
        if (!currentUser) {
            next({
                path: '/login',
                query: { redirect: to.fullPath }
            });
        } else {
            __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.database().ref('users/' + currentUser.uid).once('value', function (snap) {
                var user = snap.val();
                if (user && user.admin) {
                    next();
                } else {
                    next('/');
                }
            });
        }
        return;
    }

    if (!currentUser && requiresAuth) {
        next({
            path: '/login',
            query: { redirect: to.fullPath }
        });
        return;
    }

    next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 306 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 307 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(549)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(685),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);



var isFirefox = /firefox/i.test(navigator.userAgent);

var UPPER_REGEX = /[A-Z]/g;

var BLACKLIST = ['viewBox'];

var keyCase = function keyCase(key) {
  if (BLACKLIST.indexOf(key) === -1) {
    key = key.replace(UPPER_REGEX, function (match) {
      return '-' + match.toLowerCase();
    });
  }
  return key;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  approximateFraction: function approximateFraction(x) {
    if (Math.floor(x) === x) {
      return [x, 1];
    }

    var xinv = 1 / x;
    var limit = 8;
    if (xinv > limit) {
      return [1, limit];
    } else if (Math.floor(xinv) === xinv) {
      return [1, xinv];
    }

    var x_ = x > 1 ? xinv : x;

    var a = 0,
        b = 1,
        c = 1,
        d = 1;

    while (true) {
      var p = a + c,
          q = b + d;
      if (q > limit) {
        break;
      }
      if (x_ <= p / q) {
        c = p;d = q;
      } else {
        a = p;b = q;
      }
    }

    if (x_ - a / b < c / d - x_) {
      return x_ === x ? [a, b] : [b, a];
    } else {
      return x_ === x ? [c, d] : [d, c];
    }
  },

  getOutputScale: function getOutputScale(ctx) {
    var devicePixelRatio = window.devicePixelRatio || 1;
    var backingStoreRatio = ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
    var pixelRatio = devicePixelRatio / backingStoreRatio;
    return {
      sx: pixelRatio,
      sy: pixelRatio,
      scaled: pixelRatio !== 1
    };
  },

  roundToDivide: function roundToDivide(x, div) {
    var r = x % div;
    return r === 0 ? x : Math.round(x - r + div);
  },

  scalePage: function scalePage(page, viewport, context) {
    var canvas = page.querySelector('.canvasWrapper canvas');
    var wrapper = page.querySelector('.canvasWrapper');
    var outputScale = this.getOutputScale(context);
    var transform = !outputScale.scaled ? null : [outputScale.sx, 0, 0, outputScale.sy, 0, 0];
    var sfx = this.approximateFraction(outputScale.sx);
    var sfy = this.approximateFraction(outputScale.sy);

    page.style.visibility = '';
    canvas.width = this.roundToDivide(viewport.width * outputScale.sx, sfx[0]);
    canvas.height = this.roundToDivide(viewport.height * outputScale.sy, sfy[0]);
    canvas.style.width = this.roundToDivide(viewport.width, sfx[1]) + 'px';
    canvas.style.height = this.roundToDivide(viewport.height, sfx[1]) + 'px';
    page.style.width = viewport.width + 'px';
    page.style.height = viewport.height + 'px';


    return transform;
  },

  transform: function (_transform) {
    function transform(_x, _x2) {
      return _transform.apply(this, arguments);
    }

    transform.toString = function () {
      return _transform.toString();
    };

    return transform;
  }(function (node, viewport) {
    var trans = this.getTranslation(viewport);

    node.setAttribute('transform', 'scale(' + viewport.scale + ') rotate(' + viewport.rotation + ') translate(' + trans.x + ', ' + trans.y + ')');

    if (!isFirefox && node.nodeName.toLowerCase() === 'svg') {
      node.setAttribute('x', parseInt(node.getAttribute('x'), 10) * viewport.scale);
      node.setAttribute('y', parseInt(node.getAttribute('y'), 10) * viewport.scale);

      var x = parseInt(node.getAttribute('x', 10));
      var y = parseInt(node.getAttribute('y', 10));
      var width = parseInt(node.getAttribute('width'), 10);
      var height = parseInt(node.getAttribute('height'), 10);
      var path = node.querySelector('path');
      var svg = path.parentNode;

      [node, svg, path, node.querySelector('rect')].forEach(function (n) {
        n.setAttribute('width', parseInt(n.getAttribute('width'), 10) * viewport.scale);
        n.setAttribute('height', parseInt(n.getAttribute('height'), 10) * viewport.scale);
      });

      transform(path, objectAssign({}, viewport, { scale: 1 }));

      switch (viewport.rotation % 360) {
        case 90:
          node.setAttribute('x', viewport.width - y - width);
          node.setAttribute('y', x);
          svg.setAttribute('x', 1);
          svg.setAttribute('y', 0);
          break;
        case 180:
          node.setAttribute('x', viewport.width - x - width);
          node.setAttribute('y', viewport.height - y - height);
          svg.setAttribute('y', 2);
          break;
        case 270:
          node.setAttribute('x', y);
          node.setAttribute('y', viewport.height - x - height);
          svg.setAttribute('x', -1);
          svg.setAttribute('y', 0);
          break;
      }
    }

    return node;
  }),

  getTranslation: function getTranslation(viewport) {
    var x = void 0;
    var y = void 0;

    switch (viewport.rotation % 360) {
      case 0:
        x = y = 0;
        break;
      case 90:
        x = 0;
        y = viewport.width / viewport.scale * -1;
        break;
      case 180:
        x = viewport.width / viewport.scale * -1;
        y = viewport.height / viewport.scale * -1;
        break;
      case 270:
        x = viewport.height / viewport.scale * -1;
        y = 0;
        break;
    }

    return { x: x, y: y };
  },

  setAttributes: function setAttributes(node, attributes) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(attributes).forEach(function (key) {
      node.setAttribute(keyCase(key), attributes[key]);
    });
  },

  getViewport: function getViewport(pdfPage, width, height) {
    var unscaledViewport = pdfPage.getViewport(1.0);
    var localScale = 1;

    localScale = Math.min(width, height) / Math.min(unscaledViewport.width, unscaledViewport.height);

    var localViewport = pdfPage.getViewport(localScale, 0);
    var output = pdfPage.getViewport(localViewport.scale, localViewport.rotation);
    return output;
  }

});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);



/* harmony default export */ __webpack_exports__["a"] = ({
    updatePageOffset: function updatePageOffset(_ref, offset) {
        var state = _ref.state,
            getters = _ref.getters;

        state.pageOffset = offset;
    },
    lockProject: function lockProject(_ref2, value) {
        var getters = _ref2.getters;

        try {
            var projectRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_firebase__["database"])().ref(getters.projectPath);
            projectRef.child('locked').set(value);
        } catch (e) {
            console.error(e);
        }
    },
    deleteProject: function deleteProject(_ref3, projectID) {
        var getters = _ref3.getters;

        try {
            var projectRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_firebase__["database"])().ref('/projects/' + projectID);
            projectRef.remove();
        } catch (e) {
            console.error(e);
        }
    },
    addPendingCollaborator: function addPendingCollaborator(_ref4, _ref5) {
        var getters = _ref4.getters;
        var project = _ref5.project,
            collaborator = _ref5.collaborator,
            inviter = _ref5.inviter;

        var projectRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_firebase__["database"])().ref('/projects/' + project.id);
        var pendingCollabsRef = projectRef.child('pendingCollaborators');
        var newPendingCollab = pendingCollabsRef.push();
        collaborator.id = newPendingCollab.key;

        if (inviter) {
            collaborator.inviter = inviter;
        }

        newPendingCollab.set(collaborator);
    },
    removePendingCollaborator: function removePendingCollaborator(_ref6, _ref7) {
        var getters = _ref6.getters;
        var project = _ref7.project,
            pendingCollaboratorID = _ref7.pendingCollaboratorID;

        try {
            var projectRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_firebase__["database"])().ref('/projects/' + project.id);
            projectRef.child('pendingCollaborators/' + pendingCollaboratorID).remove();
        } catch (e) {
            console.error(e);
        }
    },
    addCollaborator: function addCollaborator(_ref8, _ref9) {
        var getters = _ref8.getters;
        var project = _ref9.project,
            uid = _ref9.uid,
            pendingCollaborator = _ref9.pendingCollaborator;

        try {
            var projectRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_firebase__["database"])().ref('/projects/' + project.id);
            var collabsRef = projectRef.child('collaborators');
            var pendingCollabsRef = projectRef.child('pendingCollaborators');

            var collab = { uid: uid, layers: {}, role: pendingCollaborator.role };

            if (project.layers) {
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(project.layers).forEach(function (layer) {
                    collab.layers[layer] = false;
                });
            }

            collabsRef.child('' + collab.uid).set(collab).then(function () {
                pendingCollabsRef.child(pendingCollaborator.id).remove();
            });
        } catch (e) {
            console.error(e);
        }
    },
    updateCollaborator: function updateCollaborator(_ref10, collaborator) {
        var getters = _ref10.getters;

        var projectRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_firebase__["database"])().ref('/projects/' + getters.project.id);
        var collabRef = projectRef.child('collaborators/' + collaborator.uid);
        collabRef.update(collaborator);
    },
    removeCollaborator: function removeCollaborator(_ref11, _ref12) {
        var getters = _ref11.getters;
        var project = _ref12.project,
            collaboratorID = _ref12.collaboratorID;

        var projectRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_firebase__["database"])().ref('/projects/' + project.id);
        var collabRef = projectRef.child('collaborators/' + collaboratorID);
        collabRef.remove();
    },
    addUserNote: function addUserNote(_ref13, _ref14) {
        var getters = _ref13.getters;
        var note = _ref14.note,
            layer = _ref14.layer;

        try {
            var projectRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_firebase__["database"])().ref(getters.projectPath);
            var newNoteRef = projectRef.child('notes').push();

            newNoteRef.set({
                id: newNoteRef.key,
                x: note.x,
                y: note.y,
                width: 100,
                height: 40,
                page: note.pageNumber,
                layer: layer.id,
                text: ''
            });
        } catch (e) {
            console.error(e);
        }
    },
    updateUserNote: function updateUserNote(_ref15, _ref16) {
        var getters = _ref15.getters;
        var note = _ref16.note;

        try {
            var projectRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_firebase__["database"])().ref(getters.projectPath);
            var noteRef = projectRef.child('notes/' + note.id);

            noteRef.update({
                x: note.x,
                y: note.y,
                text: note.text,
                width: note.width,
                height: note.height,
                layer: note.layer
            });
        } catch (e) {
            console.error(e);
        }
    },
    removeUserNote: function removeUserNote(_ref17, _ref18) {
        var getters = _ref17.getters;
        var note = _ref18.note;

        try {
            var projectRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_firebase__["database"])().ref(getters.projectPath);
            var noteRef = projectRef.child('notes/' + note.id);
            noteRef.remove();
        } catch (e) {
            console.error(e);
        }
    },
    addLayer: function addLayer(_ref19, layer) {
        var getters = _ref19.getters;

        try {
            var projectRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_firebase__["database"])().ref(getters.projectPath);
            var newLayerRef = projectRef.child('layers').push();

            layer.id = newLayerRef.key;
            newLayerRef.set(layer);
        } catch (e) {
            console.error(e);
        }
    },
    updateLayer: function updateLayer(_ref20, layer) {
        var getters = _ref20.getters;

        try {
            var projectRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_firebase__["database"])().ref(getters.projectPath);
            var layerRef = projectRef.child('layers/' + layer.id);
            layerRef.update({
                color: layer.color,
                colorDetails: layer.colorDetails,
                title: layer.title
            });
        } catch (e) {
            console.error(e);
        }
    },
    removeLayer: function removeLayer(_ref21, layer) {
        var getters = _ref21.getters;

        try {
            var projectRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_firebase__["database"])().ref(getters.projectPath);
            var cues = getters.cues;

            var layerCues = cues.filter(function (cue) {
                return cue.layer === layer.id;
            });

            for (var i = layerCues.length - 1; i >= 0; i--) {
                var cue = layerCues[i];
                var cueRef = projectRef.child('cues/' + cue.id);
                cueRef.remove();
            }

            var layerRef = projectRef.child('layers/' + layer.id);
            layerRef.remove();
        } catch (e) {
            console.error(e);
        }
    },
    setEditingLayer: function setEditingLayer(_ref22, layer) {
        var getters = _ref22.getters;

        try {
            var userLayersRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_firebase__["database"])().ref('/users/' + getters.user.uid + '/projects/' + getters.project.id + '/layers');
            userLayersRef.child('editing').set(layer.id);
        } catch (e) {
            console.log('printing error');
            console.error(e);
        }
    },
    showLayer: function showLayer(_ref23, layer) {
        var getters = _ref23.getters;

        try {
            var layers = getters.visibleLayerIDs;
            var index = layers.findIndex(function (elem) {
                return elem === layer.id;
            });
            if (index === -1) {
                layers.unshift(layer.id);
                var userLayersRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_firebase__["database"])().ref('/users/' + getters.user.uid + '/projects/' + getters.project.id + '/layers');
                userLayersRef.child('viewing').set(layers);
            }
        } catch (e) {
            console.error(e);
        }
    },
    showAllLayers: function showAllLayers(_ref24) {
        var getters = _ref24.getters;

        try {
            var layers = getters.visibleLayerIDs;
            var userLayersRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_firebase__["database"])().ref('/users/' + getters.user.uid + '/projects/' + getters.project.id + '/layers');
            userLayersRef.child('viewing').set(layers);
        } catch (e) {
            console.error(e);
        }
    },
    showAllProjectLayers: function showAllProjectLayers(_ref25, _ref26) {
        var getters = _ref25.getters;
        var project = _ref26.project,
            layers = _ref26.layers;

        try {
            var layerIDs = layers.map(function (layer) {
                return layer.id;
            });
            var userLayersRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_firebase__["database"])().ref('/users/' + getters.user.uid + '/projects/' + project.id + '/layers');
            userLayersRef.child('viewing').set(layerIDs);
        } catch (e) {
            console.error(e);
        }
    },
    hideLayer: function hideLayer(_ref27, layer) {
        var getters = _ref27.getters;

        try {
            var layers = getters.visibleLayerIDs;
            var index = layers.findIndex(function (elem) {
                return elem === layer.id;
            });
            if (index > -1) {
                layers.splice(index, 1);
            }
            var userLayersRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_firebase__["database"])().ref('/users/' + getters.user.uid + '/projects/' + getters.project.id + '/layers');
            userLayersRef.child('viewing').set(layers);
        } catch (e) {
            console.error(e);
        }
    },
    hideAllLayers: function hideAllLayers(_ref28) {
        var getters = _ref28.getters;

        try {
            var userLayersRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_firebase__["database"])().ref('/users/' + getters.user.uid + '/projects/' + getters.project.id + '/layers');
            userLayersRef.child('viewing').remove();
        } catch (e) {
            console.error(e);
        }
    },
    hideAllProjectLayers: function hideAllProjectLayers(_ref29, project) {
        var getters = _ref29.getters;

        try {
            var userLayersRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_firebase__["database"])().ref('/users/' + getters.user.uid + '/projects/' + project.id + '/layers');
            userLayersRef.child('viewing').remove();
        } catch (e) {
            console.error(e);
        }
    },
    showNotes: function showNotes(_ref30, layer) {
        var getters = _ref30.getters;

        try {
            var layers = getters.showNotesLayers;
            var index = layers.findIndex(function (elem) {
                return elem === layer.id;
            });
            if (index === -1) {
                layers.unshift(layer.id);
                var userLayersRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_firebase__["database"])().ref('/users/' + getters.user.uid + '/projects/' + getters.project.id + '/layers');
                userLayersRef.child('showNotes').set(layers);
            }
        } catch (e) {
            console.error(e);
        }
    },
    hideNotes: function hideNotes(_ref31, layer) {
        var getters = _ref31.getters;

        try {
            var layers = getters.showNotesLayers;
            var index = layers.findIndex(function (elem) {
                return elem === layer.id;
            });
            if (index > -1) {
                layers.splice(index, 1);
            }
            var userLayersRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_firebase__["database"])().ref('/users/' + getters.user.uid + '/projects/' + getters.project.id + '/layers');
            userLayersRef.child('showNotes').set(layers);
        } catch (e) {
            console.error(e);
        }
    },
    addCue: function addCue(_ref32, cue) {
        var getters = _ref32.getters;

        try {
            var projectRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_firebase__["database"])().ref(getters.projectPath);
            var newCueRef = projectRef.child('cues').push();
            cue.id = newCueRef.key;
            cue.layer = getters.currentLayer.id;
            newCueRef.set(cue);
        } catch (e) {
            console.error(e);
        }
    },
    deleteCue: function deleteCue(_ref33, cue) {
        var getters = _ref33.getters;

        try {
            var projectRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_firebase__["database"])().ref(getters.projectPath);
            projectRef.child('cues/' + cue.id).remove();
        } catch (e) {
            console.error(e);
        }
    },
    updateCue: function updateCue(_ref34, cue) {
        var getters = _ref34.getters;

        try {
            var projectRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_firebase__["database"])().ref(getters.projectPath);
            projectRef.child('cues/' + cue.id).update({
                x: cue.x,
                y: cue.y,
                description: cue.description,
                width: cue.width,
                height: cue.height,
                pageNumber: cue.pageNumber,
                title: cue.title,
                layer: cue.layer
            });
        } catch (e) {
            console.error(e);
        }
    },
    useVersion: function useVersion(_ref35, versionID) {
        var state = _ref35.state,
            getters = _ref35.getters;

        console.log('using version ' + versionID);
        state.activeVersion = versionID;
    },
    createVersion: function createVersion(_ref36, versionName) {
        var getters = _ref36.getters;

        try {
            var project = getters.project;
            var userUID = getters.user['.key'];
            var now = new Date();
            var newVersionRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_firebase__["database"])().ref('/projects/' + project.id + '/versions').push();

            var cues = project.cues || [];
            var layers = project.layers || [];
            var notes = project.notes || [];

            newVersionRef.set({
                id: newVersionRef.key,
                created: now.toISOString(),
                name: versionName,
                cues: cues,
                layers: layers,
                notes: notes,
                creator: userUID
            });
        } catch (e) {
            console.error(e);
        }
    },
    deleteVersion: function deleteVersion(_ref37, versionID) {
        var state = _ref37.state,
            getters = _ref37.getters;

        try {
            if (state.activeVersion === versionID) state.activeVersion = null;
            var versionRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_firebase__["database"])().ref('/projects/' + getters.project.id + '/versions/' + versionID);
            versionRef.remove();
        } catch (e) {
            console.error(e);
        }
    },
    promoteVersion: function promoteVersion(_ref38, versionID) {
        var state = _ref38.state,
            getters = _ref38.getters;

        try {
            var project = getters.project;
            var userUID = getters.user['.key'];

            var version = getters.versionByID(versionID);

            if (userUID === getters.ownerUID) {
                var projectRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_firebase__["database"])().ref('/projects/' + project.id);
                var cues = version.cues || [];
                var layers = version.layers || [];
                var notes = version.notes || [];

                projectRef.update({
                    cues: cues,
                    layers: layers,
                    notes: notes
                });
            }
        } catch (e) {
            console.error(e);
        }
    },
    updateUser: function updateUser(_ref39, _ref40) {
        var state = _ref39.state,
            getters = _ref39.getters;
        var uid = _ref40.uid,
            update = _ref40.update;

        try {
            console.log(uid);
            console.log(update);
            var userRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_firebase__["database"])().ref('/users/' + uid);

            userRef.update(update);
        } catch (e) {
            console.error(e);
        }
    },
    updateShowMode: function updateShowMode(_ref41, showModeValue) {
        var state = _ref41.state,
            getters = _ref41.getters;

        state.showMode = showModeValue;
    }
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_material__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material_dist_vue_material_css__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material_dist_vue_material_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_material_dist_vue_material_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_extra_scss__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_extra_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__styles_extra_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_vuex_Store__ = __webpack_require__(102);





var config = {
    apiKey: 'AIzaSyCDOqiTg-3Y7yt4Uk9USiDuOD2dtTv6XMM',

    authDomain: 'app.thecuelist.com',
    databaseURL: 'https://qlist-70c1e.firebaseio.com',
    projectId: 'qlist-70c1e',
    storageBucket: 'qlist-70c1e.appspot.com',
    messagingSenderId: '316729066442'
};

__WEBPACK_IMPORTED_MODULE_2_firebase___default.a.initializeApp(config);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

var app = void 0;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_material___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].material.registerTheme({
    default: {
        primary: {
            color: '#0d2744',
            hue: 800
        }
    },
    'show-mode': {
        background: {
            color: 'grey',
            hue: 800
        },
        textColor: 'white'
    },
    white: {
        textColor: 'black',
        background: 'white'
    }
});

__WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().onAuthStateChanged(function (user) {
    app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
        el: '#app',
        store: __WEBPACK_IMPORTED_MODULE_9__lib_vuex_Store__["a" /* default */],
        router: __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */],
        template: '<App/>',
        components: { App: __WEBPACK_IMPORTED_MODULE_7__App___default.a }
    });
});

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
//
//
//
//
//
//



module.exports = {

	// thanks to https://github.com/marcj/css-element-queries
	props: {
		initial: {
			type: Boolean,
			default: false
		}
	},
	data: function () {
		return {
			size: {
				width: -1,
				height: -1
			}
		};
	},
	methods: {
		reset: function () {

			var expand = this.$el.firstChild;
			var shrink = this.$el.lastChild;
			expand.scrollLeft = 100000;
			expand.scrollTop = 100000;
			shrink.scrollLeft = 100000;
			shrink.scrollTop = 100000;
		},
		update: function () {

			this.size.width = this.$el.offsetWidth;
			this.size.height = this.$el.offsetHeight;
		}
	},
	watch: {
		size: {
			deep: true,
			handler: function (size) {

				this.reset();
				this.$emit('resize', { width: this.size.width, height: this.size.height });
			}
		}
	},
	render: function (create) {

		var style = 'position: absolute; left: 0; top: 0; right: 0; bottom: 0; overflow: hidden; z-index: -1; visibility: hidden;';
		var styleChild = 'position: absolute; left: 0; top: 0;';

		return create('div', {
			style: style + 'animation-name: resizeSensorVisibility;',
			on: {
				'~animationstart': this.update
			}
		}, [create('div', {
			style: style,
			on: {
				scroll: this.update
			}
		}, [create('div', {
			style: styleChild + 'width: 100000px; height: 100000px;'
		})]), create('div', {
			style: style,
			on: {
				scroll: this.update
			}
		}, [create('div', {
			style: styleChild + 'width: 200%; height: 200%;'
		})])]);
	},
	beforeDestroy: function () {

		this.$emit('resize', { width: 0, height: 0 });
		this.$emit('resizeSensorBeforeDestroy');
	},
	mounted: function () {

		if (this.initial === true) this.$nextTick(this.update);

		if (this.$el.offsetParent !== this.$el.parentNode) this.$el.parentNode.style.position = 'relative';

		if ('attachEvent' in this.$el && !('AnimationEvent' in window)) {

			var onresizeHandler = function () {

				this.update();
				removeOnresizeEvent();
			}.bind(this);

			var removeOnresizeEvent = function () {

				this.$el.detachEvent('onresize', onresizeHandler);
				this.$off('resizeSensorBeforeDestroy', removeOnresizeEvent);
			}.bind(this);

			this.$el.attachEvent('onresize', onresizeHandler);
			this.$on('resizeSensorBeforeDestroy', removeOnresizeEvent);
			this.reset();
		}
	}
};

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var app = {
    name: 'app',

    data: function data() {
        return {
            currentUID: null
        };
    },

    mounted: function mounted() {}
};

/* harmony default export */ __webpack_exports__["default"] = (app);

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);






var ChangePassword = {
    name: 'change-password',
    data: function data() {
        return {
            currentPassword: '',
            newPassword: '',
            confirmPassword: '',
            hasError: '',
            errorMessage: ''
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['user'])),
    methods: {
        submit: function submit() {
            var _this = this;

            this.hasError = '';
            this.errorMessage = '';

            var currentUser = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().currentUser;
            var credential = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth.EmailAuthProvider.credential(this.user.email, this.currentPassword);
            currentUser.reauthenticateWithCredential(credential).then(function () {
                currentUser.updatePassword(_this.newPassword).then(function () {
                    _this.currentPassword = '';
                    _this.newPassword = '';
                    _this.confirmPassword = '';
                    _this.hasError = '';
                    _this.errorMessage = '';
                }).catch(function (error) {
                    _this.hasError = error.code;
                    _this.errorMessage = error.message;
                });
            }).catch(function (error) {
                _this.hasError = error.code;
                _this.errorMessage = error.message;
            });
        },
        isComplete: function isComplete() {
            return !this.confirmPasswordError() && this.currentPassword !== '' && this.newPassword !== '' && this.confirmPassword !== '';
        },
        currentPasswordError: function currentPasswordError() {
            return this.hasError === 'auth/wrong-password';
        },
        newPasswordError: function newPasswordError() {
            return this.hasError === 'auth/weak-password';
        },
        confirmPasswordError: function confirmPasswordError() {
            return this.newPassword && this.confirmPassword && this.newPassword !== this.confirmPassword;
        }
    },
    created: function created() {}
};
/* harmony default export */ __webpack_exports__["default"] = (ChangePassword);

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);






var ProfilePhoto = {
    name: 'profile-photo',
    data: function data() {
        return {};
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['user'])),
    methods: {
        onFileUpload: function onFileUpload(evt) {
            this.file = evt[0];
        },
        updateProfilePhoto: function updateProfilePhoto(data) {
            var _this = this;

            var storageRef = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.storage().ref();
            storageRef.child('profile/' + this.user.uid + '.png').putString(data, 'data_url').then(function (snapshot) {
                var downloadURL = snapshot.downloadURL;
                __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().currentUser.updateProfile({ photoURL: downloadURL }).then(function () {
                    _this.closeDialog('upload');
                });

                _this.$store.dispatch('updateUser', {
                    uid: _this.user.uid,
                    update: {
                        profile_picture: downloadURL
                    }
                });
            });
        },
        upload: function upload() {
            var _this2 = this;

            console.log(this.file);
            var fileReader = new FileReader();
            fileReader.readAsDataURL(this.file);

            fileReader.onload = function () {
                _this2.updateProfilePhoto(fileReader.result);
            };
        },
        open: function open() {
            this.$refs.upload.open();
        },
        closeDialog: function closeDialog(ref) {
            this.$refs[ref].close();
        }
    }
};
/* harmony default export */ __webpack_exports__["default"] = (ProfilePhoto);

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);




function UnverifiedException() {
    this.code = 'auth/unverified-email';
    this.message = 'This email is not confirmed yet.';
}

var LoginForm = {
    name: 'LoginForm',
    data: function data() {
        return {
            email: '',
            password: '',
            errorCode: '',
            errorMessage: '',
            sent: false
        };
    },
    methods: {
        forgot: function forgot() {
            this.$router.replace('/forgot');
        },
        login: function login() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().signInWithEmailAndPassword(this.email, this.password).then(function (user) {
                if (!user.emailVerified) {
                    _this.sent = false;
                    throw new UnverifiedException();
                }
                _this.$router.replace('/dashboard');
            }).catch(function (error) {
                _this.errorCode = error.code;
                _this.errorMessage = error.message;
            });
        },
        verifyError: function verifyError() {
            return this.errorCode === 'auth/unverified-email';
        },
        emailError: function emailError() {
            return this.errorCode === 'auth/invalid-email' || this.errorCode === 'auth/unverified-email';
        },
        passwordError: function passwordError() {
            return this.errorCode === 'auth/wrong-password';
        },
        sendVerficationEmail: function sendVerficationEmail() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().currentUser.sendEmailVerification().then(function () {
                _this2.sent = true;
            });
        }
    }
};
/* harmony default export */ __webpack_exports__["default"] = (LoginForm);

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);




var RegisterForm = {
    name: 'RegisterForm',
    data: function data() {
        return {
            newUser: {
                firstName: '',
                lastName: '',
                email: '',
                password: '',
                confirmPassword: ''
            },
            hasError: '',
            errorMessage: ''
        };
    },
    methods: {
        register: function register() {
            var _this = this;

            var self = this;

            this.hasError = '';
            this.errorMessage = '';
            __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().createUserWithEmailAndPassword(this.newUser.email, this.newUser.password).then(function (user) {
                user.updateProfile({
                    displayName: _this.newUser.firstName + ' ' + _this.newUser.lastName
                }).then(function () {
                    user.signInMethod = 'email';
                    console.log(user);
                    self.$emit('success', user);
                });

                user.sendEmailVerification();
            }).catch(function (error) {
                console.log(error.code);
                _this.hasError = error.code;
                _this.errorMessage = error.message;
            });
        },
        emailError: function emailError() {
            return this.hasError === 'auth/invalid-email' || this.hasError === 'auth/email-already-in-use';
        },
        passwordError: function passwordError() {
            return this.hasError === 'auth/weak-password';
        },
        confirmPasswordError: function confirmPasswordError() {
            return this.newUser.password && this.newUser.confirmPassword && this.newUser.password !== this.newUser.confirmPassword;
        }
    }
};
/* harmony default export */ __webpack_exports__["default"] = (RegisterForm);

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_collaborators_layer_permission__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_collaborators_layer_permission___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_collaborators_layer_permission__);




var CollaboratorsCollaborator = {
    name: 'CollaboratorsCollaborator',
    props: ['collaborator', 'user', 'collabUser', 'editable', 'layers'],
    components: {
        layerPermission: __WEBPACK_IMPORTED_MODULE_0__components_collaborators_layer_permission___default.a
    },
    data: function data() {
        return {
            editing: false
        };
    },
    methods: {
        removeCollaborator: function removeCollaborator() {
            this.$emit('removeCollaborator', this.collaborator.uid);
        }
    },
    mounted: function mounted() {
        console.log(this.user.uid);
        console.log(this.collaborator.uid);
        console.log(this.editable);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (CollaboratorsCollaborator);

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);






var SENDMAIL_URL = 'https://us-central1-qlist-70c1e.cloudfunctions.net/sendMailgunEmail';


var CollaboratorsInvite = {
    name: 'CollaboratorsInvite',
    props: ['project'],
    data: function data() {
        return {
            newInvitee: { email: '', name: '', role: '' },

            autoCompleteInvitee: '',
            inviting: false,
            emailSent: false
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['users', 'user'])),
    methods: {
        resetInvitee: function resetInvitee() {
            this.newInvitee = { email: '', name: '', role: '' };
            this.autoCompleteInvitee = '';
        },
        filter: function filter(_ref) {
            var _this = this;

            var q = _ref.q;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                var arr = [];

                for (var i = 0; i < _this.users.length; i++) {
                    if (_this.users[i].username.indexOf(q) !== -1) {
                        arr.push(_this.users[i]);
                    }

                    if (arr.length > 5) {
                        break;
                    }
                }

                resolve(arr);
            });
        },
        inviteCallback: function inviteCallback(item) {
            this.newInvitee = {
                email: item.email,
                name: item.username
            };
        },
        inviteNew: function inviteNew() {
            var _this2 = this;

            this.$emit('addCollaborator', this.newInvitee);
            this.inviting = true;

            var host = document.URL.split('/')[2] || 'app.thecuelist.com';
            var inviteLink = 'https://' + host + '/#/invite/' + this.project.id;

            var emailBody = '<p>Hi ' + this.newInvitee.name + '</p>\n                <p>You\u2019ve been invited by <strong>' + this.user.username + '</strong> to collaborate on the Cuelist project <strong>' + this.project.title + '</strong>.</p>\n                <p>Cuelist is web-based software designed to help you and your collaborators create, edit and share cues and notes directly on a PDF script in real-time. Your scripts will be constantly up-to-date and permanently archived on our secure servers.</p>\n                <p>If you are a current user of Cuelist, click <a href="' + inviteLink + '">here</a> to accept your invite to this project<br/>\n                    If you are new to Cuelist, click <a href="https://thecuelist.com">here</a> to learn more and sign up to try Cuelist today for FREE.</p>\n                <p>If you have any questions, you can reach out to me personally at <a href="mailto:joshepstein@thecuelist.com">joshepstein@thecuelist.com</a>.</p>\n                <p>Thanks for using Cuelist!</p>\n                <p><strong>Josh Epstein</strong><br/>Founder and creator, Cuelist</p>';

            var postData = {
                email: this.newInvitee.email,
                subject: 'Invitation to collaborate on ' + this.project.title + ' via Cuelist',
                content: emailBody
            };

            this.$http.post(SENDMAIL_URL, postData).then(function (response) {
                console.log(response);
                setTimeout(function () {
                    _this2.emailSent = true;
                    setTimeout(function () {
                        _this2.emailSent = false;
                        _this2.inviting = false;
                        _this2.resetInvitee();
                    }, 1000);
                }, 2000);
            });
        }
    }
};
/* harmony default export */ __webpack_exports__["default"] = (CollaboratorsInvite);

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);






var CollaboratorsNav = {
    name: 'CollaboratorsNav',
    props: ['layer', 'editable', 'collaborator'],
    data: function data() {
        return {
            layerPerms: this.collaborator.layers[this.layer.id]
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['project'])),
    methods: {
        changeEdit: function changeEdit() {
            var _this = this;

            var collabRef = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.database().ref('/projects/' + this.project.id + '/collaborators/' + this.collaborator.uid);
            var layers = this.collaborator.layers;
            this.$nextTick(function () {
                layers[_this.layer.id] = _this.layerPerms;

                collabRef.child('layers').set(layers);
            });
        }
    },

    mounted: function mounted() {}
};
/* harmony default export */ __webpack_exports__["default"] = (CollaboratorsNav);

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__buses_nav__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_collaborators_collaborator__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_collaborators_collaborator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_collaborators_collaborator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_collaborators_pending_collaborator__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_collaborators_pending_collaborator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_collaborators_pending_collaborator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_collaborators_invite__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_collaborators_invite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_collaborators_invite__);









var CollaboratorsNav = {
    name: 'CollaboratorsNav',
    props: ['project', 'user'],
    data: function data() {
        return {
            collaborator: null,
            editingCollaborator: false
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['collaborators', 'collaboratorByUID', 'pendingCollaborators', 'userByUID', 'layers', 'ownerUID']), {
        owner: function owner() {
            return this.userByUID(this.ownerUID);
        },
        canEdit: function canEdit() {
            return this.collaboratorByUID(this.user.uid) || this.ownerUID === this.user.uid;
        }
    }),
    methods: {
        back: function back() {
            this.$refs.collaboratorsNav.close();
            __WEBPACK_IMPORTED_MODULE_2__buses_nav__["a" /* default */].$emit('main-nav.open');
        },
        doneEditing: function doneEditing() {
            this.$refs.collaboratorEdit.close();
            this.$refs.collaboratorsNav.open();
            this.collaborator = null;
        },
        addCollaborator: function addCollaborator(collab) {
            this.$store.dispatch('addPendingCollaborator', {
                project: this.project,
                collaborator: collab,
                inviter: this.user.uid
            });
        },
        removeCollaborator: function removeCollaborator(collabID) {
            this.$store.dispatch('removeCollaborator', {
                project: this.project,
                collaboratorID: collabID
            });
        },
        removePendingCollaborator: function removePendingCollaborator(collabID) {
            this.$store.dispatch('removePendingCollaborator', {
                project: this.project,
                pendingCollaboratorID: collabID
            });
        }
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_2__buses_nav__["a" /* default */].$on('collaborators-nav.open', function () {
            if (_this.$refs.collaboratorsNav) {
                _this.$refs.collaboratorsNav.open();
            }
        });
    },
    components: {
        collaborator: __WEBPACK_IMPORTED_MODULE_3__components_collaborators_collaborator___default.a,
        pendingCollaborator: __WEBPACK_IMPORTED_MODULE_4__components_collaborators_pending_collaborator___default.a,
        invite: __WEBPACK_IMPORTED_MODULE_5__components_collaborators_invite___default.a
    }
};
/* harmony default export */ __webpack_exports__["default"] = (CollaboratorsNav);

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var CollaboratorsPendingCollaborator = {
    name: 'CollaboratorsPendingCollaborator',
    props: ['collaborator', 'editable', 'layers'],
    data: function data() {
        return {
            editing: false
        };
    },
    methods: {
        removeCollaborator: function removeCollaborator() {
            console.log(this.collaborator);
            this.$emit('removePendingCollaborator', this.collaborator.id);
        }
    }
};
/* harmony default export */ __webpack_exports__["default"] = (CollaboratorsPendingCollaborator);

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var CoreFooter = {
    name: 'CoreFooter',
    data: function data() {
        return {};
    }
};
/* harmony default export */ __webpack_exports__["default"] = (CoreFooter);

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__buses_nav__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_project_search__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_project_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_project_search__);








var CoreHeader = {
    name: 'CoreHeader',
    props: ['project', 'user', 'locked'],
    data: function data() {
        return {};
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['currentVersion'])),
    methods: {
        toggleLeftSidenav: function toggleLeftSidenav() {
            __WEBPACK_IMPORTED_MODULE_2__buses_nav__["a" /* default */].$emit('main-nav.open');
        }
    },
    components: {
        'project-search': __WEBPACK_IMPORTED_MODULE_3__components_project_search___default.a
    }
};
/* harmony default export */ __webpack_exports__["default"] = (CoreHeader);

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buses_nav__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layers_nav__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layers_nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_layers_nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_collaborators_nav__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_collaborators_nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_collaborators_nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_history_versions_nav__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_history_versions_nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_history_versions_nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_print_nav__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_print_nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_print_nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_project_settings_nav__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_project_settings_nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_project_settings_nav__);











var CoreNavMain = {
    name: 'CoreNavMain',
    props: ['project', 'user'],
    data: function data() {
        return {};
    },
    methods: {
        open: function open() {},
        close: function close() {},
        closeMainNav: function closeMainNav() {
            this.$refs.leftSidenav.close();
        },
        projectsClick: function projectsClick() {
            this.closeMainNav();
        },
        collaboratorsClick: function collaboratorsClick() {
            this.closeMainNav();
            __WEBPACK_IMPORTED_MODULE_1__buses_nav__["a" /* default */].$emit('collaborators-nav.open');
        },
        layersClick: function layersClick() {
            this.closeMainNav();
            __WEBPACK_IMPORTED_MODULE_1__buses_nav__["a" /* default */].$emit('layers-nav.open');
        },
        historyClick: function historyClick() {
            this.closeMainNav();
            __WEBPACK_IMPORTED_MODULE_1__buses_nav__["a" /* default */].$emit('versions-nav.open');
        },
        projectSettingsClick: function projectSettingsClick() {
            this.closeMainNav();
            __WEBPACK_IMPORTED_MODULE_1__buses_nav__["a" /* default */].$emit('project-settings-nav.open');
        },
        printClick: function printClick() {
            this.closeMainNav();
            __WEBPACK_IMPORTED_MODULE_1__buses_nav__["a" /* default */].$emit('print-nav.open');
        },
        logoutClick: function logoutClick() {
            var _this = this;

            this.closeMainNav();
            __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().signOut().then(function () {
                _this.$router.go('/login');
            });
        },
        helpClick: function helpClick() {
            window.open('https://www.thecuelist.com/additionalhelp/', '_blank');
        }
    },
    components: {
        'layers-nav': __WEBPACK_IMPORTED_MODULE_2__components_layers_nav___default.a,
        'collaborators-nav': __WEBPACK_IMPORTED_MODULE_3__components_collaborators_nav___default.a,
        'print-nav': __WEBPACK_IMPORTED_MODULE_5__components_print_nav___default.a,
        'history-nav': __WEBPACK_IMPORTED_MODULE_4__components_history_versions_nav___default.a,
        'project-settings-nav': __WEBPACK_IMPORTED_MODULE_6__components_project_settings_nav___default.a
    },
    created: function created() {
        var _this2 = this;

        __WEBPACK_IMPORTED_MODULE_1__buses_nav__["a" /* default */].$on('main-nav.open', function () {
            if (_this2.$refs.leftSidenav) {
                _this2.$refs.leftSidenav.open();
            }
        });
    }
};
/* harmony default export */ __webpack_exports__["default"] = (CoreNavMain);

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var DashboardHeader = {
    name: 'dashboardHeader',
    props: ['showMode', 'isActivePay'],
    data: function data() {
        return {
            localShowMode: this.$props.showMode
        };
    },
    methods: {
        toggleShowMode: function toggleShowMode() {
            this.$emit('toggleShowMode');
        }
    }
};

/* harmony default export */ __webpack_exports__["default"] = (DashboardHeader);

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_history_revisions_list__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_history_revisions_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_history_revisions_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sampleData__ = __webpack_require__(142);







var HistoryBox = {
    name: 'HistoryBox',
    data: function data() {
        return {};
    },
    computed: {
        allMutations: function allMutations() {
            var results = [];
            __WEBPACK_IMPORTED_MODULE_1__sampleData__["a" /* default */].projects.forEach(function (project, p) {
                if (project.versions) {
                    project.versions.forEach(function (version, v) {
                        if (version.mutations) {
                            version.mutations.forEach(function (mutation, m) {
                                var obj = {};
                                obj.id = p + '.' + v + '.' + m;
                                obj.project = project;
                                obj.version = version;
                                obj.mutation = mutation;
                                results.push(obj);
                            });
                        }
                    });
                }
            });
            return results;
        }
    },
    methods: {},
    components: {
        'revisions-list': __WEBPACK_IMPORTED_MODULE_0__components_history_revisions_list___default.a
    }
};
/* harmony default export */ __webpack_exports__["default"] = (HistoryBox);

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dashboard_project_box__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dashboard_project_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_dashboard_project_box__);




var PendingProjects = {
    name: 'PendingProjects',
    props: ['projects', 'user'],
    data: function data() {
        return {};
    },
    methods: {
        accept: function accept(project) {
            var _this = this;

            var pendingCollaborators = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(project.pendingCollaborators);
            var pcIndex = pendingCollaborators.findIndex(function (pc) {
                return pc.email === _this.user.email;
            });
            var pendingCollab = pendingCollaborators[pcIndex];

            this.$store.dispatch('addCollaborator', {
                project: project,
                uid: this.user.uid,
                pendingCollaborator: pendingCollab
            });
        },
        decline: function decline(project) {
            var _this2 = this;

            var pendingCollaborators = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(project.pendingCollaborators);
            var pcIndex = pendingCollaborators.findIndex(function (pc) {
                return pc.email === _this2.user.email;
            });
            var pendingCollab = pendingCollaborators[pcIndex];

            this.$store.dispatch('removePendingCollaborator', {
                project: project,
                pendingCollaboratorID: pendingCollab.id
            });
        }
    },
    components: {
        'dashboard-project-box': __WEBPACK_IMPORTED_MODULE_1__components_dashboard_project_box___default.a
    }
};
/* harmony default export */ __webpack_exports__["default"] = (PendingProjects);

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);






var ProjectBox = {
    name: 'ProjectBox',
    props: ['project'],
    data: function data() {
        return {
            confirm: {
                title: 'Confirm Project Delete',
                ok: 'yes',
                cancel: 'Cancel'
            }
        };
    },
    methods: {
        selectProject: function selectProject() {},
        deleteProject: function deleteProject() {
            this.$refs.deleteProjectDialog.open();
        },
        deleteProjectConfirm: function deleteProjectConfirm(type) {
            if (type === 'ok') {
                this.$store.dispatch('deleteProject', this.project.id);
                this.$router.replace('/dashboard');
            }
        },
        getConfirmContent: function getConfirmContent() {
            var numCollaborators = this.project.collaborators ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.project.collaborators).length : 0;
            var numCues = this.project.cues ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.project.cues).length : 0;
            return 'Warning, you are about to delete a project with <strong>' + numCollaborators + '</strong> collaborators and <strong>' + numCues + '</strong> cues already written! Please confirm you would like to delete this project.';
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['user', 'userByUID']), {
        lastChanged: function lastChanged() {
            if (this.project.lastChangedDate) {
                return __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.project.lastChangedDate).format('MM/DD/YYYY hh:mm:ss a');
            }
            return __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('MM/DD/YYYY hh:mm:ss a');
        },
        owner: function owner() {
            return this.userByUID(this.project.ownerUID);
        }
    })
};
/* harmony default export */ __webpack_exports__["default"] = (ProjectBox);

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_dashboard_project_box__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_dashboard_project_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_dashboard_project_box__);




var ProjectGrid = {
    name: 'ProjectGrid',
    props: ['projects'],
    data: function data() {
        return {};
    },
    methods: {},
    components: {
        'dashboard-project-box': __WEBPACK_IMPORTED_MODULE_0__components_dashboard_project_box___default.a
    }
};
/* harmony default export */ __webpack_exports__["default"] = (ProjectGrid);

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var RevisionList = {
    name: 'revisionList',
    props: ['mutations'],
    data: function data() {
        return {};
    },
    computed: {},
    methods: {}
};
/* harmony default export */ __webpack_exports__["default"] = (RevisionList);

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__buses_nav__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_history_revisions_list__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_history_revisions_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_history_revisions_list__);





var RevisionsNav = {
    name: 'RevisionsNav',
    props: ['version', 'project'],
    data: function data() {
        return {};
    },
    computed: {
        mutations: function mutations() {
            var _this = this;

            var results = [];
            if (this.$props.version.mutations) {
                this.$props.version.mutations.forEach(function (mutation, m) {
                    var obj = {};
                    obj.id = m;
                    obj.project = _this.$props.project;
                    obj.version = _this.$props.version;
                    obj.mutation = mutation;
                    results.push(obj);
                });
            }

            return results;
        }
    },
    methods: {
        open: function open() {
            if (this.$refs.revisionNav) {
                this.$refs.revisionNav.open();
            }
        },
        close: function close() {
            this.$refs.revisionNav.close();
        },
        closeRevisionsNav: function closeRevisionsNav() {
            this.$refs.revisionNav.close();
        },
        back: function back() {
            this.$emit('back');
        }
    },
    created: function created() {
        var _this2 = this;

        __WEBPACK_IMPORTED_MODULE_0__buses_nav__["a" /* default */].$on('revisions-nav.open', function () {
            if (_this2.$refs.revisionNav) {
                _this2.$refs.revisionNav.open();
            }
        });
    },
    components: {
        'revisions-list': __WEBPACK_IMPORTED_MODULE_1__components_history_revisions_list___default.a
    }
};
/* harmony default export */ __webpack_exports__["default"] = (RevisionsNav);

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);






var Version = {
    name: 'Version',
    props: ['project', 'version'],
    data: function data() {
        return {};
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['ownerUID', 'user', 'versions', 'currentVersion'])),
    methods: {
        setActiveVersion: function setActiveVersion(versionID) {
            if (versionID === null) {
                this.$router.replace('/project/' + this.project.id);
            }

            var vIndex = this.versions.findIndex(function (v) {
                return v.id === versionID;
            });
            if (vIndex > -1) {
                this.$router.replace('/project/' + this.project.id + '/version/' + versionID + '/');
            }
        },
        isCurrentVersion: function isCurrentVersion(versionID) {
            if (this.currentVersion) {
                return this.currentVersion.id === versionID;
            }

            return false;
        },
        deleteVersion: function deleteVersion(versionID) {
            this.$emit('deleteVersion', versionID);
        },
        promoteVersion: function promoteVersion(versionID) {
            this.$emit('promoteVersion', versionID);
        },
        getFormattedDate: function getFormattedDate(version) {
            return __WEBPACK_IMPORTED_MODULE_1_moment___default()(version.created).format('MM/DD/YYYY hh:mm:ss a');
        }
    }
};
/* harmony default export */ __webpack_exports__["default"] = (Version);

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__buses_nav__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_history_revisions_nav__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_history_revisions_nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_history_revisions_nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_history_version__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_history_version___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_history_version__);











var VersionsNav = {
    name: 'VersionsNav',
    props: ['project'],
    data: function data() {
        return {
            revisionVersion: {},
            showVersion: this.$props.project.showVersion,
            versionTitle: '',
            versionToPromote: null,
            versionToDelete: null,
            confirmPromote: {
                title: 'Confirm Live Version Replacement',
                ok: 'yes',
                cancel: 'cancel',
                content: 'You are about to make a previous version live. This will immediately record over your current live version. Are you sure you want to replace your current live project with this one?  You won\'t be able to undo this change.'
            },
            confirmDelete: {
                title: 'Confirm Delete Version',
                ok: 'yes',
                cancel: 'cancel',
                content: 'You are about to delete an old saved version of this project. You won\'t be able to undo this change.'
            }
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['user', 'versions', 'currentVersion']), {
        days: function days() {
            var days = this.versions.reduce(function (rv, x) {
                var day = __WEBPACK_IMPORTED_MODULE_2_moment___default()(x.created).format('MM/DD/YYYY');
                (rv[day] = rv[day] || []).push(x);
                return rv;
            }, {});
            var daysOrdered = {};
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(days).sort(this.descendingDateComparison).forEach(function (key) {
                daysOrdered[key] = days[key].sort(function (a, b) {
                    return __WEBPACK_IMPORTED_MODULE_2_moment___default()(b.created).diff(__WEBPACK_IMPORTED_MODULE_2_moment___default()(a.created));
                });
            });

            return daysOrdered;
        }
    }),
    methods: {
        closeVersionsNav: function closeVersionsNav() {
            this.$refs.versionsNav.close();
        },
        back: function back() {
            this.closeVersionsNav();
            __WEBPACK_IMPORTED_MODULE_4__buses_nav__["a" /* default */].$emit('main-nav.open');
        },
        setActiveVersion: function setActiveVersion(versionID) {
            if (versionID === null) {
                this.$router.replace('/project/' + this.project.id);
            }

            var vIndex = this.versions.findIndex(function (v) {
                return v.id === versionID;
            });

            if (vIndex > -1) {
                this.$router.replace('/project/' + this.project.id + '/version/' + versionID + '/');
            }
        },
        saveVersion: function saveVersion() {
            this.$store.dispatch('createVersion', this.versionTitle);
            this.versionTitle = '';
        },
        promoteVersion: function promoteVersion(versionID) {
            this.versionToPromote = versionID;
            this.$refs.promoteVersionDialog.open();
        },
        promoteVersionConfirm: function promoteVersionConfirm(type) {
            if (this.versionToPromote === null) return;

            if (type === 'ok') {
                this.$store.dispatch('promoteVersion', this.versionToPromote);

                this.$router.replace('/project/' + this.project.id);
            }
        },
        deleteVersion: function deleteVersion(versionID) {
            this.versionToDelete = versionID;
            this.$refs.deleteVersionDialog.open();
        },
        deleteVersionConfirm: function deleteVersionConfirm(type) {
            if (this.versionToDelete === null) return;

            if (type === 'ok') {
                this.$store.dispatch('deleteVersion', this.versionToDelete);
            }
        },
        getFormattedDate: function getFormattedDate(version) {
            return __WEBPACK_IMPORTED_MODULE_2_moment___default()(version.created).format('MM/DD/YYYY hh:mm:ss a');
        },
        descendingDateComparison: function descendingDateComparison(a, b) {
            return __WEBPACK_IMPORTED_MODULE_2_moment___default()(b, 'MM/DD/YYYY').diff(__WEBPACK_IMPORTED_MODULE_2_moment___default()(a, 'MM/DD/YYYY'));
        }
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_4__buses_nav__["a" /* default */].$on('versions-nav.open', function () {
            if (_this.$refs.versionsNav) {
                _this.$refs.versionsNav.open();
            }
        });
    },
    components: {
        'revisions-nav': __WEBPACK_IMPORTED_MODULE_5__components_history_revisions_nav___default.a,
        'version-element': __WEBPACK_IMPORTED_MODULE_6__components_history_version___default.a
    }
};
/* harmony default export */ __webpack_exports__["default"] = (VersionsNav);

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layers_layer__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layers_layer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_layers_layer__);





var LayersNav = {
    name: 'CoreHeader',
    props: ['project', 'layers'],
    data: function data() {
        return {
            newLayerTitle: '',
            layerToDelete: null
        };
    },
    components: {
        layer: __WEBPACK_IMPORTED_MODULE_2__components_layers_layer___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['visibleLayerIDs', 'showNotesLayers', 'editableLayers', 'cuesPerLayer'])),
    methods: {
        canView: function canView(layer) {
            var layerIDs = this.visibleLayerIDs;
            return layerIDs.includes(layer.id);
        },
        canEdit: function canEdit(layer) {
            var layerIDs = this.editableLayers.map(function (l) {
                return l.id;
            });
            return layerIDs.includes(layer.id);
        },
        canShowNotes: function canShowNotes(layer) {
            return this.showNotesLayers.includes(layer.id);
        },
        hideLayer: function hideLayer(layer) {
            this.$store.dispatch('hideLayer', layer);
        },
        showLayer: function showLayer(layer) {
            this.$store.dispatch('showLayer', layer);
        },
        updateLayer: function updateLayer(layer) {
            this.$store.dispatch('updateLayer', layer);
        },
        dialogClose: function dialogClose(type) {
            if (type === 'cancel') {
                this.layerToDelete = null;
            }
            if (type === 'ok') {
                this.deleteLayer();
            }
        },
        tryDeleteLayer: function tryDeleteLayer(layer) {
            var numCues = this.cuesPerLayer(layer.id).length;
            this.layerToDelete = layer;
            if (numCues === 0) {
                this.deleteLayer();
            } else {
                this.$refs.deleteLayerDialog.open();
            }
        },
        deleteLayer: function deleteLayer() {
            if (this.layerToDelete) {
                this.$store.dispatch('removeLayer', this.layerToDelete);
                this.$store.dispatch('hideLayer', this.layerToDelete);
            }
        }
    }
};
/* harmony default export */ __webpack_exports__["default"] = (LayersNav);

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var LayersLayerLite = {
    name: 'LayersLayerLite',
    props: ['layer'],
    data: function data() {
        return {};
    },
    computed: {},
    methods: {
        style: function style() {
            var val = 'background-color: white;';
            if (this.layer.color) {
                val = 'background-color: ' + this.layer.color + ' !important;';
            }
            return val;
        },
        deleteLayer: function deleteLayer() {
            this.$emit('deleteLayer', this.layer);
        }
    }
};
/* harmony default export */ __webpack_exports__["default"] = (LayersLayerLite);

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_color__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_color__);




var LayersLayerNew = {
    name: 'LayersLayerNew',
    props: ['project'],
    data: function data() {
        return {
            newLayerTitle: '',
            colorDetails: {},
            color: '',
            colors: {}
        };
    },
    methods: {
        addLayer: function addLayer() {
            var newLayer = { title: this.newLayerTitle, colorDetails: this.colorDetails, color: this.color };
            this.$emit('addLayer', newLayer);

            this.newLayerTitle = '';
            this.color = '';
            this.colorDetails = {};
            this.colors = {};
        },
        pickColor: function pickColor(e) {
            this.colorDetails = e;
            this.color = this.colorDetails.hex;
        }
    },
    components: {
        'color-picker': __WEBPACK_IMPORTED_MODULE_0_vue_color__["Slider"]
    }
};
/* harmony default export */ __webpack_exports__["default"] = (LayersLayerNew);

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var LayersLayerPicker = {
    name: 'LayersLayerPicker',
    props: ['layers', 'currentLayer'],
    data: function data() {
        return {};
    },
    methods: {
        style: function style(layer) {
            var val = 'background-color: ' + layer.color + ' !important;';
            return val;
        },
        open: function open() {
            this.$refs.layerMenu.open();
        },
        selectLayer: function selectLayer(layer) {
            this.$store.dispatch('setEditingLayer', layer);
        }
    }
};

/* harmony default export */ __webpack_exports__["default"] = (LayersLayerPicker);

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_color__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_color__);



var LayersLayer = {
    name: 'LayersLayer',
    props: ['layer', 'viewable', 'editable', 'showNotes', 'project'],
    data: function data() {
        return {
            editing: false,
            selectedColor: '',
            showingPicker: false,
            colors: {},
            oldTitle: this.$props.layer.title
        };
    },
    computed: {},
    methods: {
        edit: function edit() {
            if (this.editable) {
                this.editing = true;
            }
        },
        done: function done() {
            this.editing = false;
        },
        style: function style() {
            var val = 'background-color: white;';
            if (this.layer.color) {
                val = 'background-color: ' + this.layer.color + ' !important;';
            }
            return val;
        },
        keyPress: function keyPress(e) {
            if (e.keyCode === 27) {
                this.editing = false;
                this.$props.layer.title = this.oldTitle;
            }
        },
        saveTitle: function saveTitle() {
            this.editing = false;
            this.oldTitle = this.$props.layer.title;
            this.$emit('updateLayer', this.layer);
        },
        pickColor: function pickColor(e) {
            this.layer.colorDetails = e;
            this.layer.color = this.layer.colorDetails.hex;
            this.$emit('updateLayer', this.layer);
        },
        deleteLayer: function deleteLayer() {
            this.$emit('deleteLayer', this.layer);
        },
        toggleVisibility: function toggleVisibility() {
            if (this.viewable) {
                this.hide();
            } else {
                this.show();
            }
        },
        show: function show() {
            this.$emit('showLayer', this.layer);
        },
        hide: function hide() {
            this.$emit('hideLayer', this.layer);
        },
        showText: function showText() {
            this.$store.dispatch('showNotes', this.layer);
        },
        hideText: function hideText() {
            this.$store.dispatch('hideNotes', this.layer);
        }
    },
    components: {
        'color-picker': __WEBPACK_IMPORTED_MODULE_0_vue_color__["Slider"]
    }
};
/* harmony default export */ __webpack_exports__["default"] = (LayersLayer);

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__buses_nav__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layers_layer_list__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layers_layer_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_layers_layer_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_layers_layer_new__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_layers_layer_new___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_layers_layer_new__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_layers_layer_picker__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_layers_layer_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_layers_layer_picker__);











var LayersNav = {
    name: 'CoreHeader',
    props: ['project'],
    data: function data() {
        return {};
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['layers', 'layerByID', 'currentLayer', 'validLayers', 'collaboratorByUID', 'user', 'ownerUID']), {
        collaborator: function collaborator() {
            return this.collaboratorByUID(this.user['.key']);
        },
        userRef: function userRef() {
            return __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.database().ref('users/' + this.user['.key']);
        },
        canEdit: function canEdit() {
            return (this.collaborator || this.ownerUID === this.user.uid) && this.user.active_pay;
        }
    }),
    methods: {
        open: function open() {},
        closeLayersNav: function closeLayersNav() {
            this.$refs.layerNav.close();
        },
        back: function back() {
            this.closeLayersNav();
            __WEBPACK_IMPORTED_MODULE_3__buses_nav__["a" /* default */].$emit('main-nav.open');
        },
        addLayer: function addLayer(layer) {
            this.$store.dispatch('addLayer', layer);
            this.showLayer(layer);
            this.$store.dispatch('showNotes', layer);

            if (this.collaborator) {
                var tempCollab = this.collaborator;
                tempCollab.layers[layer.id] = true;
                this.$store.dispatch('updateCollaborator', tempCollab);
            }
        },
        hideLayer: function hideLayer(layer) {
            this.$store.dispatch('hideLayer', layer);
        },
        showLayer: function showLayer(layer) {
            this.$store.dispatch('showLayer', layer);
        }
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_3__buses_nav__["a" /* default */].$on('layers-nav.open', function () {
            if (_this.$refs.layerNav) {
                _this.$refs.layerNav.open();
            }
        });
    },
    components: {
        'layer-list': __WEBPACK_IMPORTED_MODULE_4__components_layers_layer_list___default.a,
        'layer-new': __WEBPACK_IMPORTED_MODULE_5__components_layers_layer_new___default.a,
        'layer-picker': __WEBPACK_IMPORTED_MODULE_6__components_layers_layer_picker___default.a
    }
};
/* harmony default export */ __webpack_exports__["default"] = (LayersNav);

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__buses_nav__ = __webpack_require__(16);




var PrintNav = {
    name: 'CoreHeader',
    props: ['project'],
    data: function data() {
        return {
            allLayers: false,
            allNotes: false,
            allDescriptions: false
        };
    },
    methods: {
        closePrintNav: function closePrintNav() {
            this.$refs.printNav.close();
        },
        back: function back() {
            this.closePrintNav();
            __WEBPACK_IMPORTED_MODULE_0__buses_nav__["a" /* default */].$emit('main-nav.open');
        },
        print: function print() {
            console.log('Print');
        }
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0__buses_nav__["a" /* default */].$on('print-nav.open', function () {
            if (_this.$refs.printNav) {
                _this.$refs.printNav.open();
            }
        });
    }
};
/* harmony default export */ __webpack_exports__["default"] = (PrintNav);

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__buses_nav__ = __webpack_require__(16);







var ProjectSettingsNav = {
    name: 'CoreHeader',
    props: ['project'],
    data: function data() {
        return {
            nightMode: false,
            title: '',
            confirm: {
                title: 'Confirm Project Delete',
                ok: 'yes',
                cancel: 'Cancel'
            }
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['user', 'ownerUID', 'collaborators', 'cues']), {
        projectRef: function projectRef() {
            return __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.database().ref('/projects/' + this.project.id);
        }
    }),
    methods: {
        updateTitle: function updateTitle() {
            this.projectRef.update({ title: this.title });
        },
        closeProjectSettingsNav: function closeProjectSettingsNav() {
            this.$refs.projectSettingsNav.close();
        },
        back: function back() {
            this.closeProjectSettingsNav();
            __WEBPACK_IMPORTED_MODULE_3__buses_nav__["a" /* default */].$emit('main-nav.open');
        },
        getConfirmContent: function getConfirmContent() {
            var numCollaborators = this.collaborators.length;
            var numCues = this.cues.length;
            return 'Warning, you are about to delete a project with <strong>' + numCollaborators + '</strong> collaborators and <strong>' + numCues + '</strong> cues already written! Please confirm you would like to delete this project.';
        },
        deleteProject: function deleteProject() {
            this.$refs.deleteProjectDialog.open();
        },
        deleteProjectConfirm: function deleteProjectConfirm(type) {
            if (type === 'ok') {
                this.$store.dispatch('deleteProject', this.project.id);
                this.$router.replace('/dashboard');
            }
        }
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_3__buses_nav__["a" /* default */].$on('project-settings-nav.open', function () {
            if (_this.$refs.projectSettingsNav) {
                _this.title = _this.project.title;
                _this.$refs.projectSettingsNav.open();
            }
        });
    }
};
/* harmony default export */ __webpack_exports__["default"] = (ProjectSettingsNav);

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

var ProjectCuesAddCueButton = {
    name: 'projectCuesAddCueButton',
    props: ['cueToAdd'],
    data: function data() {
        return {};
    },
    methods: {
        preventContext: function preventContext(e) {
            e.preventDefault();
            e.stopPropagation();
            return false;
        },
        addCue: function addCue(e) {
            this.$emit('addCue', e);
        },
        addText: function addText(e) {
            this.$emit('addText', e);
        },
        cancel: function cancel(e) {
            this.$emit('cancel', e);
        }
    },
    components: {},
    mounted: function mounted() {
        this.$el.addEventListener('contextmenu', function (event) {
            event.preventDefault();
            event.stopPropagation();
            return false;
        });
    }
};

/* harmony default export */ __webpack_exports__["default"] = (ProjectCuesAddCueButton);

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

var ProjectCuesCueBody = {
    name: 'projectCuesCueBody',
    props: {
        cue: { Object: Object },
        locked: { Boolean: Boolean },
        editable: { Boolean: Boolean },
        color: { String: String }
    },
    data: function data() {
        return {
            editing: false,
            oldVal: this.$props.cue.description
        };
    },
    methods: {
        edit: function edit() {
            this.editing = true;
        },
        done: function done() {
            this.editing = false;
            this.oldVal = this.cue.description;
            this.$emit('cueUpdated', this.cue);
        },
        cancel: function cancel() {
            this.editing = false;
            this.cue.description = this.oldVal;
        },
        keyPress: function keyPress(e) {
            if (e.keyCode === 27) {
                this.done();
            }
        },
        destroy: function destroy() {
            this.$emit('destroy');
        }
    },
    components: {}
};

/* harmony default export */ __webpack_exports__["default"] = (ProjectCuesCueBody);

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_project_cues_layer_picker__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_project_cues_layer_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_project_cues_layer_picker__);




var ProjectCuesCueHeader = {
    name: 'projectCuesCueHeader',
    props: {
        cue: { Object: Object },
        expanded: { Boolean: Boolean },
        layer: { Object: Object },
        layers: { Array: Array },
        locked: { Boolean: Boolean },
        editable: { Boolean: Boolean },
        color: { String: String }
    },
    data: function data() {
        return {
            editing: false,
            oldVal: this.$props.cue.title
        };
    },
    methods: {
        toggle: function toggle() {
            this.$emit('toggle');
        },
        selectLayer: function selectLayer(layer) {
            if (this.locked) {
                return;
            }
            this.$props.cue.layer = layer;
            this.$emit('cueUpdated', this.$props.cue);
        },
        edit: function edit() {
            if (this.locked) {
                return;
            }
            this.editing = true;
        },
        keyPress: function keyPress(e) {
            if (e.keyCode === 27) {
                this.editing = false;
                this.$props.cue.title = this.oldVal;
            }
        },
        submit: function submit() {
            this.editing = false;
            this.oldVal = this.$props.cue.title;
            this.$emit('cueUpdated', this.cue);
        },
        style: function style() {
            if (this.expanded) {
                return 'border-bottom: 1px solid ' + this.color + '';
            }
            return '';
        }
    },
    components: {
        'layer-picker': __WEBPACK_IMPORTED_MODULE_0__components_project_cues_layer_picker___default.a
    }
};

/* harmony default export */ __webpack_exports__["default"] = (ProjectCuesCueHeader);

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_project_cues_cue__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_project_cues_cue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_project_cues_cue__);




var ProjectCueList = {
    name: 'projectCueList',
    props: ['cues', 'openCues', 'layers', 'locked'],
    data: function data() {
        return {};
    },
    methods: {
        isOpen: function isOpen(cue) {
            var cueSet = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(this.openCues);
            return cueSet.has(cue.id);
        },
        openCue: function openCue(cue) {
            this.$emit('openCue', cue);
        },
        closeCue: function closeCue(cue) {
            this.$emit('closeCue', cue);
        },
        destroy: function destroy(cue) {
            this.$emit('destroy', cue);
        },
        updatedCue: function updatedCue(cue) {
            this.$emit('updatedCue', cue);
        }
    },
    components: {
        'project-cues-cue': __WEBPACK_IMPORTED_MODULE_1__components_project_cues_cue___default.a
    }
};

/* harmony default export */ __webpack_exports__["default"] = (ProjectCueList);

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_draggable_resizable__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_draggable_resizable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_draggable_resizable__);






var CuePositionMarker = {
    name: 'CuePositionMarker',
    props: ['cue', 'locked', 'editable', 'pageWidth', 'pageHeight'],
    data: function data() {
        return {
            dragging: false
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['layerByCue']), {
        layer: function layer() {
            return this.layerByCue(this.cue);
        },
        cuePosLeft: function cuePosLeft() {
            if (!this.dragging && this.cue.x <= 1) {
                return this.cue.x * this.pageWidth;
            }
            return this.cue.x;
        },
        cuePosTop: function cuePosTop() {
            if (!this.dragging && this.cue.y <= 1) {
                return this.cue.y * this.pageHeight;
            }
            return this.cue.y;
        }
    }),
    methods: {
        cueColor: function cueColor(cue) {
            var layer = this.layerByCue(cue);
            if (layer) return layer.color;

            return 'black';
        },
        onDrag: function onDrag(x, y) {
            this.cue.x = x;
            this.cue.y = y;
            this.dragging = true;
        },
        onDragStop: function onDragStop(x, y) {
            var cue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.cue, {
                x: x,
                y: y
            });
            this.dragging = false;
            this.$emit('updateCue', cue);
        },
        onActivate: function onActivate() {
            this.$emit('activated');
        },
        onDeactivate: function onDeactivate() {
            this.$emit('deactivated');
        }
    },
    components: {
        'vue-draggable-resizable': __WEBPACK_IMPORTED_MODULE_2_vue_draggable_resizable___default.a
    },

    mounted: function mounted() {}
};

/* harmony default export */ __webpack_exports__["default"] = (CuePositionMarker);

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_draggable_resizable__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_draggable_resizable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_draggable_resizable__);






var CueSelectionMarker = {
    name: 'CueSelectionMarker',
    props: ['cue', 'locked', 'editable', 'pageWidth', 'pageHeight'],
    data: function data() {
        return {
            dragging: false
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['layerByCue']), {
        layer: function layer() {
            return this.layerByCue(this.cue);
        },
        cuePosLeft: function cuePosLeft() {
            if (!this.dragging && this.cue.x <= 1) {
                return this.cue.x * this.pageWidth;
            }
            return this.cue.x;
        },
        cuePosTop: function cuePosTop() {
            if (!this.dragging && this.cue.y <= 1) {
                return this.cue.y * this.pageHeight;
            }
            return this.cue.y;
        }
    }),
    methods: {
        cueColor: function cueColor(cue) {
            var layer = this.layerByCue(cue);
            if (layer) return layer.color;

            return 'black';
        },
        onDrag: function onDrag(x, y) {
            this.cue.x = x;
            this.cue.y = y;
            this.dragging = true;
        },
        onDragStop: function onDragStop(x, y) {
            var cue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.cue, {
                x: x,
                y: y
            });
            this.dragging = false;
            this.$emit('updateCue', cue);
        },
        onResize: function onResize(x, y, width, height) {
            var cue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.cue, {
                x: x,
                y: y,
                width: width,
                height: height
            });
            this.$emit('updateCue', cue);
        },
        onActivate: function onActivate() {
            this.$emit('activated');
        },
        onDeactivate: function onDeactivate() {
            this.$emit('deactivated');
        }
    },
    components: {
        'vue-draggable-resizable': __WEBPACK_IMPORTED_MODULE_2_vue_draggable_resizable___default.a
    },

    mounted: function mounted() {}
};

/* harmony default export */ __webpack_exports__["default"] = (CueSelectionMarker);

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_project_cues_cue_header__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_project_cues_cue_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_project_cues_cue_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_project_cues_cue_body__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_project_cues_cue_body___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_project_cues_cue_body__);








var ProjectCuesCue = {
    name: 'projectCuesCue',
    props: ['cue', 'open', 'layers', 'locked'],
    data: function data() {
        return {
            expanded: this.open
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['layerByCue', 'editableLayers']), {
        layer: function layer() {
            return this.layerByCue(this.cue);
        },
        visible: function visible() {
            var visible = true;

            if (this.layer) {
                if (this.layer.hidden === true) {
                    visible = false;
                }
            }
            return visible;
        },
        editable: function editable() {
            var _this = this;

            if (this.layer) {
                var filter = this.editableLayers.filter(function (l) {
                    return l.id === _this.layer.id;
                });
                return filter.length > 0;
            }
            return false;
        },
        color: function color() {
            var val = 'white';
            if (this.layer) {
                val = this.layer.color;
            }
            return val;
        }
    }),
    methods: {
        toggle: function toggle() {
            if (this.$props.cue) {
                if (this.expanded) {
                    this.contract();
                } else {
                    this.expand();
                }
            }
        },
        expand: function expand() {
            this.expanded = true;
            this.$emit('openCue', this.cue);
        },
        contract: function contract() {
            this.expanded = false;
            this.$emit('closeCue', this.cue);
        },
        destroy: function destroy() {
            this.$emit('destroy', this.$props.cue);
        },
        style: function style() {
            return { borderColor: this.color, top: this.cue.offsetY + 'px', zIndex: this.expanded ? 12 : 11 };
        },
        updatedCue: function updatedCue(cue) {
            this.$emit('updatedCue', cue);
        }
    },
    components: {
        'project-cues-cue-body': __WEBPACK_IMPORTED_MODULE_3__components_project_cues_cue_body___default.a,
        'project-cues-cue-header': __WEBPACK_IMPORTED_MODULE_2__components_project_cues_cue_header___default.a
    }
};

/* harmony default export */ __webpack_exports__["default"] = (ProjectCuesCue);

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var ProjectCuesLayerPicker = {
    name: 'projectCuesLayerPicker',
    props: ['layers', 'currentLayer', 'editable', 'locked'],
    data: function data() {
        return {};
    },
    computed: {},
    methods: {
        style: function style(layer) {
            var val = 'background-color: ' + layer.color + ' !important;';
            return val;
        },
        open: function open() {
            this.$refs.layerMenu.open();
        },
        selectLayer: function selectLayer(layer) {
            this.$emit('selectLayer', layer);
        }
    },
    components: {}
};

/* harmony default export */ __webpack_exports__["default"] = (ProjectCuesLayerPicker);

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_project_pagination__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_project_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_project_pagination__);




var ProjectHeader = {
    name: 'projectHeader',
    props: ['currentPage', 'totalPages', 'showMode', 'locked', 'isOwner', 'isActivePay'],
    data: function data() {
        return {
            localShowMode: this.$props.showMode,
            localLocked: this.$props.locked
        };
    },
    watch: {
        locked: function locked() {
            this.localLocked = this.locked;
        }
    },
    methods: {
        pageDown: function pageDown() {
            this.$emit('pageDown', this.currentPage);
        },
        pageUp: function pageUp() {
            this.$emit('pageUp', this.currentPage);
        },
        setPage: function setPage(number) {
            this.$emit('setPage', number);
        },
        toggleShowMode: function toggleShowMode() {
            this.$emit('toggleShowMode');
        },
        toggleLocked: function toggleLocked() {
            this.$emit('toggleLocked');
        },
        expandAll: function expandAll() {
            console.log('Expanding all');
        },
        contractAll: function contractAll() {
            console.log('Contracting all');
        }
    },
    components: {
        'project-pagination': __WEBPACK_IMPORTED_MODULE_0__components_project_pagination___default.a
    }
};

/* harmony default export */ __webpack_exports__["default"] = (ProjectHeader);

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_draggable_resizable__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_draggable_resizable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_draggable_resizable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_project_cues_layer_picker__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_project_cues_layer_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_project_cues_layer_picker__);








var ProjectNotesNote = {
    name: 'ProjectNotesNote',
    props: ['note', 'locked', 'pageWidth', 'pageHeight'],
    data: function data() {
        return {
            editing: false,
            disableText: false,
            dragging: false
        };
    },
    components: {
        'vue-draggable-resizable': __WEBPACK_IMPORTED_MODULE_1_vue_draggable_resizable___default.a,
        'layer-picker': __WEBPACK_IMPORTED_MODULE_3__components_project_cues_layer_picker___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['layerByID', 'validLayers']), {
        noteText: function noteText() {
            return this.note.text || 'Click to edit';
        },
        notePosLeft: function notePosLeft() {
            if (!this.dragging && this.note.x <= 1) {
                return this.note.x * this.pageWidth;
            }
            return this.note.x;
        },
        notePosTop: function notePosTop() {
            if (!this.dragging && this.note.y <= 1) {
                return this.note.y * this.pageHeight;
            }
            return this.note.y;
        }
    }),
    methods: {
        edit: function edit() {
            this.disableText = true;
            this.editing = true;
            this.$emit('activated');
        },
        open: function open() {
            this.$refs['text-edit-dialog'].open();
        },
        close: function close() {
            this.$emit('updateNote', this.note);
            this.$refs['text-edit-dialog'].close();
        },
        remove: function remove() {
            this.$emit('deactivated');
            this.$store.dispatch('removeUserNote', {
                note: this.note
            });
        },
        onDrag: function onDrag(x, y) {
            this.note.x = x;
            this.note.y = y;
            this.dragging = true;
        },
        onDragStop: function onDragStop(x, y) {
            var note = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.note, {
                x: x,
                y: y
            });
            this.dragging = false;
            this.$emit('updateNote', note);
        },
        onResize: function onResize(x, y, width, height) {
            var note = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.note, {
                x: x,
                y: y,
                width: width,
                height: height
            });
            this.$emit('updateNote', note);
        },
        onActivate: function onActivate() {},
        onDeactivate: function onDeactivate() {
            this.$emit('deactivated');
            this.editing = false;
            this.disableText = false;
        },
        selectLayer: function selectLayer(layerID) {
            var note = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.note, {
                layer: layerID
            });
            this.$emit('updateNote', note);
        }
    }
};

/* harmony default export */ __webpack_exports__["default"] = (ProjectNotesNote);

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resize_sensor__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resize_sensor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_resize_sensor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_project_cues_cue_position_marker__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_project_cues_cue_position_marker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_project_cues_cue_position_marker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_project_cues_cue_selection_marker__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_project_cues_cue_selection_marker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_project_cues_cue_selection_marker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_project_cues_add_cue_button__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_project_cues_add_cue_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_project_cues_add_cue_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_project_cues_cue_list__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_project_cues_cue_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_project_cues_cue_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_project_pdf_page__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_project_pdf_page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_project_pdf_page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_project_notes_note__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_project_notes_note___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_project_notes_note__);












var ProjectPage = {
    name: 'projectPage',
    props: ['page', 'layers', 'currentLayer', 'cues', 'locked', 'showMode'],
    data: function data() {
        return {
            pageNumber: this.$props.page.pageNumber,
            pageContainerId: 'pageContainer' + this.$props.page.pageNumber,
            ready: false,
            pageReady: false,
            disableText: false,
            scale: 1,
            addingCue: false,
            addCueX: 0,
            addCueY: 0,
            cueToAdd: null,
            offsetX: 0,
            offsetY: 0,
            pageWidth: 0,
            pageHeight: 0,
            pdfHeight: 0,
            pdfWidth: 0,
            originWidth: 0,
            originHeight: 0,
            cueMarkerWidth: 24,
            cueMarkerHeight: 24
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['currentVersion', 'layerByCue', 'visibleCues', 'editableLayers', 'notesByPage']), {
        versionID: function versionID() {
            return this.currentVersion ? this.currentVersion.id : '';
        },
        displayCues: function displayCues() {
            return this.visibleCues(this.pageNumber);
        },
        selectionCues: function selectionCues() {
            return this.displayCues.filter(function (c) {
                return c.type === 'selection';
            });
        },
        positionCues: function positionCues() {
            return this.displayCues.filter(function (c) {
                return c.type === 'position';
            });
        },
        displayNotes: function displayNotes() {
            return this.notesByPage(this.pageNumber);
        }
    }),
    methods: {
        openDialog: function openDialog(ref) {
            this.$refs[ref].open();
        },
        closeDialog: function closeDialog(ref) {
            this.$refs[ref].close();
        },
        getPDFViewport: function getPDFViewport() {
            return this.page.pdfPage.getViewport(this.scale, 0);
        },
        readyPage: function readyPage() {
            this.ready = false;
            var bounds = this.$el.querySelector('.ql-page-cover').getBoundingClientRect();
            var vp = this.getPDFViewport();

            var ph = window.innerHeight - bounds.top;

            var pw = vp.width * ph / vp.height;

            if (pw > bounds.width) {
                ph *= bounds.width / pw;
                pw = bounds.width;
            }


            this.scale = pw / Math.min(bounds.width, vp.width);

            this.originWidth = vp.width;
            this.originHeight = vp.height;

            this.pageWidth = pw;
            this.pageHeight = ph;
            this.ready = true;
        },
        setScale: function setScale(scale) {
            this.scale = scale;
        },
        pdfLoaded: function pdfLoaded(data) {
            this.setOffset();

            this.$emit('pageLoaded', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, {
                offsetX: this.offsetX,
                offsetY: this.offsetY,
                width: this.pdfWidth,
                height: this.pdfHeight,
                pageWidth: this.pageWidth,
                pageHeight: this.pageHeight,
                markerWidth: this.cueMarkerWidth,
                cueMarkerHeight: this.cueMarkerHeight
            }));

            this.pageReady = true;
        },
        cueCreated: function cueCreated(tempCue) {
            var _this = this;

            if (!this.currentLayer) {
                this.openDialog('no-layers-dialog');
                return;
            }
            if (this.locked || this.addingCue) {
                return;
            }

            var filter = this.editableLayers.filter(function (l) {
                return l.id === _this.currentLayer.id;
            });
            if (filter.length <= 0) {}

            this.$nextTick(function () {
                _this.addingCue = false;
                _this.cueToAdd = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, tempCue, {
                    title: _this.currentLayer.title,
                    description: tempCue.text || '',
                    pageNumber: _this.pageNumber
                });
                _this.addCueX = tempCue.x + (_this.offsetX - 25);
                _this.addCueY = tempCue.y - 5;
                _this.addingCue = true;
            });
        },
        addCue: function addCue() {
            if (this.locked) return;

            if (this.cueToAdd.x > 1 || this.cueToAdd.y > 1) {
                this.cueToAdd.x /= this.pageWidth;
                if (this.cueToAdd.x > 1) this.cueToAdd.x = 1;
                this.cueToAdd.y /= this.pageHeight;
                if (this.cueToAdd.y > 1) this.cueToAdd.y = 1;
            }
            this.$store.dispatch('addCue', this.cueToAdd);

            this.addingCue = false;
            this.cueToAdd = null;
            this.sortCues();
        },
        destroyCue: function destroyCue(cueToDestroy) {
            this.$store.dispatch('deletedCue', cueToDestroy);
        },
        updateCue: function updateCue(cueToUpdate) {
            if (cueToUpdate.x > 1 || cueToUpdate.y > 1) {
                cueToUpdate.x /= this.pageWidth;
                if (cueToUpdate.x > 1) cueToUpdate.x = 1;
                cueToUpdate.y /= this.pageHeight;
                if (cueToUpdate.y > 1) cueToUpdate.y = 1;
            }
            this.$store.dispatch('updateCue', cueToUpdate);
        },
        updateNote: function updateNote(noteToUpdate) {
            if (noteToUpdate.x > 1 || noteToUpdate.y > 1) {
                noteToUpdate.x /= this.pageWidth;
                if (noteToUpdate.x > 1) noteToUpdate.x = 1;
                noteToUpdate.y /= this.pageHeight;
                if (noteToUpdate.y > 1) noteToUpdate.y = 1;
            }
            this.$store.dispatch('updateUserNote', { note: noteToUpdate });
        },
        addText: function addText() {
            if (this.locked) return;

            this.$store.dispatch('addUserNote', {
                note: this.cueToAdd,
                layer: this.currentLayer
            });
            this.addingCue = false;
            this.cueToAdd = null;
        },
        cancelAddCue: function cancelAddCue() {
            this.addingCue = false;
            this.cueToAdd = null;
        },
        sortCues: function sortCues() {
            function comparator(a, b) {
                if (a.y === b.y) {
                    if (a.x === b.x) {
                        return 1;
                    } else if (a.x > b.x) {
                        return 1;
                    }
                    return 0;
                } else if (a.y > b.y) {
                    return 1;
                }
                return 0;
            }
            if (this.cues) {
                this.cues.sort(comparator);
            }
        },
        cueColor: function cueColor(cue) {
            var layer = this.layerByCue(cue);
            if (layer) return layer.color;

            return 'black';
        },
        setOffset: function setOffset() {
            var page = this.$el.querySelector('.ql-pdf-page');
            if (page) {
                var bounds = page.getBoundingClientRect();

                this.pdfHeight = bounds.height;
                this.pdfWidth = bounds.width;
                this.offsetX = bounds.x;
                this.offsetY = bounds.y;

                this.$store.dispatch('updatePageOffset', bounds.x);
            }
        },
        resize: function resize() {
            this.setOffset();
            if (this.pageReady) {
                this.$emit('pageLoaded', {
                    offsetX: this.offsetX,
                    offsetY: this.offsetY,
                    width: this.pdfWidth,
                    height: this.pdfHeight,
                    pageWidth: this.pageWidth,
                    pageHeight: this.pageHeight,
                    markerWidth: this.cueMarkerWidth,
                    cueMarkerHeight: this.cueMarkerHeight
                });
            }
        },
        isCueEditable: function isCueEditable(cue) {
            var layer = this.layerByCue(cue);
            if (layer) {
                var filter = this.editableLayers.filter(function (l) {
                    return l.id === layer.id;
                });
                return filter.length > 0;
            }
            return false;
        },
        isNoteEditable: function isNoteEditable(note) {
            var filter = this.editableLayers.filter(function (l) {
                return l.id === note.layer;
            });
            return filter.length > 0;
        }
    },
    components: {
        'cue-position-marker': __WEBPACK_IMPORTED_MODULE_3__components_project_cues_cue_position_marker___default.a,
        'cue-selection-marker': __WEBPACK_IMPORTED_MODULE_4__components_project_cues_cue_selection_marker___default.a,
        'project-cues-add-cue-button': __WEBPACK_IMPORTED_MODULE_5__components_project_cues_add_cue_button___default.a,
        'project-cue-list': __WEBPACK_IMPORTED_MODULE_6__components_project_cues_cue_list___default.a,
        'resize-sensor': __WEBPACK_IMPORTED_MODULE_1_vue_resize_sensor___default.a,
        'project-pdf-page': __WEBPACK_IMPORTED_MODULE_7__components_project_pdf_page___default.a,
        'project-note': __WEBPACK_IMPORTED_MODULE_8__components_project_notes_note___default.a
    },
    mounted: function mounted() {
        this.readyPage();
    }
};

/* harmony default export */ __webpack_exports__["default"] = (ProjectPage);

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_draggable_resizable__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_draggable_resizable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_draggable_resizable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_project_page__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_project_page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_project_page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_project_cues_cue_list__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_project_cues_cue_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_project_cues_cue_list__);











var ProjectPages = {
    name: 'projectPages',
    props: ['currentPage', 'currentUser', 'pages', 'locked', 'showMode'],
    data: function data() {
        return {
            svgOffsetStart: 0,
            svgOffsetEnd: 0,
            cueHeight: 48,
            cueOpenHeight: 180,
            cueBottomPadding: 10,
            svgHeight: 100,
            svgContentWidth: 100,
            pageReady: false,
            openCues: []
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['project', 'layerByCue', 'visibleCues', 'visibleLayers', 'currentLayer', 'layers']), {
        positionedCues: function positionedCues() {
            var allCues = this.visibleCues(this.currentPage);
            allCues.sort(function (a, b) {
                if (a.y === b.y) {
                    return a.x - b.x;
                }

                return a.y - b.y;
            });
            var positionedCues = [];

            for (var i = 0; i < allCues.length; i++) {
                var cue = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(allCues[i]));

                cue.currentHeight = this.getCueHeight(cue);
                if (cue.y <= 1 && cue.x <= 1) {
                    cue.offsetY = cue.y * this.svgHeight;
                    cue.offsetX = cue.x * this.svgContentWidth + this.svgOffsetStart;
                } else {
                    cue.offsetY = cue.y;
                    cue.offsetX = cue.x + this.svgOffsetStart;
                }


                if (positionedCues.length > 0) {
                    var otherCue = positionedCues[positionedCues.length - 1];
                    if (cue.offsetY < otherCue.offsetY + otherCue.currentHeight) {
                        cue.offsetY = otherCue.offsetY + otherCue.currentHeight + this.cueBottomPadding;
                    }
                }

                positionedCues.push(cue);
            }

            return positionedCues;
        },
        svgTrueHeight: function svgTrueHeight() {
            var lastElement = this.positionedCues[this.positionedCues.length - 1];
            if (lastElement) {
                return Math.max(this.svgHeight, lastElement.offsetY);
            }

            return this.svgHeight;
        }
    }),
    methods: {
        cueColor: function cueColor(cue) {
            var layer = this.layerByCue(cue);
            if (layer) return layer.color;

            return 'black';
        },
        getCueHeight: function getCueHeight(cue) {
            var cueOpenSet = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(this.openCues);
            var tempHeight = cueOpenSet.has(cue.id) ? this.cueOpenHeight : this.cueHeight;
            return tempHeight + this.cueBottomPadding;
        },
        cuePosTop: function cuePosTop(cue) {
            if (cue.x <= 1 && cue.y <= 1) {
                return cue.y * this.svgHeight + 1;
            }
            return cue.y + 1;
        },
        inRange: function inRange(key) {
            return key > this.$props.currentPage - 2 && key < this.$props.currentPage + 2;
        },
        current: function current(key) {
            return this.$props.currentPage === key;
        },
        openCue: function openCue(cue) {
            this.openCues.push(cue.id);
        },
        closeCue: function closeCue(cue) {
            var cueIndex = this.openCues.findIndex(function (c) {
                return c === cue.id;
            });
            this.openCues.splice(cueIndex, 1);
        },

        addedCue: function addedCue(cue) {
            this.$store.dispatch('addCue', cue);
        },
        deletedCue: function deletedCue(cue) {
            this.$store.dispatch('deleteCue', cue);
        },
        updatedCue: function updatedCue(cue) {
            this.$store.dispatch('updateCue', cue);
        },
        pageLoaded: function pageLoaded(data) {
            console.log(data);
            this.svgHeight = data.pageHeight;
            this.svgOffsetStart = data.offsetX;
            this.svgContentWidth = data.pageWidth;
            this.svgOffsetEnd = data.width + data.offsetX * 2 + 15;
            this.pageReady = true;
        },
        sortCues: function sortCues(cues) {
            return cues.sort(function (a, b) {
                if (a.y === b.y) {
                    if (a.x === b.x) {
                        return a.id > b.id;
                    }
                    return a.x > b.x;
                }

                return a.y > b.y;
            });
        },
        getCueRect: function getCueRect(cue) {
            return {
                left: 0,
                top: cue.offsetY,
                right: 10,
                bottom: cue.offsetY + cue.currentHeight
            };
        },
        intersectRect: function intersectRect(r1, r2) {
            return !(r2.left > r1.right || r2.right < r1.left || r2.top > r1.bottom || r2.bottom < r1.top);
        }
    },
    components: {
        'project-page': __WEBPACK_IMPORTED_MODULE_5__components_project_page___default.a,
        'project-cue-list': __WEBPACK_IMPORTED_MODULE_6__components_project_cues_cue_list___default.a,
        'vue-draggable-resizable': __WEBPACK_IMPORTED_MODULE_4_vue_draggable_resizable___default.a
    },
    mounted: function mounted() {}
};

/* harmony default export */ __webpack_exports__["default"] = (ProjectPages);

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var handleKeyDown = function handleKeyDown(that, e) {
    var preventTargets = ['md-input'];
    if (e.target.className.split(' ').some(function (el) {
        return preventTargets.some(function (prevent) {
            return el === prevent;
        });
    })) return;
    if (e.key === 'ArrowLeft') {
        that.pageDown();
    }
    if (e.key === 'ArrowRight') {
        that.pageUp();
    }
};

var ProjectPagination = {
    name: 'projectPagination',
    props: ['totalPages', 'currentPage'],
    data: function data() {
        return {
            page: this.$props.currentPage
        };
    },
    watch: {
        page: function page() {
            this.setPage();
        }
    },
    computed: {
        canPageDown: function canPageDown() {
            if (this.page > 1) {
                return true;
            }
            return false;
        },
        canPageUp: function canPageUp() {
            if (this.page < this.totalPages) {
                return true;
            }
            return false;
        }
    },
    methods: {
        pageDown: function pageDown() {
            if (this.canPageDown) {
                this.page = Math.max(1, this.page - 1);
            }
        },
        pageUp: function pageUp() {
            if (this.canPageUp) {
                this.page = Math.min(this.totalPages, this.page + 1);
            }
        },
        setPage: function setPage() {
            this.page = Math.max(Math.min(this.totalPages, this.page), 1);
            this.$emit('setPage', this.page);
        }
    },
    components: {},
    mounted: function mounted() {
        window.addEventListener('keydown', handleKeyDown.bind(null, this));
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('keydown', handleKeyDown.bind(null, this));
    }
};

/* harmony default export */ __webpack_exports__["default"] = (ProjectPagination);

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_Utils__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pdfjs_dist_web_pdf_viewer__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pdfjs_dist_web_pdf_viewer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_pdfjs_dist_web_pdf_viewer__);




__WEBPACK_IMPORTED_MODULE_1_pdfjs_dist_web_pdf_viewer__["PDFJS"].workerSrc = '../../../node_modules/pdfjs-dist/build/pdf.worker.js';

var ProjectPdfPage = {
    name: 'ProjectPdfPage',
    props: ['page', 'pageWidth', 'pageHeight'],
    components: {},
    data: function data() {
        return {
            pdfRender: null,
            pageNumber: this.$props.page.pageNumber,
            pdfPage: this.$props.page.pdfPage,
            pageContainerId: 'pageContainer' + this.$props.page.pageNumber
        };
    },
    methods: {
        renderPage: function renderPage() {
            var _this = this;

            var canvas = this.$el.querySelector('.canvasWrapper canvas');
            var canvasContext = canvas.getContext('2d', { alpha: false });

            var viewport = __WEBPACK_IMPORTED_MODULE_0__lib_Utils__["a" /* default */].getViewport(this.pdfPage, canvas.width, canvas.height);
            var transform = __WEBPACK_IMPORTED_MODULE_0__lib_Utils__["a" /* default */].scalePage(this.$el, viewport, canvasContext);

            console.log('RENDER PAGE ' + this.pageNumber);
            this.pdfRender = this.pdfPage.render({ canvasContext: canvasContext, viewport: viewport, transform: transform }).then(function () {
                _this.$el.setAttribute('data-loaded', 'true');
                return _this.pdfPage.getTextContent({ normalizeWhitespace: true }).then(function (textContent) {
                    var textLayer = _this.$el.querySelector('.textLayer');
                    textLayer.innerHTML = '';
                    var textLayerFactory = new __WEBPACK_IMPORTED_MODULE_1_pdfjs_dist_web_pdf_viewer__["PDFJS"].DefaultTextLayerFactory();
                    var textLayerBuilder = textLayerFactory.createTextLayerBuilder(textLayer, _this.pageNumber, viewport, true);
                    textLayerBuilder.setTextContent(textContent);
                    textLayerBuilder.render();

                    _this.$emit('pdfLoaded', { pageText: textContent, pageNumber: _this.pageNumber, viewport: viewport });
                    console.log('RENDERED PAGE ' + _this.pageNumber);
                });
            });
        },
        mouseDown: function mouseDown(e) {
            console.log(e);
            if (e.button === 2 || e.button === 0 && (e.metaKey || e.ctrlKey)) {
                e.preventDefault();
                this.createPositionCue(e);
            }
        },
        mouseUp: function mouseUp(e) {
            if (e.button === 0) {
                this.createSelectionCue();
            }
        },
        createSelectionCue: function createSelectionCue() {
            var selection = window.getSelection();
            var text = selection.toString();
            if (text) {
                var canvas = this.$el.querySelector('.canvasWrapper canvas');
                var bounds = canvas.getBoundingClientRect();

                var range = selection.getRangeAt(0);
                var rect = range.getBoundingClientRect();

                var cue = {
                    type: 'selection',
                    width: rect.width,
                    height: rect.height,
                    x: rect.x - bounds.x,
                    y: rect.y - bounds.y
                };
                this.$emit('cueCreated', cue);
            }
        },
        createPositionCue: function createPositionCue(e) {
            var canvas = this.$el.querySelector('.canvasWrapper canvas');
            var bounds = canvas.getBoundingClientRect();

            var cue = {
                type: 'position',
                x: e.clientX - bounds.x,
                y: e.clientY - bounds.y,
                width: 10,
                height: 10
            };

            this.$emit('cueCreated', cue);
        },
        preventContext: function preventContext(e) {
            e.preventDefault();
            e.stopPropagation();
            return false;
        }
    },
    mounted: function mounted() {
        this.renderPage();
    }
};

/* harmony default export */ __webpack_exports__["default"] = (ProjectPdfPage);

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__buses_nav__ = __webpack_require__(16);




var ProjectSearch = {
    resultComposite: 'projectSearch',
    data: function data() {
        return {
            visible: false,
            searchPageChoice: '',
            searchResults: [{ term: 'legend', page: 1, resultComposite: 'Page 1: legend' }, { term: 'legend', page: 2, resultComposite: 'Page 2: legend' }, { term: 'characters', page: 2, resultComposite: 'Page 2: characters' }, { term: 'pre-show', page: 3, resultComposite: 'Page 3: pre-show' }, { term: 'eddie', page: 2, resultComposite: 'Page 2: eddie' }, { term: 'eddie', page: 3, resultComposite: 'Page 3: eddie' }]
        };
    },
    methods: {
        search: function search(list, query) {
            var arr = [];

            for (var i = 0; i < list.length; i++) {
                if (list[i].term.indexOf(query.toLowerCase()) !== -1) {
                    arr.push(list[i]);
                }

                if (arr.length > 5) {
                    break;
                }
            }

            return arr;
        },
        selectSearchResult: function selectSearchResult(item) {
            __WEBPACK_IMPORTED_MODULE_0__buses_nav__["a" /* default */].$emit('goToPage', item.page);
        }
    }
};

/* harmony default export */ __webpack_exports__["default"] = (ProjectSearch);

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modals_create_project_create__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modals_create_project_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__modals_create_project_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modals_create_project_layers__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modals_create_project_layers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__modals_create_project_layers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modals_create_project_collaborators__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modals_create_project_collaborators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__modals_create_project_collaborators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sampleData__ = __webpack_require__(142);












var CreateProject = {
    name: 'createProject',
    data: function data() {
        return {
            project: __WEBPACK_IMPORTED_MODULE_6__sampleData__["a" /* default */].defaultProject(),
            projectsRef: __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.database().ref('projects/')
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['user'])),
    methods: {
        open: function open() {
            this.project = __WEBPACK_IMPORTED_MODULE_6__sampleData__["a" /* default */].defaultProject();
            this.$refs.createProj.open();
        },
        closeDialog: function closeDialog() {
            var _this = this;

            var now = new Date();

            if (this.project.fileObject) {
                var pdfDirRef = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.storage().ref('pdfs/' + this.project.fileObject.name);
                var newProject = {};

                pdfDirRef.put(this.project.fileObject).then(function (snap) {
                    var newProjectRef = _this.projectsRef.push();

                    newProject.lastChangedDate = now.toISOString();
                    newProject.id = newProjectRef.key;
                    newProject.title = _this.project.title;
                    newProject.version = 0.1;
                    newProject.showVersion = 0.1;
                    newProject.activeVersion = 0.1;
                    newProject.documentUrl = snap.downloadURL;
                    newProject.ownerUID = _this.user['.key'];
                    newProject.lastChangedBy = _this.user['.key'];

                    newProjectRef.set(newProject);

                    var layersRef = newProjectRef.child('layers');

                    _this.project.layers.forEach(function (layer) {
                        var newLayerRef = layersRef.push();
                        layer.id = newLayerRef.key;
                        newLayerRef.set(layer);
                    });

                    var collabsRef = newProjectRef.child('collaborators');

                    _this.project.collaborators.forEach(function (collab) {
                        collab.layers = {};
                        _this.project.layers.forEach(function (layer) {
                            collab.layers[layer.id] = false;
                        });
                        collabsRef.child('' + collab.uid).set(collab);
                    });
                });
            } else {
                console.log('Could not create project: No File Selected');
            }
            this.$refs.createProj.close();
        },
        fixContent: function fixContent() {
            var _this2 = this;

            if (this.$refs.stepper) {
                this.$nextTick(function () {
                    _this2.$refs.stepper.calculateStepsWidthAndPosition();
                });
            }
        },
        startOver: function startOver() {
            if (this.$refs.stepper) {
                this.$refs.stepper.movePreviousStep();
                this.$refs.stepper.movePreviousStep();
            }
        },
        cancel: function cancel() {
            this.$refs.createProj.close();
        }
    },
    components: {
        create: __WEBPACK_IMPORTED_MODULE_3__modals_create_project_create___default.a,
        layers: __WEBPACK_IMPORTED_MODULE_4__modals_create_project_layers___default.a,
        collaborators: __WEBPACK_IMPORTED_MODULE_5__modals_create_project_collaborators___default.a
    }
};
/* harmony default export */ __webpack_exports__["default"] = (CreateProject);

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_collaborators_collaborator__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_collaborators_collaborator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_collaborators_collaborator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_collaborators_invite__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_collaborators_invite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_collaborators_invite__);







var Collaborators = {
    name: 'collaborators',
    props: ['project'],
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['user', 'userByUID']), {
        owner: function owner() {
            return this.user;
        }
    }),
    methods: {
        addCollaborator: function addCollaborator(collab) {
            this.project.collaborators.unshift(collab);
        },
        removeCollaborator: function removeCollaborator(collab) {
            var index = this.project.collaborators.findIndex(function (c) {
                return c.uid === collab.uid;
            });
            this.project.collaborators.splice(index, 1);
        }
    },
    components: {
        collaborator: __WEBPACK_IMPORTED_MODULE_2__components_collaborators_collaborator___default.a,
        invite: __WEBPACK_IMPORTED_MODULE_3__components_collaborators_invite___default.a
    }
};
/* harmony default export */ __webpack_exports__["default"] = (Collaborators);

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var Create = {
    name: 'create',
    props: ['project'],
    methods: {
        onFileChange: function onFileChange(fileList) {
            this.project.fileObject = fileList[0];
        }
    }
};
/* harmony default export */ __webpack_exports__["default"] = (Create);

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layers_layer_lite__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layers_layer_lite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_layers_layer_lite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layers_layer_new__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layers_layer_new___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_layers_layer_new__);





var Layers = {
    name: 'layers',
    props: ['project'],
    methods: {
        addLayer: function addLayer(layer) {
            layer.id = Math.random() * 100000;
            this.project.layers.unshift(layer);
        },
        deleteLayer: function deleteLayer(layer) {
            var index = this.project.layers.findIndex(function (l) {
                return l.title === layer.title;
            });
            this.project.layers.splice(index, 1);
        }
    },
    components: {
        'layer-lite': __WEBPACK_IMPORTED_MODULE_0__components_layers_layer_lite___default.a,
        'layer-new': __WEBPACK_IMPORTED_MODULE_1__components_layers_layer_new___default.a
    }
};
/* harmony default export */ __webpack_exports__["default"] = (Layers);

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_core_footer__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_core_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_core_footer__);







var AcceptInviteView = {
    name: 'AcceptInviteView',
    props: ['id'],
    data: function data() {
        return {
            ready: false,
            validCollab: null
        };
    },
    watch: {
        project: function project() {
            this.checkProjectStatus();
        },
        user: function user() {
            this.checkProjectStatus();
        }
    },
    methods: {
        setValidCollab: function setValidCollab() {
            var _this = this;

            var index = this.pendingCollaborators.findIndex(function (pc) {
                return pc.email === _this.user.email;
            });

            if (index > -1) {
                this.validCollab = this.pendingCollaborators[index];
            }
        },
        accept: function accept() {
            this.$store.dispatch('addCollaborator', {
                project: this.project,
                uid: this.user.uid,
                pendingCollaborator: this.validCollab
            });

            this.$store.dispatch('showAllLayers');

            this.$router.replace('/project/' + this.id);
        },
        checkProjectStatus: function checkProjectStatus() {
            var _this2 = this;

            if (this.project || this.user && this.user.uid) {
                this.ready = true;

                var index = this.pendingCollaborators.findIndex(function (pc) {
                    return (pc.email || '').toLowerCase() === (_this2.user.email || '').toLowerCase();
                });

                if (index > -1) {
                    this.validCollab = this.pendingCollaborators[index];
                }
            }
        }
    },
    components: {
        'core-footer': __WEBPACK_IMPORTED_MODULE_3__components_core_footer___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['project', 'user', 'layers', 'pendingCollaborators'])),
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        next(function (vm) {
            console.log(__WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().currentUser);
            vm.$store.dispatch('setActiveProject', {
                ref: __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.database().ref('projects/' + vm.id),
                options: {}
            });
            vm.$store.dispatch('setActiveUser', {
                ref: __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.database().ref('users/' + __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().currentUser.uid),
                options: {}
            });
        });
    }
};
/* harmony default export */ __webpack_exports__["default"] = (AcceptInviteView);

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_core_nav_main__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_core_nav_main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_core_nav_main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_core_header__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_core_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_core_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_core_footer__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_core_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_core_footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_account_profile_photo__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_account_profile_photo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_account_profile_photo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_account_change_password__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_account_change_password___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_account_change_password__);












var AccountView = {
    name: 'account',
    data: function data() {
        return {
            editingName: false
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['user']), {
        isNameComplete: function isNameComplete() {
            return this.new_username !== '';
        }
    }),
    methods: {
        openDialog: function openDialog() {
            if (this.user.signInMethod === 'email') {
                this.$refs.imageUpload.open();
            }
        },
        editName: function editName() {
            if (this.user.signInMethod === 'email') {
                this.editingName = true;
                this.new_username = this.user.username;
            }
        },
        saveName: function saveName() {
            if (this.new_username !== '') {
                this.$store.dispatch('updateUser', {
                    uid: this.user.uid,
                    update: {
                        username: this.new_username
                    }
                });
            }
            this.editingName = false;
        },
        cancelEditingName: function cancelEditingName() {
            this.editingName = false;
        },
        upgradeSubscription: function upgradeSubscription() {
            window.open('https://www.thecuelist.com/subscribe/');
        }
    },
    components: {
        'core-nav-main': __WEBPACK_IMPORTED_MODULE_3__components_core_nav_main___default.a,
        'core-header': __WEBPACK_IMPORTED_MODULE_4__components_core_header___default.a,
        'core-footer': __WEBPACK_IMPORTED_MODULE_5__components_core_footer___default.a,
        'profile-photo': __WEBPACK_IMPORTED_MODULE_6__components_account_profile_photo___default.a,
        'change-password': __WEBPACK_IMPORTED_MODULE_7__components_account_change_password___default.a
    },
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        next(function (vm) {
            vm.$store.dispatch('setActiveUser', {
                ref: __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.database().ref('users/' + __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().currentUser.uid),
                options: {}
            });
        });
    }
};
/* harmony default export */ __webpack_exports__["default"] = (AccountView);

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__buses_nav__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_core_nav_main__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_core_nav_main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_core_nav_main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_core_header__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_core_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_core_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_core_footer__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_core_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_core_footer__);











var AdminDashboard = {
    name: 'admin',
    props: [],
    data: function data() {
        return {
            project: null
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['user', 'users']), {
        sortedUsers: function sortedUsers() {
            return this.users.sort(function (a, b) {
                if (a.username < b.username) {
                    return -1;
                }
                if (a.username > b.username) {
                    return 1;
                }

                return 0;
            });
        }
    }),
    methods: {
        isAdmin: function isAdmin(user) {
            if (user.admin) {
                return user.admin;
            }
            return false;
        },
        toggleLeftSidenav: function toggleLeftSidenav() {
            __WEBPACK_IMPORTED_MODULE_3__buses_nav__["a" /* default */].$emit('main-nav.open');
        },
        updateUser: function updateUser(user) {
            this.$store.dispatch('updateUser', {
                uid: user.uid,
                update: {
                    active_pay: user.active_pay,
                    stripe_id: user.stripe_id || null
                }
            });
        }
    },
    components: {
        'core-nav-main': __WEBPACK_IMPORTED_MODULE_4__components_core_nav_main___default.a,
        'core-header': __WEBPACK_IMPORTED_MODULE_5__components_core_header___default.a,
        'core-footer': __WEBPACK_IMPORTED_MODULE_6__components_core_footer___default.a
    },
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        next(function (vm) {
            vm.$store.dispatch('setUsersRef', {
                ref: __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.database().ref('users'),
                options: {}
            });
            vm.$store.dispatch('setActiveUser', {
                ref: __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.database().ref('users/' + __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().currentUser.uid),
                options: { readyCallback: function readyCallback() {} }
            });
        });
    }
};

/* harmony default export */ __webpack_exports__["default"] = (AdminDashboard);

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_core_nav_main__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_core_nav_main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_core_nav_main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_core_header__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_core_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_core_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_core_footer__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_core_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_core_footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_dashboard_header__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_dashboard_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_dashboard_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_dashboard_project_box__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_dashboard_project_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_dashboard_project_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_dashboard_project_grid__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_dashboard_project_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_dashboard_project_grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_dashboard_history_box__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_dashboard_history_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_dashboard_history_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_dashboard_pending_projects__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_dashboard_pending_projects___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_dashboard_pending_projects__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modals_create_project__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modals_create_project___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__modals_create_project__);


















var DashboardView = {
    name: 'dashboard',
    data: function data() {
        return {
            ready: false,
            theme: 'default'
        };
    },
    watch: {
        projects: function projects() {
            if (this.projects) {
                this.ready = true;
            }
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['projects', 'mostRecentProject', 'userProjects', 'userPendingInvites', 'user', 'showMode']), {
        displayProjects: function displayProjects() {
            var _this = this;

            return this.userProjects.filter(function (proj) {
                return proj.id !== _this.mostRecentProject.id;
            });
        }
    }),
    methods: {
        toggleShowMode: function toggleShowMode() {
            this.$store.dispatch('updateShowMode', !this.showMode);
            if (this.showMode) {
                this.theme = 'show-mode';
            } else {
                this.theme = 'default';
            }
            __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].material.setCurrentTheme(this.theme);
        },
        openCreateProject: function openCreateProject() {
            this.$refs.createProject.open();
        }
    },
    components: {
        'core-nav-main': __WEBPACK_IMPORTED_MODULE_4__components_core_nav_main___default.a,
        'core-header': __WEBPACK_IMPORTED_MODULE_5__components_core_header___default.a,
        'core-footer': __WEBPACK_IMPORTED_MODULE_6__components_core_footer___default.a,
        'dashboard-header': __WEBPACK_IMPORTED_MODULE_7__components_dashboard_header___default.a,
        'dashboard-project-box': __WEBPACK_IMPORTED_MODULE_8__components_dashboard_project_box___default.a,
        'dashboard-project-grid': __WEBPACK_IMPORTED_MODULE_9__components_dashboard_project_grid___default.a,
        'dashboard-history-box': __WEBPACK_IMPORTED_MODULE_10__components_dashboard_history_box___default.a,
        'dashboard-pending-projects': __WEBPACK_IMPORTED_MODULE_11__components_dashboard_pending_projects___default.a,
        'create-project': __WEBPACK_IMPORTED_MODULE_12__modals_create_project___default.a
    },
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        next(function (vm) {
            vm.$store.dispatch('setProjectsRef', {
                ref: __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.database().ref('projects'),
                options: {}
            });
            vm.$store.dispatch('setUsersRef', {
                ref: __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.database().ref('users'),
                options: {}
            });
            vm.$store.dispatch('setActiveUser', {
                ref: __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.database().ref('users/' + __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().currentUser.uid),
                options: { readyCallback: function readyCallback() {} }
            });
        });
    }
};
/* harmony default export */ __webpack_exports__["default"] = (DashboardView);

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_core_footer__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_core_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_core_footer__);






var ForgotView = {
    name: 'ForgotView',
    data: function data() {
        return {
            email: '',
            sent: false,
            message: ''
        };
    },
    methods: {
        isComplete: function isComplete() {
            return this.email !== '';
        },
        back: function back() {
            this.$router.replace('/login');
        },
        submit: function submit() {
            var _this = this;

            this.message = '';
            __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().sendPasswordResetEmail(this.email).then(function () {
                _this.sent = !_this.sent;
                setTimeout(function () {
                    _this.$router.replace('/login');
                }, 1000);
            }).catch(function (err) {
                _this.message = err.message;
            });
        },
        emailError: function emailError() {
            return this.message !== '';
        }
    },
    components: {
        'core-footer': __WEBPACK_IMPORTED_MODULE_1__components_core_footer___default.a
    }
};
/* harmony default export */ __webpack_exports__["default"] = (ForgotView);

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_core_footer__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_core_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_core_footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_auth_login_form__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_auth_login_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_auth_login_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_auth_register_form__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_auth_register_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_auth_register_form__);








var LoginView = {
    name: 'LoginView',
    data: function data() {
        return {
            signingIn: true
        };
    },
    props: ['redirect'],
    methods: {
        login: function login() {
            var _this = this;

            var self = this;
            var provider = new __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth.GoogleAuthProvider();

            __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().signInWithPopup(provider).then(function (res) {
                var user = res.user;
                user.signInMethod = 'google';
                _this.createUser(user).then(function () {
                    var redirect = self.$route.query.redirect || '/dashboard';
                    self.$router.replace(redirect);
                });
            });
        },
        createUser: function createUser(user) {
            var now = new Date();
            var newUser = {
                username: user.displayName,
                email: user.email,
                profile_picture: user.photoURL,
                uid: user.uid,
                last_login: now.toISOString(),
                active_pay: false,
                subscription_level: 0,
                signInMethod: user.signInMethod
            };

            var usersRef = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.database().ref('users');
            return usersRef.child(user.uid).transaction(function (currentUserData) {
                if (currentUserData === null) {
                    return newUser;
                }

                currentUserData.email = user.email;
                currentUserData.uid = user.uid;
                currentUserData.signInMethod = user.signInMethod;
                currentUserData.username = user.displayName;
                currentUserData.profile_picture = user.photoURL;
                currentUserData.last_login = now.toISOString();
                return currentUserData;
            }, function (error, committed) {
                if (error) {
                    console.log('Transaction failed abnormally!', error);
                }
                return committed;
            });
        },
        toggleRegister: function toggleRegister() {
            this.signingIn = !this.signingIn;
        }
    },
    components: {
        'core-footer': __WEBPACK_IMPORTED_MODULE_1__components_core_footer___default.a,
        'login-form': __WEBPACK_IMPORTED_MODULE_2__components_auth_login_form___default.a,
        'register-form': __WEBPACK_IMPORTED_MODULE_3__components_auth_register_form___default.a
    }
};
/* harmony default export */ __webpack_exports__["default"] = (LoginView);

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfjs_dist_webpack__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfjs_dist_webpack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pdfjs_dist_webpack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__buses_nav__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_core_nav_main__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_core_nav_main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_core_nav_main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_core_header__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_core_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_core_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_core_footer__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_core_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_core_footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_project_header__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_project_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_project_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_project_pages__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_project_pages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_project_pages__);

















__WEBPACK_IMPORTED_MODULE_3_pdfjs_dist_webpack___default.a.workerSrc = '../../../node_modules/pdfjs-dist/build/pdf.worker.js';

var ProjectView = {
    name: 'project',
    props: ['id', 'version'],
    data: function data() {
        return {
            projectRef: __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('projects/' + this.id),
            currentPage: 1,
            pdfPages: [],
            projectPages: [],
            theme: 'default'
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])(['project', 'documentUrl', 'isLocked', 'user', 'showMode']), {
        totalPages: function totalPages() {
            return this.pdfPages.length;
        }
    }),
    watch: {
        project: function project() {
            if (this.project) {
                this.initDocument();
            }
        },
        version: function version() {
            if (this.version) {
                this.$store.dispatch('useVersion', this.version);
            } else {
                this.$store.dispatch('useVersion', null);
            }
        }
    },
    methods: {
        toggleShowMode: function toggleShowMode() {
            this.$store.dispatch('updateShowMode', !this.showMode);
            if (this.showMode) {
                this.theme = 'show-mode';
            } else {
                this.theme = 'default';
            }
            __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].material.setCurrentTheme(this.theme);
        },
        toggleLocked: function toggleLocked() {
            this.$store.dispatch('lockProject', !this.isLocked);
        },
        setCurrentPage: function setCurrentPage(number) {
            this.currentPage = number;
        },
        pageUp: function pageUp() {
            this.currentPage++;
        },
        pageDown: function pageDown() {
            this.currentPage--;
        },

        initDocument: function initDocument() {
            var _this = this;

            if (this.documentUrl) {
                console.log('Initializing Document');
                this.loadDocument(this.documentUrl).then(function (pdfDoc) {
                    var pdfPageProms = [];
                    _this.pdfDoc = pdfDoc;
                    _this.docLoaded = true;

                    for (var i = 1; i < pdfDoc.numPages + 1; i++) {
                        var prom = pdfDoc.getPage(i);
                        pdfPageProms.push(prom);
                    }

                    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(pdfPageProms).then(function (pdfPages) {
                        _this.pdfPages = pdfPages;
                        _this.projectPages = [];

                        pdfPages.forEach(function (page, index) {
                            var newPage = {
                                pageNumber: index + 1,
                                pdfPage: page
                            };
                            _this.projectPages.push(newPage);
                        });
                    });
                });
            } else {
                console.error('Could not init document');
            }
        },
        loadDocument: function loadDocument(documentSrc) {
            var _this2 = this;

            this.pdfDoc = null;

            var loadingTask = __WEBPACK_IMPORTED_MODULE_3_pdfjs_dist_webpack___default.a.getDocument(documentSrc);

            loadingTask.onProgress = function (status) {
                var ratio = status.loaded / status.total;
                _this2.loadingProgress = Math.min(ratio, 1);
            };

            return loadingTask;
        }
    },
    components: {
        'core-nav-main': __WEBPACK_IMPORTED_MODULE_7__components_core_nav_main___default.a,
        'core-header': __WEBPACK_IMPORTED_MODULE_8__components_core_header___default.a,
        'core-footer': __WEBPACK_IMPORTED_MODULE_9__components_core_footer___default.a,
        'project-header': __WEBPACK_IMPORTED_MODULE_10__components_project_header___default.a,
        'project-pages': __WEBPACK_IMPORTED_MODULE_11__components_project_pages___default.a
    },
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        next(function (vm) {
            vm.$store.dispatch('setUsersRef', {
                ref: __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('users'),
                options: {}
            });
            vm.$store.dispatch('setActiveUser', {
                ref: __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('users/' + __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth().currentUser.uid),
                options: { readyCallback: function readyCallback() {} }
            });
            vm.$store.dispatch('setActiveProject', {
                ref: __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('projects/' + vm.id),
                options: { readyCallback: function readyCallback() {
                        console.log('project should be ready');
                    } }
            });
        });
    },
    created: function created() {
        var _this3 = this;

        if (this.version) {
            this.$store.dispatch('useVersion', this.version);
        } else {
            this.$store.dispatch('useVersion', null);
        }

        __WEBPACK_IMPORTED_MODULE_6__buses_nav__["a" /* default */].$on('goToPage', function (e) {
            _this3.currentPage = e;
        });
    }
};

/* harmony default export */ __webpack_exports__["default"] = (ProjectView);

/***/ }),
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 496 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 497 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 498 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 499 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 500 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 501 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 502 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 503 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 504 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 505 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 506 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 507 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 508 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 509 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 512 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 513 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 514 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 515 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 516 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 517 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 518 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 520 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 521 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 522 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 523 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 524 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 525 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 526 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 527 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 528 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 529 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 530 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 531 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 532 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 533 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 534 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 535 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 536 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 537 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 538 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 539 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 540 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 541 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 542 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 543 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 544 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 545 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 546 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 547 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 548 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 549 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 550 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 551 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 162,
	"./af.js": 162,
	"./ar": 169,
	"./ar-dz": 163,
	"./ar-dz.js": 163,
	"./ar-kw": 164,
	"./ar-kw.js": 164,
	"./ar-ly": 165,
	"./ar-ly.js": 165,
	"./ar-ma": 166,
	"./ar-ma.js": 166,
	"./ar-sa": 167,
	"./ar-sa.js": 167,
	"./ar-tn": 168,
	"./ar-tn.js": 168,
	"./ar.js": 169,
	"./az": 170,
	"./az.js": 170,
	"./be": 171,
	"./be.js": 171,
	"./bg": 172,
	"./bg.js": 172,
	"./bm": 173,
	"./bm.js": 173,
	"./bn": 174,
	"./bn.js": 174,
	"./bo": 175,
	"./bo.js": 175,
	"./br": 176,
	"./br.js": 176,
	"./bs": 177,
	"./bs.js": 177,
	"./ca": 178,
	"./ca.js": 178,
	"./cs": 179,
	"./cs.js": 179,
	"./cv": 180,
	"./cv.js": 180,
	"./cy": 181,
	"./cy.js": 181,
	"./da": 182,
	"./da.js": 182,
	"./de": 185,
	"./de-at": 183,
	"./de-at.js": 183,
	"./de-ch": 184,
	"./de-ch.js": 184,
	"./de.js": 185,
	"./dv": 186,
	"./dv.js": 186,
	"./el": 187,
	"./el.js": 187,
	"./en-au": 188,
	"./en-au.js": 188,
	"./en-ca": 189,
	"./en-ca.js": 189,
	"./en-gb": 190,
	"./en-gb.js": 190,
	"./en-ie": 191,
	"./en-ie.js": 191,
	"./en-il": 192,
	"./en-il.js": 192,
	"./en-nz": 193,
	"./en-nz.js": 193,
	"./eo": 194,
	"./eo.js": 194,
	"./es": 197,
	"./es-do": 195,
	"./es-do.js": 195,
	"./es-us": 196,
	"./es-us.js": 196,
	"./es.js": 197,
	"./et": 198,
	"./et.js": 198,
	"./eu": 199,
	"./eu.js": 199,
	"./fa": 200,
	"./fa.js": 200,
	"./fi": 201,
	"./fi.js": 201,
	"./fo": 202,
	"./fo.js": 202,
	"./fr": 205,
	"./fr-ca": 203,
	"./fr-ca.js": 203,
	"./fr-ch": 204,
	"./fr-ch.js": 204,
	"./fr.js": 205,
	"./fy": 206,
	"./fy.js": 206,
	"./gd": 207,
	"./gd.js": 207,
	"./gl": 208,
	"./gl.js": 208,
	"./gom-latn": 209,
	"./gom-latn.js": 209,
	"./gu": 210,
	"./gu.js": 210,
	"./he": 211,
	"./he.js": 211,
	"./hi": 212,
	"./hi.js": 212,
	"./hr": 213,
	"./hr.js": 213,
	"./hu": 214,
	"./hu.js": 214,
	"./hy-am": 215,
	"./hy-am.js": 215,
	"./id": 216,
	"./id.js": 216,
	"./is": 217,
	"./is.js": 217,
	"./it": 218,
	"./it.js": 218,
	"./ja": 219,
	"./ja.js": 219,
	"./jv": 220,
	"./jv.js": 220,
	"./ka": 221,
	"./ka.js": 221,
	"./kk": 222,
	"./kk.js": 222,
	"./km": 223,
	"./km.js": 223,
	"./kn": 224,
	"./kn.js": 224,
	"./ko": 225,
	"./ko.js": 225,
	"./ky": 226,
	"./ky.js": 226,
	"./lb": 227,
	"./lb.js": 227,
	"./lo": 228,
	"./lo.js": 228,
	"./lt": 229,
	"./lt.js": 229,
	"./lv": 230,
	"./lv.js": 230,
	"./me": 231,
	"./me.js": 231,
	"./mi": 232,
	"./mi.js": 232,
	"./mk": 233,
	"./mk.js": 233,
	"./ml": 234,
	"./ml.js": 234,
	"./mn": 235,
	"./mn.js": 235,
	"./mr": 236,
	"./mr.js": 236,
	"./ms": 238,
	"./ms-my": 237,
	"./ms-my.js": 237,
	"./ms.js": 238,
	"./mt": 239,
	"./mt.js": 239,
	"./my": 240,
	"./my.js": 240,
	"./nb": 241,
	"./nb.js": 241,
	"./ne": 242,
	"./ne.js": 242,
	"./nl": 244,
	"./nl-be": 243,
	"./nl-be.js": 243,
	"./nl.js": 244,
	"./nn": 245,
	"./nn.js": 245,
	"./pa-in": 246,
	"./pa-in.js": 246,
	"./pl": 247,
	"./pl.js": 247,
	"./pt": 249,
	"./pt-br": 248,
	"./pt-br.js": 248,
	"./pt.js": 249,
	"./ro": 250,
	"./ro.js": 250,
	"./ru": 251,
	"./ru.js": 251,
	"./sd": 252,
	"./sd.js": 252,
	"./se": 253,
	"./se.js": 253,
	"./si": 254,
	"./si.js": 254,
	"./sk": 255,
	"./sk.js": 255,
	"./sl": 256,
	"./sl.js": 256,
	"./sq": 257,
	"./sq.js": 257,
	"./sr": 259,
	"./sr-cyrl": 258,
	"./sr-cyrl.js": 258,
	"./sr.js": 259,
	"./ss": 260,
	"./ss.js": 260,
	"./sv": 261,
	"./sv.js": 261,
	"./sw": 262,
	"./sw.js": 262,
	"./ta": 263,
	"./ta.js": 263,
	"./te": 264,
	"./te.js": 264,
	"./tet": 265,
	"./tet.js": 265,
	"./tg": 266,
	"./tg.js": 266,
	"./th": 267,
	"./th.js": 267,
	"./tl-ph": 268,
	"./tl-ph.js": 268,
	"./tlh": 269,
	"./tlh.js": 269,
	"./tr": 270,
	"./tr.js": 270,
	"./tzl": 271,
	"./tzl.js": 271,
	"./tzm": 273,
	"./tzm-latn": 272,
	"./tzm-latn.js": 272,
	"./tzm.js": 273,
	"./ug-cn": 274,
	"./ug-cn.js": 274,
	"./uk": 275,
	"./uk.js": 275,
	"./ur": 276,
	"./ur.js": 276,
	"./uz": 278,
	"./uz-latn": 277,
	"./uz-latn.js": 277,
	"./uz.js": 278,
	"./vi": 279,
	"./vi.js": 279,
	"./x-pseudo": 280,
	"./x-pseudo.js": 280,
	"./yo": 281,
	"./yo.js": 281,
	"./zh-cn": 282,
	"./zh-cn.js": 282,
	"./zh-hk": 283,
	"./zh-hk.js": 283,
	"./zh-tw": 284,
	"./zh-tw.js": 284
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 558;

/***/ }),
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cuelistWHITE.6170c5e.png";

/***/ }),
/* 580 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(496)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(633),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(518)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(654),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(533)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(394),
  /* template */
  __webpack_require__(669),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(522)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(658),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(529)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(665),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(541)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(399),
  /* template */
  __webpack_require__(677),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(525)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(400),
  /* template */
  __webpack_require__(661),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(512)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(404),
  /* template */
  __webpack_require__(648),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(509)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(405),
  /* template */
  __webpack_require__(645),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(540)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(406),
  /* template */
  __webpack_require__(676),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(508)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(408),
  /* template */
  __webpack_require__(644),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(514)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(410),
  /* template */
  __webpack_require__(650),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(531)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(411),
  /* template */
  __webpack_require__(667),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(497)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(412),
  /* template */
  __webpack_require__(634),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(537)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(413),
  /* template */
  __webpack_require__(673),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(535)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(414),
  /* template */
  __webpack_require__(671),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(504)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(416),
  /* template */
  __webpack_require__(640),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(510)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(417),
  /* template */
  __webpack_require__(646),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(495)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(418),
  /* template */
  __webpack_require__(632),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(526)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(419),
  /* template */
  __webpack_require__(662),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(502)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(420),
  /* template */
  __webpack_require__(638),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(536)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(421),
  /* template */
  __webpack_require__(672),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(547)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(422),
  /* template */
  __webpack_require__(683),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(507)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(423),
  /* template */
  __webpack_require__(643),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(499)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(425),
  /* template */
  __webpack_require__(635),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(517)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(426),
  /* template */
  __webpack_require__(653),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(543)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(427),
  /* template */
  __webpack_require__(679),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(515)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(429),
  /* template */
  __webpack_require__(651),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(546)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(430),
  /* template */
  __webpack_require__(682),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(506)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(431),
  /* template */
  __webpack_require__(642),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(524)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(432),
  /* template */
  __webpack_require__(660),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(545)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(433),
  /* template */
  __webpack_require__(681),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(521)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(657),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(538)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(435),
  /* template */
  __webpack_require__(674),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(527)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(436),
  /* template */
  __webpack_require__(663),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(532)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(437),
  /* template */
  __webpack_require__(668),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(503)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(438),
  /* template */
  __webpack_require__(639),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(544)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(439),
  /* template */
  __webpack_require__(680),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(539)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(440),
  /* template */
  __webpack_require__(675),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(516)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(652),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(513)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(442),
  /* template */
  __webpack_require__(649),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(530)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(443),
  /* template */
  __webpack_require__(666),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(519)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(444),
  /* template */
  __webpack_require__(655),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(520)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(445),
  /* template */
  __webpack_require__(656),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(523)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(659),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(498)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(390),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 632 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-sidenav', {
    ref: "layerNav",
    staticClass: "md-left"
  }, [_c('md-toolbar', {
    staticClass: "md-dense main-toolbar"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('h3', {
    staticClass: "md-title"
  }, [_vm._v("Layers")])], 1), _vm._v(" "), _c('layer-list', {
    attrs: {
      "project": _vm.project,
      "layers": _vm.layers
    },
    on: {
      "showLayer": _vm.showLayer,
      "hideLayer": _vm.hideLayer
    }
  }), _vm._v(" "), (_vm.validLayers.length > 0) ? _c('layer-picker', {
    attrs: {
      "layers": _vm.validLayers,
      "currentLayer": _vm.currentLayer
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canEdit) ? _c('layer-new', {
    attrs: {
      "project": _vm.project
    },
    on: {
      "showLayer": _vm.showLayer,
      "addLayer": _vm.addLayer
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 633 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "validate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.currentPasswordError()
    }
  }, [_c('label', [_vm._v("Current Password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.currentPassword),
      callback: function($$v) {
        _vm.currentPassword = $$v
      },
      expression: "currentPassword"
    }
  }), _vm._v(" "), (_vm.currentPasswordError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()], 1), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.newPasswordError()
    }
  }, [_c('label', [_vm._v("New Password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  }), _vm._v(" "), (_vm.newPasswordError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()], 1), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.confirmPasswordError()
    }
  }, [_c('label', [_vm._v("Re-Type Password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.confirmPassword),
      callback: function($$v) {
        _vm.confirmPassword = $$v
      },
      expression: "confirmPassword"
    }
  }), _vm._v(" "), (_vm.confirmPasswordError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("Passwords do not match")]) : _vm._e()], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Submit")])], 1)
},staticRenderFns: []}

/***/ }),
/* 634 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-dialog-confirm', {
    ref: "promoteVersionDialog",
    attrs: {
      "md-title": _vm.confirmPromote.title,
      "md-content-html": _vm.confirmPromote.content,
      "md-ok-text": _vm.confirmPromote.ok,
      "md-cancel-text": _vm.confirmPromote.cancel
    },
    on: {
      "close": _vm.promoteVersionConfirm
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "deleteVersionDialog",
    attrs: {
      "md-title": _vm.confirmDelete.title,
      "md-content-html": _vm.confirmDelete.content,
      "md-ok-text": _vm.confirmDelete.ok,
      "md-cancel-text": _vm.confirmDelete.cancel
    },
    on: {
      "close": _vm.deleteVersionConfirm
    }
  }), _vm._v(" "), _c('md-sidenav', {
    ref: "versionsNav",
    staticClass: "md-left"
  }, [_c('md-toolbar', {
    staticClass: "md-dense main-toolbar"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('h3', {
    staticClass: "md-title"
  }, [_vm._v("History")])], 1), _vm._v(" "), (_vm.user.active_pay) ? _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.saveVersion($event)
      }
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Version Name")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.versionTitle),
      callback: function($$v) {
        _vm.versionTitle = $$v
      },
      expression: "versionTitle"
    }
  })], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": _vm.saveVersion
    }
  }, [_vm._v("Save New Version")])], 1) : _vm._e(), _vm._v(" "), _c('md-list', {
    staticClass: "ql-version-list md-double-line"
  }, [_c('md-list-item', [_c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_vm._v("Current Version")]), _vm._v(" "), (!_vm.currentVersion) ? _c('span', [_vm._v("Live Edit")]) : _c('span', [_vm._v(_vm._s(_vm.currentVersion.name))])])]), _vm._v(" "), _c('md-list-item', [(!_vm.currentVersion) ? _c('md-icon', [_vm._v("label")]) : _c('md-icon', [_vm._v("label_outline")]), _vm._v(" "), _c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_vm._v("Live Version")])]), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button md-list-action",
    on: {
      "click": function($event) {
        _vm.setActiveVersion(null)
      }
    }
  }, [_c('md-icon', [_vm._v("launch")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("Show Version")])], 1)], 1), _vm._v(" "), _c('md-list', _vm._l((_vm.days), function(filteredVersions, day) {
    return _c('md-list-item', {
      key: day,
      attrs: {
        "md-expand-multiple": ""
      }
    }, [_c('span', [_c('strong', [_vm._v(_vm._s(day))])]), _vm._v(" "), _c('md-list-expand', [_c('md-list', _vm._l((filteredVersions), function(version) {
      return _c('version-element', {
        key: version.id,
        attrs: {
          "project": _vm.project,
          "version": version
        },
        on: {
          "promoteVersion": _vm.promoteVersion,
          "deleteVersion": _vm.deleteVersion
        }
      })
    }))], 1)], 1)
  }))], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 635 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('vue-draggable-resizable', {
    staticClass: "ql-position-cue-marker",
    style: ({
      backgroundColor: _vm.cueColor(_vm.cue)
    }),
    attrs: {
      "handles": [],
      "x": _vm.cuePosLeft,
      "y": _vm.cuePosTop,
      "w": _vm.cue.width || 20,
      "h": _vm.cue.height || 20,
      "minw": 10,
      "minh": 10,
      "parent": true,
      "draggable": _vm.editable && !_vm.locked
    },
    on: {
      "dragging": _vm.onDrag,
      "dragstop": _vm.onDragStop,
      "activated": _vm.onActivate,
      "deactivated": _vm.onDeactivate
    }
  }, [(!_vm.locked && _vm.editable) ? _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("Move")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 636 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.user.active_pay) ? _c('md-list-item', [_c('md-subheader', {
    staticClass: "ql-invite-header"
  }, [_vm._v("Invite Collaborators")]), _vm._v(" "), _c('md-list-expand', {
    staticClass: "ql-invite-form"
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Find Existing User")]), _vm._v(" "), _c('md-autocomplete', {
    attrs: {
      "fetch": _vm.filter,
      "print-attribute": "username",
      "min-chars": 0,
      "max-height": 6,
      "max-res": 0,
      "debounce": 500,
      "width": "100%"
    },
    on: {
      "selected": _vm.inviteCallback
    },
    model: {
      value: (_vm.autoCompleteInvitee),
      callback: function($$v) {
        _vm.autoCompleteInvitee = $$v
      },
      expression: "autoCompleteInvitee"
    }
  })], 1), _vm._v(" "), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.inviting),
      expression: "!inviting"
    }],
    attrs: {
      "nvalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.inviteNew($event)
      }
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "email",
      "required": ""
    },
    model: {
      value: (_vm.newInvitee.email),
      callback: function($$v) {
        _vm.$set(_vm.newInvitee, "email", $$v)
      },
      expression: "newInvitee.email"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.newInvitee.name),
      callback: function($$v) {
        _vm.$set(_vm.newInvitee, "name", $$v)
      },
      expression: "newInvitee.name"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Role")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.newInvitee.role),
      callback: function($$v) {
        _vm.$set(_vm.newInvitee, "role", $$v)
      },
      expression: "newInvitee.role"
    }
  })], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised",
    attrs: {
      "type": "submit"
    }
  }, [_c('md-icon', [_vm._v("person_add")]), _vm._v(" Send Invite")], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised",
    on: {
      "click": _vm.resetInvitee
    }
  }, [_vm._v("Clear")])], 1), _vm._v(" "), _c('md-spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inviting && !_vm.emailSent),
      expression: "inviting && !emailSent"
    }],
    attrs: {
      "md-indeterminate": ""
    }
  }), _vm._v(" "), _c('md-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inviting && _vm.emailSent),
      expression: "inviting && emailSent"
    }],
    attrs: {
      "id": "done-icon"
    }
  }, [_vm._v("done")])], 1)], 1)], 1) : _c('md-list-item', [_c('md-subheader', {
    staticClass: "ql-invite-header"
  }, [_vm._v("Invite Collaborators (disabled)")])], 1)
},staticRenderFns: []}

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-sidenav', {
    ref: "leftSidenav",
    staticClass: "md-left",
    on: {
      "open": function($event) {
        _vm.open()
      },
      "close": function($event) {
        _vm.close()
      }
    }
  }, [_c('md-toolbar', {
    staticClass: "md-large main-toolbar"
  }, [_c('div', {
    staticClass: "md-toolbar-container ql-toolbar-logo"
  }, [_c('h1', [_c('img', {
    staticClass: "logo-text",
    attrs: {
      "src": __webpack_require__(580),
      "alt": "cuelisttext"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(294),
      "alt": "cuelist"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "md-toolbar-container ql-toolbar-avatar"
  }, [_c('md-avatar', {
    staticClass: "md-small"
  }, [(_vm.user.profile_picture) ? _c('img', {
    attrs: {
      "src": _vm.user.profile_picture,
      "alt": "People"
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__(49),
      "alt": "People"
    }
  })]), _vm._v(" "), (_vm.user.username) ? _c('div', {
    staticClass: "md-subtitle avatar-name-role"
  }, [_vm._v(_vm._s(_vm.user.username))]) : _c('div', {
    staticClass: "md-subtitle avatar-name-role"
  }, [_vm._v("Cuelist User")])], 1)]), _vm._v(" "), _c('md-list', [_c('router-link', {
    attrs: {
      "to": {
        name: 'dashboard'
      },
      "tag": "md-list-item"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.projectsClick()
      }
    }
  }, [_vm._v("All Projects")])]), _vm._v(" "), (_vm.project) ? _c('md-list-item', [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.project.title))])])]) : _vm._e(), _vm._v(" "), (_vm.project) ? _c('md-list-item', [_c('md-list', [_c('md-list-item', {
    on: {
      "click": function($event) {
        _vm.collaboratorsClick()
      }
    }
  }, [_c('span', [_vm._v("Collaborators")])]), _vm._v(" "), _c('md-list-item', {
    on: {
      "click": function($event) {
        _vm.layersClick()
      }
    }
  }, [_c('span', [_vm._v("Layers")])]), _vm._v(" "), _c('md-list-item', {
    on: {
      "click": function($event) {
        _vm.historyClick()
      }
    }
  }, [_c('span', [_vm._v("History")])]), _vm._v(" "), _c('md-list-item', {
    on: {
      "click": function($event) {
        _vm.projectSettingsClick()
      }
    }
  }, [_c('span', [_vm._v("Project Settings")])]), _vm._v(" "), _c('md-list-item', {
    on: {
      "click": function($event) {
        _vm.printClick()
      }
    }
  }, [_c('span', [_vm._v("Print")])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "md-list-item",
      "to": {
        name: 'account'
      }
    }
  }, [_c('span', [_vm._v("Account Settings")])]), _vm._v(" "), (_vm.user.admin) ? _c('router-link', {
    attrs: {
      "tag": "md-list-item",
      "to": {
        name: 'admin'
      }
    }
  }, [_c('span', [_vm._v("Admin Dashboard")])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "md-list-item"
  }, [_c('div', {
    staticClass: "md-button md-list-item-container"
  }, [_c('span', [_vm._v("Help")])]), _vm._v(" "), _c('md-button', {
    staticClass: "md-button-ghost",
    on: {
      "click": _vm.helpClick
    }
  })], 1), _vm._v(" "), _c('md-list-item', {
    on: {
      "click": function($event) {
        _vm.logoutClick()
      }
    }
  }, [_c('span', [_vm._v("Log Out")])])], 1)], 1), _vm._v(" "), (_vm.project) ? _c('layers-nav', {
    attrs: {
      "project": _vm.project,
      "user": _vm.user
    }
  }) : _vm._e(), _vm._v(" "), (_vm.project) ? _c('collaborators-nav', {
    attrs: {
      "project": _vm.project,
      "user": _vm.user
    }
  }) : _vm._e(), _vm._v(" "), (_vm.project) ? _c('print-nav', {
    attrs: {
      "project": _vm.project,
      "user": _vm.user
    }
  }) : _vm._e(), _vm._v(" "), (_vm.project) ? _c('project-settings-nav', {
    attrs: {
      "project": _vm.project,
      "user": _vm.user
    }
  }) : _vm._e(), _vm._v(" "), (_vm.project) ? _c('history-nav', {
    attrs: {
      "project": _vm.project,
      "user": _vm.user
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 638 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-sidenav', {
    ref: "projectSettingsNav",
    staticClass: "md-left"
  }, [_c('md-dialog-confirm', {
    ref: "deleteProjectDialog",
    attrs: {
      "md-title": _vm.confirm.title,
      "md-content-html": _vm.getConfirmContent(),
      "md-ok-text": _vm.confirm.ok,
      "md-cancel-text": _vm.confirm.cancel
    },
    on: {
      "close": _vm.deleteProjectConfirm
    }
  }), _vm._v(" "), _c('md-toolbar', {
    staticClass: "md-dense main-toolbar"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('h3', {
    staticClass: "md-title"
  }, [_vm._v("Project Settings")])], 1), _vm._v(" "), (_vm.ownerUID === _vm.user.uid) ? _c('md-layout', {
    attrs: {
      "md-flex": "90",
      "md-flex-offset": "5"
    }
  }, [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.open($event)
      }
    }
  }, [_c('h1', {
    staticClass: "md-title"
  }, [_vm._v("Project Name")]), _vm._v(" "), _c('md-input-container', [_c('md-input', {
    model: {
      value: (_vm.title),
      callback: function($$v) {
        _vm.title = $$v
      },
      expression: "title"
    }
  })], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": _vm.updateTitle
    }
  }, [_vm._v("Rename")])], 1)]) : _c('md-layout', {
    attrs: {
      "md-column": "",
      "md-flex": "90",
      "md-flex-offset": "5"
    }
  }, [_c('h1', {
    staticClass: "md-title"
  }, [_vm._v("Project Name")]), _vm._v(" "), _c('span', {
    staticClass: "md-body-2"
  }, [_vm._v(_vm._s(_vm.project.title))])])], 1)
},staticRenderFns: []}

/***/ }),
/* 639 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-dialog-content', [_c('p', [_vm._v("Create Your Project")]), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Project Name")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.project.title),
      callback: function($$v) {
        _vm.$set(_vm.project, "title", $$v)
      },
      expression: "project.title"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("File")]), _vm._v(" "), _c('md-file', {
    attrs: {
      "required": ""
    },
    on: {
      "selected": _vm.onFileChange
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 640 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ql-nav-layer-picker"
  }, [_c('h2', {
    staticClass: "md-title"
  }, [_vm._v("Active Layer")]), _vm._v(" "), _c('md-menu', {
    ref: "layerMenu",
    attrs: {
      "md-size": "6"
    }
  }, [(_vm.currentLayer) ? _c('md-button', {
    staticClass: "pick-current-layer",
    style: ({
      backgroundColor: _vm.currentLayer.color
    }),
    attrs: {
      "md-menu-trigger": ""
    }
  }) : _c('md-button', {
    staticClass: "blank-current-layer",
    attrs: {
      "md-menu-trigger": ""
    }
  }, [_c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("Please choose an active layer.")])], 1), _vm._v(" "), (_vm.currentLayer) ? _c('span', {
    staticClass: "current-layer-name"
  }, [_vm._v(_vm._s(_vm.currentLayer.title))]) : _c('span', {
    staticClass: "current-layer-name"
  }, [_vm._v("Select an active layer")]), _vm._v(" "), _c('md-menu-content', _vm._l((_vm.layers), function(layer) {
    return _c('md-menu-item', {
      key: layer.id,
      on: {
        "selected": function($event) {
          _vm.selectLayer(layer)
        }
      }
    }, [_c('span', {
      staticClass: "ql-nav-layer-picker-item",
      style: (_vm.style(layer))
    }), _vm._v(" "), _c('span', {
      staticClass: "ql-nav-layer-picker-option"
    }, [_vm._v(_vm._s(layer.title))])])
  }))], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 641 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-list', {
    staticClass: "md-triple-line"
  }, _vm._l((_vm.mutations), function(mutation) {
    return _c('md-list-item', {
      key: mutation.id
    }, [_c('div', {
      staticClass: "md-list-text-container"
    }, [_c('span', [_vm._v(_vm._s(mutation.project.title) + " "), _c('span', {
      staticClass: "md-caption"
    }, [_vm._v(_vm._s(mutation.version.version))])]), _vm._v(" "), _c('span', [_vm._v("Changed By: " + _vm._s(mutation.mutation.user))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(mutation.mutation.date.toDateString()))])])])
  }))
},staticRenderFns: []}

/***/ }),
/* 642 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-card', {
    staticClass: "ql-page",
    attrs: {
      "id": "ql-page"
    }
  }, [_c('md-dialog', {
    ref: "no-layers-dialog",
    attrs: {
      "md-open-from": ("cardCover" + _vm.pageNumber),
      "md-close-to": ("cardCover" + _vm.pageNumber)
    }
  }, [_c('md-dialog-title', [_vm._v("You don't have a current layer!")]), _vm._v(" "), _c('md-dialog-content', [_vm._v("Open up the layers menu and choose a layer to edit.")]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.closeDialog('no-layers-dialog')
      }
    }
  }, [_vm._v("Ok")])], 1)], 1), _vm._v(" "), _c('md-card-media-cover', {
    ref: "cardCover",
    staticClass: "ql-page-cover",
    attrs: {
      "id": ("cardCover" + _vm.pageNumber)
    }
  }, [(_vm.ready) ? _c('project-pdf-page', {
    staticClass: "ql-pdf-page",
    class: {
      'night-mode': _vm.showMode, 'disable-text': _vm.disableText
    },
    attrs: {
      "page": _vm.page,
      "pageWidth": _vm.pageWidth,
      "pageHeight": _vm.pageHeight
    },
    on: {
      "pdfLoaded": _vm.pdfLoaded,
      "rightclick": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.rightClick($event)
      },
      "cueCreated": _vm.cueCreated
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.ready) ? _c('p', [_vm._v("Loading PDF...")]) : _vm._e(), _vm._v(" "), _c('resize-sensor', {
    on: {
      "resize": _vm.resize
    }
  })], 1), _vm._v(" "), (_vm.pageReady) ? _c('div', {
    staticClass: "marker-container",
    style: ({
      left: (_vm.offsetX + "px"),
      width: (_vm.pdfWidth + "px")
    })
  }, [_vm._l((_vm.positionCues), function(cue) {
    return _c('cue-position-marker', {
      key: ("" + (cue.id) + _vm.versionID),
      attrs: {
        "cue": cue,
        "editable": _vm.isCueEditable(cue),
        "locked": _vm.locked,
        "pageWidth": _vm.pageWidth,
        "pageHeight": _vm.pageHeight
      },
      on: {
        "updateCue": _vm.updateCue,
        "activated": function($event) {
          _vm.disableText = true
        },
        "deactivated": function($event) {
          _vm.disableText = false
        }
      }
    })
  }), _vm._v(" "), _vm._l((_vm.selectionCues), function(cue) {
    return _c('cue-selection-marker', {
      key: ("" + (cue.id) + _vm.versionID),
      attrs: {
        "cue": cue,
        "editable": _vm.isCueEditable(cue),
        "locked": _vm.locked,
        "pageWidth": _vm.pageWidth,
        "pageHeight": _vm.pageHeight
      },
      on: {
        "updateCue": _vm.updateCue,
        "activated": function($event) {
          _vm.disableText = true
        },
        "deactivated": function($event) {
          _vm.disableText = false
        }
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), (_vm.addingCue) ? _c('project-cues-add-cue-button', {
    staticClass: "ql-add-cue-button",
    style: ({
      top: (_vm.addCueY + "px"),
      left: (_vm.addCueX + "px")
    }),
    attrs: {
      "cueToAdd": _vm.cueToAdd
    },
    on: {
      "cancel": _vm.cancelAddCue,
      "addText": _vm.addText,
      "addCue": _vm.addCue
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageReady) ? _c('div', {
    staticClass: "ql-note-container",
    style: ({
      left: (_vm.offsetX + "px"),
      width: (_vm.pdfWidth + "px")
    })
  }, _vm._l((_vm.displayNotes), function(note) {
    return _c('project-note', {
      key: ("" + (note.id) + _vm.versionID),
      attrs: {
        "note": note,
        "locked": !_vm.isNoteEditable(note) || _vm.locked,
        "pageWidth": _vm.pageWidth,
        "pageHeight": _vm.pageHeight
      },
      on: {
        "updateNote": _vm.updateNote,
        "activated": function($event) {
          _vm.disableText = true
        },
        "deactivated": function($event) {
          _vm.disableText = false
        }
      }
    })
  })) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 643 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-toolbar', {
    staticClass: "md-dense ql-cue-header",
    style: (_vm.style())
  }, [_c('layer-picker', {
    attrs: {
      "currentLayer": _vm.layer,
      "layers": _vm.layers,
      "editable": _vm.editable,
      "locked": _vm.locked
    },
    on: {
      "selectLayer": _vm.selectLayer
    }
  }), _vm._v(" "), (_vm.editable && !_vm.locked) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editing),
      expression: "!editing"
    }],
    staticClass: "md-body-1 cue-header-title",
    on: {
      "click": _vm.edit
    }
  }, [_vm._v(_vm._s(_vm.cue.title) + "\r\n        "), _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("Click to edit")])], 1) : _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editing),
      expression: "!editing"
    }],
    staticClass: "md-body-1 cue-header-title"
  }, [_vm._v(_vm._s(_vm.cue.title))]), _vm._v(" "), (_vm.editing) ? _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.submit($event)
      },
      "keyup": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.keyPress($event)
      }
    }
  }, [_c('md-input-container', [_c('md-input', {
    model: {
      value: (_vm.cue.title),
      callback: function($$v) {
        _vm.$set(_vm.cue, "title", $$v)
      },
      expression: "cue.title"
    }
  }), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("Enter to save, Escape to cancel")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.expanded),
      expression: "!expanded"
    }],
    staticClass: "md-icon-button",
    on: {
      "click": _vm.toggle
    }
  }, [_c('md-icon', [_vm._v("keyboard_arrow_down")])], 1), _vm._v(" "), _c('md-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.expanded),
      expression: "expanded"
    }],
    staticClass: "md-icon-button",
    on: {
      "click": _vm.toggle
    }
  }, [_c('md-icon', [_vm._v("keyboard_arrow_up")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 644 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    attrs: {
      "md-flex": "100",
      "md-gutter": "16"
    }
  }, _vm._l((_vm.projects), function(project) {
    return _c('md-layout', {
      key: project.id,
      staticClass: "project-box-container",
      attrs: {
        "md-flex": "25"
      }
    }, [_c('dashboard-project-box', {
      attrs: {
        "project": project
      }
    })], 1)
  }))
},staticRenderFns: []}

/***/ }),
/* 645 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-whiteframe', {
    staticClass: "history-box"
  }, [_c('md-card', {
    staticClass: "history-box-content"
  }, [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Recent Changes")])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 646 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-list-item', {
    ref: "colorPicker",
    staticClass: "ql-layer-menu-item"
  }, [_c('md-button', {
    staticClass: "ql-color-picker-choice",
    style: (_vm.style()),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.toggleVisibility($event)
      }
    }
  }, [(!_vm.viewable) ? _c('md-icon', [_vm._v("visibility_off")]) : _vm._e(), _vm._v(" "), (_vm.viewable && !_vm.showNotes) ? _c('md-icon', [_vm._v("speaker_notes_off")]) : _c('md-icon')], 1), _vm._v(" "), (_vm.editable) ? _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.saveTitle($event)
      },
      "keyup": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.keyPress($event)
      }
    }
  }, [(!_vm.editing) ? _c('span', {
    on: {
      "click": function($event) {
        _vm.edit()
      }
    }
  }, [_vm._v(_vm._s(_vm.layer.title) + "\n            "), _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("click to edit title")])], 1) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('md-input-container', [_c('md-input', {
    attrs: {
      "value": _vm.layer.title
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    },
    model: {
      value: (_vm.layer.title),
      callback: function($$v) {
        _vm.$set(_vm.layer, "title", $$v)
      },
      expression: "layer.title"
    }
  })], 1) : _vm._e()], 1) : _c('span', {
    staticStyle: {
      "width": "100%",
      "padding-left": "15px"
    }
  }, [_vm._v(" " + _vm._s(_vm.layer.title) + "\n        "), _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("No Edit Permissions")])], 1), _vm._v(" "), (_vm.editing) ? _c('md-button', {
    staticClass: "md-icon-button md-list-action",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.saveTitle($event)
      }
    }
  }, [_c('md-icon', [_vm._v("save")])], 1) : _vm._e(), _vm._v(" "), _c('md-list-expand', [_c('md-list', {
    staticClass: "sub-list"
  }, [(_vm.viewable) ? _c('md-list-item', {
    on: {
      "click": _vm.hide
    }
  }, [_vm._v("\n                Hide Layer\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.viewable) ? _c('md-list-item', {
    on: {
      "click": _vm.show
    }
  }, [_vm._v("\n                Show Layer\n            ")]) : _vm._e(), _vm._v(" "), (_vm.showNotes) ? _c('md-list-item', {
    on: {
      "click": _vm.hideText
    }
  }, [_vm._v("\n                Hide Text\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.showNotes) ? _c('md-list-item', {
    on: {
      "click": _vm.showText
    }
  }, [_vm._v("\n                Show Text\n            ")]) : _vm._e(), _vm._v(" "), (_vm.editable) ? _c('md-list-item', [_vm._v("\n                Change Color\n                "), _c('md-list-expand', [_c('md-list', [_c('md-list-item', [_c('color-picker', {
    on: {
      "input": _vm.pickColor
    },
    model: {
      value: (_vm.colors),
      callback: function($$v) {
        _vm.colors = $$v
      },
      expression: "colors"
    }
  }), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("click to change color theme")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.editable) ? _c('md-list-item', {
    on: {
      "click": _vm.deleteLayer
    }
  }, [_vm._v("\n                Delete this layer \n                "), _c('md-icon', [_vm._v("delete")])], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 647 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-whiteframe', {
    staticClass: "project-box"
  }, [_c('md-dialog-confirm', {
    ref: "deleteProjectDialog",
    attrs: {
      "md-title": _vm.confirm.title,
      "md-content-html": _vm.getConfirmContent(),
      "md-ok-text": _vm.confirm.ok,
      "md-cancel-text": _vm.confirm.cancel
    },
    on: {
      "close": _vm.deleteProjectConfirm
    }
  }), _vm._v(" "), _c('md-card', {
    staticClass: "project-box-content"
  }, [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s(_vm.project.title))]), _vm._v(" "), (_vm.owner) ? _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("Owner: " + _vm._s(_vm.owner.username))]) : _vm._e()]), _vm._v(" "), _c('md-card-content', [_c('div', {
    staticClass: "md-subtitle"
  }, [_vm._v("Last Updated")]), _vm._v(" "), _c('div', {
    staticClass: "md-caption"
  }, [_vm._v(_vm._s(_vm.lastChanged))])]), _vm._v(" "), _c('md-card-actions', [_c('router-link', {
    staticClass: "md-icon-button",
    attrs: {
      "tag": "md-button",
      "to": {
        name: 'project',
        params: {
          id: _vm.project.id
        }
      },
      "click": _vm.selectProject
    }
  }, [_c('md-icon', [_vm._v("mode_edit")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Edit Project")])], 1), _vm._v(" "), (_vm.user.uid === _vm.project.ownerUID) ? _c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.deleteProject
    }
  }, [_c('md-icon', [_vm._v("delete")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Delete Project")])], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 648 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', [_c('md-layout', {
    attrs: {
      "md-flex": "70"
    }
  }, [_c('md-toolbar', {
    staticClass: "md-transparent ql-dashboard-header"
  }, [_c('div', {
    staticClass: "dashboard-toggles"
  }, [_c('span', {
    staticClass: "dark-mode-toggle"
  }, [_c('md-switch', {
    attrs: {
      "id": "showMode",
      "name": "showMode"
    },
    on: {
      "change": _vm.toggleShowMode
    },
    model: {
      value: (_vm.localShowMode),
      callback: function($$v) {
        _vm.localShowMode = $$v
      },
      expression: "localShowMode"
    }
  }, [_vm._v("Dark Mode")])], 1)])])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-toolbar', {
    staticClass: "md-transparent ql-dashboard-header"
  }, [_c('span', {
    staticStyle: {
      "flex": "1"
    }
  }), _vm._v(" "), (_vm.isActivePay) ? _c('span', {
    staticClass: "ql-dashboard-role"
  }, [_vm._v("Collaborator")]) : _c('span', {
    staticClass: "ql-dashboard-role"
  }, [_vm._v("Observer")])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 649 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ql-admin"
    }
  }, [_c('md-toolbar', [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.toggleLeftSidenav
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('h2', [_vm._v("Cuelist Admin Dashboard")])], 1), _vm._v(" "), _c('core-nav-main', {
    attrs: {
      "project": _vm.project,
      "user": _vm.user
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user-list"
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25",
      "md-flex-offset": "5"
    }
  }, [_c('h2', [_vm._v("List of User Stripe IDs")])]), _vm._v(" "), _c('md-layout', {
    staticClass: "header",
    attrs: {
      "md-gutter": "8",
      "md-row": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-offset": "5"
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("Name")])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("Active Pay")])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("Stripe ID")])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.sortedUsers), function(usr) {
    return _c('md-layout', {
      key: usr.uid,
      attrs: {
        "md-gutter": "8",
        "md-row": ""
      }
    }, [_c('md-layout', {
      attrs: {
        "md-column": "",
        "md-flex": "30",
        "md-flex-offset": "5"
      }
    }, [_c('strong', [_vm._v(_vm._s(usr.username))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(usr.email))])]), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "15",
        "md-align": "center"
      }
    }, [_c('md-checkbox', {
      model: {
        value: (usr.active_pay),
        callback: function($$v) {
          _vm.$set(usr, "active_pay", $$v)
        },
        expression: "usr.active_pay"
      }
    })], 1), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "25"
      }
    }, [_c('md-input-container', [_c('md-input', {
      model: {
        value: (usr.stripe_id),
        callback: function($$v) {
          _vm.$set(usr, "stripe_id", $$v)
        },
        expression: "usr.stripe_id"
      }
    })], 1)], 1), _vm._v(" "), _c('md-button', {
      on: {
        "click": function($event) {
          _vm.updateUser(usr)
        }
      }
    }, [_vm._v("Update")])], 1)
  })], 2), _vm._v(" "), _c('core-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 650 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-sidenav', {
    ref: "revisionNav",
    staticClass: "md-left"
  }, [_c('md-toolbar', {
    staticClass: "md-dense main-toolbar"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('h3', {
    staticClass: "md-title"
  }, [_vm._v("Revisions")])], 1), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.version.version))]), _vm._v(" "), _c('revisions-list', {
    attrs: {
      "mutations": _vm.mutations
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 651 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', [_c('md-layout', {
    attrs: {
      "md-flex": "70"
    }
  }, [_c('md-toolbar', {
    staticClass: "md-transparent ql-project-header"
  }, [_c('div', {
    staticClass: "project-toggles"
  }, [_c('span', {
    staticClass: "dark-mode-toggle"
  }, [_c('md-switch', {
    attrs: {
      "id": "showMode",
      "name": "showMode"
    },
    on: {
      "change": _vm.toggleShowMode
    },
    model: {
      value: (_vm.localShowMode),
      callback: function($$v) {
        _vm.localShowMode = $$v
      },
      expression: "localShowMode"
    }
  }, [_vm._v("Dark Mode")])], 1), _vm._v(" "), (_vm.isOwner) ? _c('span', {
    staticClass: "project-lock-toggle"
  }, [_c('md-switch', {
    attrs: {
      "id": "locked",
      "name": "locked"
    },
    on: {
      "change": _vm.toggleLocked
    },
    model: {
      value: (_vm.localLocked),
      callback: function($$v) {
        _vm.localLocked = $$v
      },
      expression: "localLocked"
    }
  }, [_vm._v("Project Lock")])], 1) : _vm._e()]), _vm._v(" "), _c('project-pagination', {
    staticClass: "ql-project-header-pull-right",
    attrs: {
      "totalPages": _vm.totalPages,
      "currentPage": _vm.currentPage
    },
    on: {
      "pageUp": _vm.pageUp,
      "pageDown": _vm.pageDown,
      "setPage": _vm.setPage
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-toolbar', {
    staticClass: "md-transparent ql-project-header"
  }, [_c('span', {
    staticStyle: {
      "flex": "1"
    }
  }), _vm._v(" "), (_vm.isActivePay) ? _c('span', {
    staticClass: "ql-project-role"
  }, [_vm._v("Collaborator")]) : _c('span', {
    staticClass: "ql-project-role"
  }, [_vm._v("Observer")])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('core-header', {
    attrs: {
      "user": _vm.user
    }
  }), _vm._v(" "), _c('core-nav-main', {
    attrs: {
      "user": _vm.user
    }
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "account",
    attrs: {
      "md-row": "",
      "md-align": "center",
      "md-vertical-align": "center"
    }
  }, [_c('md-layout', {
    staticClass: "layout-separator",
    attrs: {
      "md-flex": "100"
    }
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "account-subscription-status",
    attrs: {
      "md-flex": "100",
      "md-align": "center"
    }
  }, [(_vm.user.active_pay) ? _c('div', [_c('span', [_vm._v("Subscription Status: "), _c('strong', [_vm._v("Collaborator")])])]) : _c('div', [_c('span', [_vm._v("Subscription Status: "), _c('strong', [_vm._v("Observer")])]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised",
    on: {
      "click": _vm.upgradeSubscription
    }
  }, [_vm._v("Upgrade")])], 1)]), _vm._v(" "), _c('md-layout', {
    staticClass: "layout-separator",
    attrs: {
      "md-flex": "100"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "60"
    }
  }, [_c('md-avatar', {
    staticClass: "md-xxlarge"
  }, [(_vm.user.profile_picture) ? _c('img', {
    attrs: {
      "src": _vm.user.profile_picture,
      "alt": "People"
    },
    on: {
      "click": _vm.openDialog
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__(49),
      "alt": "People"
    },
    on: {
      "click": _vm.openDialog
    }
  }), _vm._v(" "), (_vm.user.signInMethod === 'email') ? _c('md-tooltip', {
    attrs: {
      "md-direction": "right",
      "md-delay": "500"
    }
  }, [_vm._v("Click to upload a new photo")]) : _c('md-tooltip', {
    attrs: {
      "md-direction": "right",
      "md-delay": "500"
    }
  }, [_vm._v("Update your user profile photo in your Google account settings.")])], 1), _vm._v(" "), _c('profile-photo', {
    ref: "imageUpload"
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "layout-separator",
    attrs: {
      "md-flex": "100"
    }
  }), _vm._v(" "), (_vm.editingName) ? _c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-offset": "35",
      "md-align": "center"
    }
  }, [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.saveName($event)
      }
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.new_username),
      callback: function($$v) {
        _vm.new_username = $$v
      },
      expression: "new_username"
    }
  })], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised",
    on: {
      "click": _vm.cancelEditingName
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": _vm.saveName
    }
  }, [_vm._v("Save")])], 1)]) : _c('md-layout', {
    attrs: {
      "md-flex": "100",
      "md-align": "center"
    }
  }, [_c('div', {
    staticClass: "md-headline ql-user-name",
    on: {
      "click": _vm.editName
    }
  }, [_vm._v(_vm._s(_vm.user.username))]), _vm._v(" "), (_vm.user.signInMethod === 'email') ? _c('md-tooltip', [_vm._v("click to change")]) : _c('md-tooltip', [_vm._v("Update your user name in your Google account settings.")])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "layout-separator",
    attrs: {
      "md-flex": "100"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-offset": "35",
      "md-align": "center"
    }
  }, [(_vm.user.signInMethod === 'email') ? _c('change-password') : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "layout-separator",
    attrs: {
      "md-flex": "100"
    }
  })], 1), _vm._v(" "), _c('core-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 653 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('vue-draggable-resizable', {
    staticClass: "ql-selection-cue-marker",
    style: ({
      borderColor: _vm.cueColor(_vm.cue)
    }),
    attrs: {
      "x": _vm.cuePosLeft,
      "y": _vm.cuePosTop,
      "w": _vm.cue.width || 20,
      "h": _vm.cue.height || 20,
      "minw": 10,
      "minh": 10,
      "parent": true,
      "draggable": _vm.editable && !_vm.locked,
      "resizable": _vm.editable && !_vm.locked
    },
    on: {
      "dragging": _vm.onDrag,
      "dragstop": _vm.onDragStop,
      "resizestop": _vm.onResize,
      "activated": _vm.onActivate,
      "deactivated": _vm.onDeactivate
    }
  }, [(!_vm.locked && _vm.editable) ? _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("Move or Resize")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 654 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-dialog', {
    ref: "upload",
    attrs: {
      "md-open-from": "#upload",
      "md-close-to": "#upload"
    }
  }, [_c('md-dialog-title', [_vm._v("Profile Photo Upload")]), _vm._v(" "), _c('md-dialog-content', [_c('form', {
    attrs: {
      "enctype": "multipart/form-data",
      "novalidate": ""
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Profile Picture")]), _vm._v(" "), _c('md-file', {
    attrs: {
      "accept": "image/*"
    },
    on: {
      "selected": function($event) {
        _vm.onFileUpload($event)
      }
    }
  })], 1)], 1)]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.closeDialog('upload')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.upload()
      }
    }
  }, [_vm._v("Upload")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-container",
    attrs: {
      "id": "ql-forgot-screen"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-vertical-align": "center"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-offset": "35",
      "md-align": "center"
    }
  }, [_c('h1', [_c('img', {
    attrs: {
      "src": __webpack_require__(100),
      "alt": "LOGO"
    }
  })])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "100",
      "md-align": "center"
    }
  }, [(!_vm.sent) ? _c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-offset": "35",
      "md-align": "center"
    }
  }, [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('p', [_vm._v("Please enter your email address to request a password reset.")]), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.emailError()
    }
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), (_vm.emailError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "forgot-wrapper"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("RESET PASSWORD")]), _vm._v(" "), _c('md-button', {
    staticClass: "btn-troubleshoot",
    on: {
      "click": _vm.back
    }
  }, [_vm._v("Back to Login")])], 1)], 1)]) : _c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-offset": "35",
      "md-align": "center"
    }
  }, [_c('p', [_vm._v("We just sent you and email to reset your password! Redirecting...")])])], 1)], 1), _vm._v(" "), _c('core-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-container",
    attrs: {
      "id": "ql-login-screen"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-vertical-align": "center"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-offset": "35",
      "md-align": "center"
    }
  }, [_c('h1', [_c('img', {
    attrs: {
      "src": __webpack_require__(100),
      "alt": "LOGO"
    }
  })])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "100",
      "md-align": "center"
    }
  }, [(_vm.signingIn) ? _c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": _vm.login
    }
  }, [_c('md-icon', [_vm._v("person")]), _vm._v(" Sign in with Google")], 1) : _c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": _vm.login
    }
  }, [_c('md-icon', [_vm._v("person")]), _vm._v(" Register with Google")], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-offset": "35",
      "md-align": "center"
    }
  }, [_c('h1', {
    staticClass: "md-body-1"
  }, [_vm._v("Or")]), _vm._v(" "), (_vm.signingIn) ? _c('md-layout', {
    attrs: {
      "md-flex": "100",
      "md-align": "center"
    }
  }, [_c('h1', {
    staticClass: "md-title"
  }, [_vm._v("Sign in with your email")]), _vm._v(" "), _c('login-form'), _vm._v(" "), _c('md-button', {
    on: {
      "click": _vm.toggleRegister
    }
  }, [_vm._v("Need to Register instead?")])], 1) : _c('md-layout', {
    attrs: {
      "md-flex": "100",
      "md-align": "center"
    }
  }, [_c('h1', {
    staticClass: "md-title"
  }, [_vm._v("Register with your email")]), _vm._v(" "), _c('register-form', {
    on: {
      "success": _vm.createUser
    }
  }), _vm._v(" "), _c('md-button', {
    on: {
      "click": _vm.toggleRegister
    }
  }, [_vm._v("Need to Sign In instead?")])], 1)], 1)], 1), _vm._v(" "), _c('core-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 657 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page",
    staticStyle: {
      "visibility": "hidden"
    },
    attrs: {
      "data-loaded": "false",
      "id": _vm.pageContainerId,
      "data-page-number": "pageNumber"
    },
    on: {
      "mousedown": _vm.mouseDown,
      "mouseup": _vm.mouseUp,
      "contextmenu": function($event) {
        _vm.preventContext($event)
      }
    }
  }, [_c('div', {
    staticClass: "canvasWrapper"
  }, [_c('canvas', {
    attrs: {
      "id": ("page" + _vm.pageNumber),
      "height": _vm.pageHeight,
      "width": _vm.pageWidth
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "textLayer"
  })])
},staticRenderFns: []}

/***/ }),
/* 658 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.register($event)
      }
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("First Name")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.newUser.firstName),
      callback: function($$v) {
        _vm.$set(_vm.newUser, "firstName", $$v)
      },
      expression: "newUser.firstName"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Last Name")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.newUser.lastName),
      callback: function($$v) {
        _vm.$set(_vm.newUser, "lastName", $$v)
      },
      expression: "newUser.lastName"
    }
  })], 1), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.emailError()
    }
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "email",
      "required": ""
    },
    model: {
      value: (_vm.newUser.email),
      callback: function($$v) {
        _vm.$set(_vm.newUser, "email", $$v)
      },
      expression: "newUser.email"
    }
  }), _vm._v(" "), (_vm.emailError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()], 1), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.passwordError()
    }
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.newUser.password),
      callback: function($$v) {
        _vm.$set(_vm.newUser, "password", $$v)
      },
      expression: "newUser.password"
    }
  }), _vm._v(" "), (_vm.passwordError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()], 1), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.confirmPasswordError()
    }
  }, [_c('label', [_vm._v("Confirm Password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.newUser.confirmPassword),
      callback: function($$v) {
        _vm.$set(_vm.newUser, "confirmPassword", $$v)
      },
      expression: "newUser.confirmPassword"
    }
  }), _vm._v(" "), (_vm.confirmPasswordError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("Passwords do not match")]) : _vm._e()], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": _vm.register
    }
  }, [_c('md-icon', [_vm._v("person")]), _vm._v(" Register")], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 659 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ql-app"
    }
  }, [_c('core-header', {
    attrs: {
      "project": _vm.project,
      "user": _vm.user,
      "locked": _vm.isLocked
    }
  }), _vm._v(" "), _c('core-nav-main', {
    attrs: {
      "project": _vm.project,
      "user": _vm.user
    }
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "sub-header",
    attrs: {
      "md-flex": "100",
      "md-row": "",
      "md-gutter": "12"
    }
  }, [_c('project-header', {
    attrs: {
      "currentPage": _vm.currentPage,
      "totalPages": _vm.totalPages,
      "locked": _vm.isLocked,
      "showMode": _vm.showMode,
      "isOwner": _vm.user.uid === _vm.project.ownerUID,
      "isActivePay": _vm.user.active_pay
    },
    on: {
      "pageUp": _vm.pageUp,
      "pageDown": _vm.pageDown,
      "setPage": _vm.setCurrentPage,
      "toggleShowMode": _vm.toggleShowMode,
      "toggleLocked": _vm.toggleLocked
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "page-viewer"
  }, [_c('project-pages', {
    attrs: {
      "pages": _vm.projectPages,
      "currentPage": _vm.currentPage,
      "currentUser": _vm.user,
      "locked": _vm.isLocked,
      "showMode": _vm.showMode
    }
  })], 1), _vm._v(" "), _c('core-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 660 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    staticClass: "ql-pages-container",
    attrs: {
      "md-flex": "100",
      "md-column": ""
    }
  }, [_c('md-layout', {
    staticClass: "ql-page-layout",
    attrs: {
      "md-row": "",
      "md-gutter": "12"
    }
  }, [(_vm.pageReady) ? _c('svg', {
    staticClass: "ql-page-graphics",
    style: ({
      height: (_vm.svgTrueHeight + "px")
    }),
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "version": "1.1",
      "height": _vm.svgTrueHeight
    }
  }, _vm._l((_vm.positionedCues), function(cue) {
    return _c('line', {
      attrs: {
        "x1": cue.offsetX + cue.width,
        "y1": _vm.cuePosTop(cue),
        "x2": _vm.svgOffsetEnd,
        "y2": cue.offsetY,
        "stroke": _vm.cueColor(cue),
        "stroke-width": "1"
      }
    })
  })) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "70"
    }
  }, _vm._l((_vm.pages), function(page, index) {
    return (_vm.current(index + 1)) ? _c('project-page', {
      key: index,
      attrs: {
        "page": page,
        "cues": _vm.visibleCues(index + 1),
        "layers": _vm.visibleLayers,
        "currentLayer": _vm.currentLayer,
        "locked": _vm.locked,
        "showMode": _vm.showMode
      },
      on: {
        "pageLoaded": _vm.pageLoaded,
        "addedCue": _vm.addedCue,
        "deletedCue": _vm.deletedCue,
        "updatedCue": _vm.updatedCue
      }
    }) : _vm._e()
  })), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('project-cue-list', {
    attrs: {
      "cues": _vm.positionedCues,
      "layers": _vm.visibleLayers,
      "locked": _vm.locked,
      "openCues": _vm.openCues
    },
    on: {
      "openCue": _vm.openCue,
      "closeCue": _vm.closeCue,
      "destroy": _vm.deletedCue,
      "updatedCue": _vm.updatedCue
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 661 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-list-item', [_c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.collaborator.name))])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.collaborator.role))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.collaborator.email))])]), _vm._v(" "), (_vm.editable) ? _c('md-list-expand', [_c('md-button', {
    on: {
      "click": _vm.removeCollaborator
    }
  }, [_c('md-icon', [_vm._v("delete")]), _vm._v("\r\n            Remove\r\n        ")], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 662 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-sidenav', {
    ref: "printNav",
    staticClass: "md-left"
  }, [_c('md-toolbar', {
    staticClass: "md-dense main-toolbar"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('h3', {
    staticClass: "md-title"
  }, [_vm._v("Print Settings")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "90",
      "md-flex-offset": "5"
    }
  }, [_c('p', [_vm._v("Print Options coming soon")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 663 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-dialog', {
    ref: "createProj",
    attrs: {
      "md-open-from": "#createProj",
      "md-close-to": "#createProj"
    },
    on: {
      "open": _vm.fixContent,
      "close": _vm.startOver
    }
  }, [(_vm.user.active_pay) ? _c('md-stepper', {
    ref: "stepper",
    on: {
      "completed": _vm.closeDialog
    }
  }, [_c('md-step', {
    attrs: {
      "md-button-continue": "CREATE",
      "md-label": "CREATE",
      "md-editable": ""
    }
  }, [_c('create', {
    attrs: {
      "project": _vm.project
    }
  })], 1), _vm._v(" "), _c('md-step', {
    attrs: {
      "md-label": "COLLABORATORS"
    }
  }, [_c('collaborators', {
    attrs: {
      "project": _vm.project
    }
  })], 1), _vm._v(" "), _c('md-step', {
    attrs: {
      "md-label": "LAYERS"
    }
  }, [_c('layers', {
    attrs: {
      "project": _vm.project
    }
  })], 1)], 1) : _c('div', [_c('md-dialog-title', [_vm._v("Unable to create project")]), _vm._v(" "), _c('md-dialog-content', [_vm._v("Free users are not able to create projects.")]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Ok")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 664 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    staticClass: "ql-cue-list",
    attrs: {
      "md-column": ""
    }
  }, [(!_vm.cues.length) ? _c('p', {
    staticClass: "md-body-2"
  }, [_vm._v("You haven't created any cues on this page. Select text or right click on the document to add a cue.")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.cues), function(cue) {
    return _c('project-cues-cue', {
      key: cue.id,
      attrs: {
        "cue": cue,
        "open": _vm.isOpen(cue),
        "layers": _vm.layers,
        "locked": _vm.locked
      },
      on: {
        "openCue": function($event) {
          _vm.openCue(cue)
        },
        "closeCue": function($event) {
          _vm.closeCue(cue)
        },
        "destroy": _vm.destroy,
        "updatedCue": _vm.updatedCue
      }
    })
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 665 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-list-item', [_c('md-layout', {
    attrs: {
      "md-row": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [(_vm.editable) ? _c('md-checkbox', {
    on: {
      "change": _vm.changeEdit
    },
    model: {
      value: (_vm.layerPerms),
      callback: function($$v) {
        _vm.layerPerms = $$v
      },
      expression: "layerPerms"
    }
  }) : _c('md-checkbox', {
    attrs: {
      "disabled": ""
    },
    on: {
      "change": _vm.changeEdit
    },
    model: {
      value: (_vm.layerPerms),
      callback: function($$v) {
        _vm.layerPerms = $$v
      },
      expression: "layerPerms"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "md-body-1"
  }, [_vm._v(_vm._s(_vm.layer.title))])], 1)
},staticRenderFns: []}

/***/ }),
/* 666 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('core-header', {
    attrs: {
      "user": _vm.user
    }
  }), _vm._v(" "), _c('core-nav-main', {
    attrs: {
      "user": _vm.user
    }
  }), _vm._v(" "), _c('dashboard-header', {
    attrs: {
      "showMode": _vm.showMode,
      "isActivePay": _vm.user.active_pay
    },
    on: {
      "toggleShowMode": _vm.toggleShowMode
    }
  }), _vm._v(" "), (_vm.ready) ? _c('div', {
    staticClass: "dashboard"
  }, [_c('div', {
    staticClass: "ql-dashboard-top"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.mostRecentProject || _vm.userPendingInvites.length > 0) ? _c('md-layout', {
    attrs: {
      "md-row": "",
      "md-flex": "60"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-align": "center",
      "md-row": ""
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-accent btn-start-project",
    on: {
      "click": function($event) {
        _vm.openCreateProject()
      }
    }
  }, [_vm._v("Start a New Project")])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "layout-separator",
    attrs: {
      "md-flex": "100"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "100",
      "md-row": "",
      "md-gutter": "16",
      "md-align": "center"
    }
  }, [(_vm.mostRecentProject) ? _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('dashboard-project-box', {
    attrs: {
      "project": _vm.mostRecentProject
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.mostRecentProject || _vm.userPendingInvites.length > 0) ? _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('dashboard-pending-projects', {
    attrs: {
      "projects": _vm.userPendingInvites,
      "user": _vm.user
    }
  })], 1) : _vm._e()], 1)], 1) : _c('md-layout', {
    attrs: {
      "md-row": "",
      "md-vertical-align": "center",
      "md-align": "center"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-align": "center",
      "md-row": ""
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-accent btn-start-project",
    on: {
      "click": function($event) {
        _vm.openCreateProject()
      }
    }
  }, [_vm._v("Start your first Project")])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "layout-separator",
    attrs: {
      "md-flex": "100"
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.displayProjects.length) ? _c('md-layout', {
    attrs: {
      "md-row": "",
      "md-flex": "40"
    }
  }, [_c('dashboard-project-grid', {
    attrs: {
      "projects": _vm.displayProjects
    }
  })], 1) : _vm._e()], 1) : _c('div', {
    staticClass: "dashboard"
  }, [_c('md-layout', {
    attrs: {
      "md-row": "",
      "md-flex": "100",
      "md-vertical-align": "center",
      "md-align": "center"
    }
  }, [_c('span', {
    staticClass: "md-subheader"
  }, [_vm._v("Loading your projects...")])])], 1), _vm._v(" "), _c('create-project', {
    ref: "createProject"
  }), _vm._v(" "), _c('core-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 667 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-list-item', [(_vm.isCurrentVersion(_vm.version.id)) ? _c('md-icon', [_vm._v("label")]) : _c('md-icon', [_vm._v("label_outline")]), _vm._v(" "), _c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_vm._v(_vm._s(_vm.version.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getFormattedDate(_vm.version)))]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "bottom"
    }
  }, [_vm._v(_vm._s(_vm.getFormattedDate(_vm.version)))])], 1), _vm._v(" "), ((_vm.user.uid === _vm.ownerUID || _vm.user.uid === _vm.version.creator) && _vm.user.active_pay) ? _c('md-button', {
    staticClass: "md-icon-button md-list-action",
    on: {
      "click": function($event) {
        _vm.deleteVersion(_vm.version.id)
      }
    }
  }, [_c('md-icon', [_vm._v("delete")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("Delete Version")])], 1) : _vm._e(), _vm._v(" "), (_vm.user.uid === _vm.ownerUID && _vm.user.active_pay) ? _c('md-button', {
    staticClass: "md-icon-button md-list-action",
    on: {
      "click": function($event) {
        _vm.promoteVersion(_vm.version.id)
      }
    }
  }, [_c('md-icon', [_vm._v("vertical_align_top")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("Make Live")])], 1) : _vm._e(), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button md-list-action",
    on: {
      "click": function($event) {
        _vm.setActiveVersion(_vm.version.id)
      }
    }
  }, [_c('md-icon', [_vm._v("launch")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("Show Version")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 668 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-dialog-content', [_c('p', [_vm._v("Collaborators")]), _vm._v(" "), _c('md-list', {
    staticClass: "md-double-line"
  }, [(_vm.owner) ? _c('md-list-item', [_c('md-avatar', [_c('img', {
    attrs: {
      "src": _vm.owner.profile_picture
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_vm._v(_vm._s(_vm.owner.username))]), _vm._v(" "), _c('span', [_vm._v("Project Owner")])])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.project.collaborators), function(collab) {
    return _c('collaborator', {
      key: collab.uid,
      attrs: {
        "user": _vm.userByUID(collab.uid),
        "collaborator": collab
      },
      on: {
        "removeCollaborator": _vm.removeCollaborator
      }
    })
  }), _vm._v(" "), _c('invite', {
    attrs: {
      "project": _vm.project
    },
    on: {
      "addCollaborator": _vm.addCollaborator
    }
  })], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 669 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.login($event)
      }
    }
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.emailError()
    }
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "email",
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), (_vm.emailError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errorMessage) + " "), (_vm.verifyError && !_vm.sent) ? _c('a', {
    staticClass: "send-verification-email",
    on: {
      "click": _vm.sendVerficationEmail
    }
  }, [_vm._v("Send Verification Email")]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.passwordError()
    }
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), (_vm.passwordError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "login-wrapper"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": _vm.login
    }
  }, [_c('md-icon', [_vm._v("mail")]), _vm._v(" Sign In")], 1), _vm._v(" "), _c('md-button', {
    staticClass: "btn-troubleshoot",
    on: {
      "click": _vm.forgot
    }
  }, [_vm._v("Forgot Password")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-list-item', [(_vm.collabUser) ? _c('md-avatar', [(_vm.collabUser.profile_picture) ? _c('img', {
    attrs: {
      "src": _vm.collabUser.profile_picture,
      "alt": "People"
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__(49),
      "alt": "People"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.collabUser) ? _c('div', {
    staticClass: "md-list-text-container collaborator-text-container"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.collabUser.username))])]), _vm._v(" "), (_vm.collaborator.role) ? _c('span', [_vm._v(_vm._s(_vm.collaborator.role))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.collabUser.email))])]) : _vm._e(), _vm._v(" "), _c('md-list-expand', [_c('md-layout', {
    staticClass: "heading-align",
    attrs: {
      "md-align": "center"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('h2', {
    staticClass: "md-title"
  }, [_vm._v("Layer Permissions")])])], 1), _vm._v(" "), _c('md-list', {
    staticClass: "sub-list"
  }, [_c('md-list-item', [_c('md-layout', {
    attrs: {
      "md-row": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Edit")])])], 1), _vm._v(" "), _c('span', [_vm._v("Layer Name")])], 1), _vm._v(" "), _c('md-list', {
    staticClass: "sub-list"
  }, _vm._l((_vm.layers), function(layer) {
    return _c('layer-permission', {
      key: layer.id,
      attrs: {
        "layer": layer,
        "editable": _vm.editable,
        "collaborator": _vm.collaborator
      }
    })
  }))], 1), _vm._v(" "), (_vm.user.uid === _vm.collaborator.uid || _vm.editable) ? _c('md-button', {
    on: {
      "click": _vm.removeCollaborator
    }
  }, [_c('md-icon', [_vm._v("delete")]), _vm._v("\r\n            Remove From Project\r\n        ")], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 671 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-list-item', {
    staticClass: "ql-layer-menu-item"
  }, [_c('md-icon', {
    staticClass: "ql-color-picker-choice",
    style: (_vm.style())
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.layer.title))]), _vm._v(" "), _c('md-button', {
    on: {
      "click": _vm.deleteLayer
    }
  }, [_c('md-icon', [_vm._v("delete")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 672 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-speed-dial', {
    staticClass: "ql-add-cue",
    attrs: {
      "md-open": "click",
      "md-direction": "bottom"
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button md-mini md-clean",
    attrs: {
      "md-fab-trigger": ""
    }
  }, [_c('md-icon', {
    attrs: {
      "md-icon-morph": ""
    }
  }, [_vm._v("close")]), _vm._v(" "), _c('md-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-fab md-primary md-mini",
    on: {
      "click": _vm.addCue
    }
  }, [_c('md-icon', [_vm._v("note_add")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("Add New Cue")])], 1), _vm._v(" "), (_vm.cueToAdd.type == 'position') ? _c('md-button', {
    staticClass: "md-fab md-primary md-mini",
    on: {
      "click": _vm.addText
    }
  }, [_c('md-icon', [_vm._v("text_fields")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("Add New Text")])], 1) : _vm._e(), _vm._v(" "), _c('md-button', {
    staticClass: "md-fab md-primary md-mini",
    on: {
      "click": _vm.cancel
    }
  }, [_c('md-icon', [_vm._v("clear")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("Cancel")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 673 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-list', {
    staticClass: "md-double-line",
    attrs: {
      "id": "ql-sidenav-layer-list"
    }
  }, [_c('md-dialog-confirm', {
    ref: "deleteLayerDialog",
    attrs: {
      "md-title": 'Confirm Layer Delete',
      "md-content-html": 'This layer contains cues. Are you sure you want to delete it?',
      "md-ok-text": 'Yes',
      "md-cancel-text": 'Cancel'
    },
    on: {
      "close": _vm.dialogClose
    }
  }), _vm._v(" "), _vm._l((_vm.layers), function(layer) {
    return _c('layer', {
      key: layer.id,
      attrs: {
        "layer": layer,
        "viewable": _vm.canView(layer),
        "editable": _vm.canEdit(layer),
        "showNotes": _vm.canShowNotes(layer),
        "project": _vm.project
      },
      on: {
        "updateLayer": _vm.updateLayer,
        "deleteLayer": _vm.tryDeleteLayer,
        "showLayer": _vm.showLayer,
        "hideLayer": _vm.hideLayer
      }
    })
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 674 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    staticClass: "ql-project-search",
    attrs: {
      "md-row": ""
    }
  })
},staticRenderFns: []}

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-container"
  }, [(_vm.ready) ? _c('md-layout', {
    attrs: {
      "md-vertical-align": "center"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-offset": "35",
      "md-align": "center"
    }
  }, [_c('h1', [_c('img', {
    attrs: {
      "src": __webpack_require__(100),
      "alt": "LOGO"
    }
  })])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "100",
      "md-align": "center"
    }
  }, [_c('h1', {
    staticClass: "md-headline"
  }, [_vm._v("Collaborate on "), _c('strong', [_vm._v(_vm._s(_vm.project.title))])])]), _vm._v(" "), (_vm.validCollab) ? _c('md-layout', {
    attrs: {
      "md-flex": "100",
      "md-align": "center"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100",
      "md-align": "center"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": _vm.accept
    }
  }, [_c('md-icon', [_vm._v("person")]), _vm._v(" Accept Invite")], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.validCollab) ? _c('md-layout', {
    attrs: {
      "md-flex": "100",
      "md-align": "center"
    }
  }, [_c('h2', {
    staticClass: "md-title"
  }, [_vm._v("You have not been invited to this project.")])]) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 676 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-whiteframe', {
    staticClass: "project-box"
  }, [_c('md-card', {
    staticClass: "project-box-content"
  }, [_c('md-card-header', [_c('h1', {
    staticClass: "md-title"
  }, [_vm._v("Pending Project Invites")])]), _vm._v(" "), _c('md-card-content', _vm._l((_vm.projects), function(project) {
    return _c('md-layout', {
      key: project.id,
      staticClass: "project-box-container md-row",
      attrs: {
        "md-flex": "25"
      }
    }, [_c('h1', {
      staticClass: "md-subheader pending-subheader"
    }, [_vm._v(_vm._s(project.title))]), _vm._v(" "), _c('md-button', {
      staticClass: "md-mini md-fab pending-action-button",
      on: {
        "click": function($event) {
          _vm.accept(project)
        }
      }
    }, [_c('md-icon', [_vm._v("person_add")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Join Project")])], 1), _vm._v(" "), _c('md-button', {
      staticClass: "md-mini md-fab pending-action-button",
      on: {
        "click": function($event) {
          _vm.decline(project)
        }
      }
    }, [_c('md-icon', [_vm._v("delete")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Cancel Invite")])], 1)], 1)
  }))], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-sidenav', {
    ref: "collaboratorsNav",
    staticClass: "md-left collaboratorsNav"
  }, [_c('md-toolbar', {
    staticClass: "md-dense main-toolbar"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('h3', {
    staticClass: "md-title"
  }, [_vm._v("Collaborators")])], 1), _vm._v(" "), _c('md-list', {
    staticClass: "md-double-line"
  }, [_c('md-subheader', [_vm._v("Current Collaborators")]), _vm._v(" "), (_vm.owner) ? _c('md-list-item', [_c('md-avatar', [(_vm.owner.profile_picture) ? _c('img', {
    attrs: {
      "src": _vm.owner.profile_picture,
      "alt": "People"
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__(49),
      "alt": "People"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "md-list-text-container collaborator-text-container"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.owner.username))])]), _vm._v(" "), _c('span', [_vm._v("Project Owner")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.owner.email))])])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.collaborators), function(collab) {
    return _c('collaborator', {
      key: collab.id,
      attrs: {
        "user": _vm.user,
        "collabUser": _vm.userByUID(collab.uid),
        "collaborator": collab,
        "editable": _vm.user.uid === _vm.owner.uid,
        "layers": _vm.layers
      },
      on: {
        "removeCollaborator": _vm.removeCollaborator
      }
    })
  })], 2), _vm._v(" "), _c('md-list', {
    staticClass: "md-double-line pendingCollaboratorList"
  }, [_c('md-subheader', [_vm._v("Pending Collaborators")]), _vm._v(" "), _vm._l((_vm.pendingCollaborators), function(collab) {
    return _c('pendingCollaborator', {
      key: collab.id,
      attrs: {
        "collaborator": collab,
        "editable": _vm.user.uid === _vm.owner.uid
      },
      on: {
        "removePendingCollaborator": _vm.removePendingCollaborator
      }
    })
  })], 2), _vm._v(" "), _c('md-list', [(_vm.canEdit) ? _c('invite', {
    attrs: {
      "project": _vm.project
    },
    on: {
      "addCollaborator": _vm.addCollaborator
    }
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-toolbar', {
    staticClass: "main-toolbar"
  }, [(_vm.project) ? _c('div', {
    staticClass: "md-toolbar-container"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.toggleLeftSidenav
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('h2', {
    staticClass: "md-title"
  }, [_c('span', [_vm._v(_vm._s(_vm.project.title))]), _vm._v(" "), (_vm.currentVersion) ? _c('span', {
    staticClass: "project-version"
  }, [_vm._v(_vm._s(_vm.currentVersion.name))]) : _c('span', {
    staticClass: "project-version-live"
  }, [_vm._v("Live Edit")]), _vm._v(" "), (_vm.locked) ? _c('md-icon', [_vm._v("lock")]) : _vm._e(), _vm._v(" "), (_vm.locked) ? _c('md-tooltip', [_vm._v("This version is locked")]) : _vm._e()], 1), _vm._v(" "), _c('img', {
    staticClass: "main-header-logo",
    attrs: {
      "src": __webpack_require__(294),
      "alt": "cuelisttext"
    }
  }), _vm._v(" "), _c('project-search')], 1) : _c('div', {
    staticClass: "md-toolbar-container"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.toggleLeftSidenav
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('div', {
    staticClass: "md-title"
  }, [_c('md-avatar', {
    staticClass: "md-small"
  }, [(_vm.user.profile_picture) ? _c('img', {
    attrs: {
      "src": _vm.user.profile_picture,
      "alt": "People"
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__(49),
      "alt": "People"
    }
  })]), _vm._v(" "), (_vm.user.username) ? _c('span', {
    staticClass: "avatar-name-role"
  }, [_vm._v(_vm._s(_vm.user.username))]) : _c('span', {
    staticClass: "avatar-name-role"
  }, [_vm._v("Cuelist User")])], 1), _vm._v(" "), _c('img', {
    staticClass: "main-header-logo",
    attrs: {
      "src": __webpack_require__(579),
      "alt": "cuelisttext"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 679 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('md-card', {
    staticClass: "ql-cue",
    style: (_vm.style()),
    attrs: {
      "id": _vm.cue.id
    }
  }, [_c('project-cues-cue-header', {
    attrs: {
      "expanded": _vm.expanded,
      "cue": _vm.cue,
      "layer": _vm.layer,
      "layers": _vm.editableLayers,
      "locked": _vm.locked,
      "editable": _vm.editable,
      "color": _vm.color
    },
    on: {
      "toggle": _vm.toggle,
      "cueUpdated": _vm.updatedCue
    }
  }), _vm._v(" "), _c('project-cues-cue-body', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.expanded),
      expression: "expanded"
    }],
    attrs: {
      "cue": _vm.cue,
      "locked": _vm.locked,
      "editable": _vm.editable,
      "color": _vm.color
    },
    on: {
      "cueUpdated": _vm.updatedCue,
      "destroy": _vm.destroy
    }
  })], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 680 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-dialog-content', [_c('p', [_vm._v("Create Your Starting Layers")]), _vm._v(" "), _c('md-list', _vm._l((_vm.project.layers), function(layer) {
    return _c('layer-lite', {
      key: layer.id,
      attrs: {
        "layer": layer
      },
      on: {
        "deleteLayer": _vm.deleteLayer
      }
    })
  })), _vm._v(" "), _c('layer-new', {
    attrs: {
      "project": _vm.project
    },
    on: {
      "addLayer": _vm.addLayer
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 681 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-button', {
    staticClass: "md-icon-button md-raised",
    attrs: {
      "disabled": !_vm.canPageDown
    },
    on: {
      "click": _vm.pageDown
    }
  }, [_c('md-icon', [_vm._v("keyboard_arrow_left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-number-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.page),
      expression: "page"
    }],
    staticClass: "current-page-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.page)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.page = $event.target.value
      }
    }
  }), _vm._v("\r\n        /" + _vm._s(_vm.totalPages) + "\r\n    ")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button md-raised",
    attrs: {
      "disabled": !_vm.canPageUp
    },
    on: {
      "click": _vm.pageUp
    }
  }, [_c('md-icon', [_vm._v("keyboard_arrow_right")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 682 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('vue-draggable-resizable', {
    staticClass: "ql-note",
    class: {
      'note-editing': _vm.editing, 'disable-text': _vm.disableText
    },
    attrs: {
      "id": _vm.note.id,
      "x": _vm.notePosLeft,
      "y": _vm.notePosTop,
      "w": _vm.note.width,
      "h": _vm.note.height,
      "minw": 40,
      "minh": 40,
      "handles": ['br'],
      "active": _vm.editing,
      "parent": true,
      "draggable": !_vm.locked,
      "resizable": !_vm.locked,
      "drag-handle": ".drag"
    },
    on: {
      "dragging": _vm.onDrag,
      "dragstop": _vm.onDragStop,
      "resizestop": _vm.onResize,
      "activated": _vm.onActivate,
      "deactivated": _vm.onDeactivate
    }
  }, [_c('md-dialog', {
    ref: "text-edit-dialog",
    attrs: {
      "md-open-from": ("#" + (_vm.note.id)),
      "md-close-to": ("#" + (_vm.note.id))
    }
  }, [_c('md-dialog-title', [_vm._v("Edit Note")]), _vm._v(" "), _c('md-dialog-content', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note.text),
      expression: "note.text"
    }],
    staticClass: "note-input",
    attrs: {
      "placeholder": "Enter Text"
    },
    domProps: {
      "value": (_vm.note.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.note, "text", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "layer-picker-container"
  }, [_c('layer-picker', {
    attrs: {
      "currentLayer": _vm.layerByID(_vm.note.layer),
      "layers": _vm.validLayers,
      "editable": !_vm.locked,
      "locked": _vm.locked
    },
    on: {
      "selectLayer": _vm.selectLayer
    }
  }), _vm._v(" "), _c('span', [_vm._v("Select Note Layer")])], 1)]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Done")])], 1)], 1), _vm._v(" "), _c('span', {
    ref: "note-text",
    staticClass: "note-text",
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("\n            " + _vm._s(_vm.noteText) + "\n        ")]), _vm._v(" "), (_vm.editing && !_vm.locked) ? _c('div', {
    staticClass: "button-container"
  }, [_c('span', {
    staticClass: "edit-button drag md-mini"
  }, [_c('md-icon', [_vm._v("zoom_out_map")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Move")])], 1), _vm._v(" "), _c('span', {
    staticClass: "edit-button md-mini",
    on: {
      "click": _vm.open
    }
  }, [_c('md-icon', [_vm._v("edit")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Edit")])], 1), _vm._v(" "), _c('span', {
    staticClass: "edit-button md-mini",
    on: {
      "click": _vm.remove
    }
  }, [_c('md-icon', [_vm._v("clear")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Delete")])], 1)]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 683 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-card-content', {
    staticClass: "ql-cue-body"
  }, [_c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editing),
      expression: "editing"
    }],
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.submit($event)
      },
      "keyup": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.keyPress($event)
      }
    }
  }, [_c('md-input-container', [_c('md-textarea', {
    model: {
      value: (_vm.cue.description),
      callback: function($$v) {
        _vm.$set(_vm.cue, "description", $$v)
      },
      expression: "cue.description"
    }
  })], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": _vm.done
    }
  }, [_vm._v("Done")])], 1), _vm._v(" "), (_vm.editable) ? _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editing),
      expression: "!editing"
    }],
    staticClass: "cue-description",
    on: {
      "click": _vm.edit
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cue.description),
      expression: "cue.description"
    }]
  }, [_vm._v(_vm._s(_vm.cue.description))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cue.description),
      expression: "!cue.description "
    }]
  }, [_vm._v("Click to enter text")]), _vm._v(" "), (_vm.editable) ? _c('md-tooltip', {
    attrs: {
      "md-direction": "bottom"
    }
  }, [_vm._v("Click Text to Edit")]) : _vm._e()], 1) : _c('p', {
    staticClass: "cue-description"
  }, [_c('span', [_vm._v(_vm._s(_vm.cue.description))])]), _vm._v(" "), (!_vm.locked && !_vm.editing && _vm.editable) ? _c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.destroy
    }
  }, [_c('md-icon', [_vm._v("delete")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Delete Cue")])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 684 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ql-cue-layer-picker"
  }, [(_vm.locked || !_vm.editable) ? _c('div', {
    staticClass: "ql-button-container"
  }, [_c('md-button', {
    staticClass: "ql-cue-layer-picker",
    style: ({
      backgroundColor: _vm.currentLayer.color
    })
  })], 1) : _c('md-menu', {
    ref: "layerMenu",
    attrs: {
      "md-size": "4"
    }
  }, [_c('md-button', {
    staticClass: "ql-cue-layer-picker",
    style: ({
      backgroundColor: _vm.currentLayer.color
    }),
    attrs: {
      "md-menu-trigger": ""
    }
  }, [_c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("Click to change layer")])], 1), _vm._v(" "), _c('md-menu-content', _vm._l((_vm.layers), function(layer) {
    return _c('md-menu-item', {
      key: layer.id,
      on: {
        "selected": function($event) {
          _vm.selectLayer(layer.id)
        }
      }
    }, [_c('span', {
      staticClass: "ql-cue-layer-picker",
      style: (_vm.style(layer))
    }), _vm._v(" "), _c('span', {
      staticClass: "ql-cue-layer-picker-option"
    }, [_vm._v(_vm._s(layer.title))])])
  }))], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 685 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 686 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "ql-new-layer-form",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.addLayer($event)
      }
    }
  }, [_c('h2', {
    staticClass: "md-title"
  }, [_vm._v("Add a New Layer")]), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Layer Title")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.newLayerTitle),
      callback: function($$v) {
        _vm.newLayerTitle = $$v
      },
      expression: "newLayerTitle"
    }
  })], 1), _vm._v(" "), _c('color-picker', {
    staticClass: "ql-color-picker",
    on: {
      "input": _vm.pickColor
    },
    model: {
      value: (_vm.colors),
      callback: function($$v) {
        _vm.colors = $$v
      },
      expression: "colors"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": _vm.addLayer
    }
  }, [_vm._v("Add Layer")])], 1)
},staticRenderFns: []}

/***/ }),
/* 687 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 693 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 694 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 695 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 696 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[389]);


// WEBPACK FOOTER //
// static/js/app.552092ead84b2897f670.js